
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bRTjQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3pfAb = parcelRequire("3pfAb");


var $kDuN4 = parcelRequire("kDuN4");


var $3jwuS = parcelRequire("3jwuS");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $2SowE = parcelRequire("2SowE");

const $4c66dfa08a03eed2$var$handleOnProseMirrorRendered = (onProseMirrorRendered, eventAttributes)=>{
    if (onProseMirrorRendered && typeof onProseMirrorRendered === 'function') {
        const clientRouteStart = performance.getEntriesByName('browser-metric.start').pop()?.startTime;
        const proseMirrorRenderedTimestamp = (0, $2SowE.getProseMirrorFMPTimestamp)(eventAttributes?.startTime, eventAttributes?.duration);
        const proseMirrorRenderedFMP = typeof clientRouteStart !== 'undefined' && typeof proseMirrorRenderedTimestamp !== 'undefined' ? Math.round(proseMirrorRenderedTimestamp - clientRouteStart) : proseMirrorRenderedTimestamp;
        onProseMirrorRendered({
            ...eventAttributes,
            proseMirrorRenderedFMP: proseMirrorRenderedFMP,
            proseMirrorRenderedTimestamp: proseMirrorRenderedTimestamp
        });
    }
};
const $4c66dfa08a03eed2$export$2d1d97ac8c5e1e6f = (props)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { edition: edition, environment: environment } = (0, $bQm3c.useSessionData)() || {};
    // setting default to development so in tests it doesn't fail due to being undefined
    const safeEnvironment = environment || 'DEVELOPMENT';
    const { contentId: contentId, contentType: contentType, children: children, source: source, collabService: collabService, onProseMirrorRendered: onProseMirrorRendered, isGuest: isGuest, touchpointId: touchpointId } = props;
    const handleEvent = (0, $42omo.useCallback)((event)=>{
        const instanceName = safeEnvironment;
        if (event?.payload?.action === 'proseMirrorRendered') $4c66dfa08a03eed2$var$handleOnProseMirrorRendered(onProseMirrorRendered, event?.payload?.attributes);
        event.update((payload)=>{
            const isCommentEvent = payload.attributes && payload.attributes.appearance === 'comment';
            // WS-3190 If this is a comment event use the existing objectId as it correlates to the commentId
            let newPayload = (0, $2SowE.extendPayloadAttributes)(payload, {
                objectId: isCommentEvent ? payload.attributes.objectId : contentId,
                editorSource: source
            });
            if (instanceName) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                instance: instanceName
            });
            newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                collabService: collabService ?? 'none',
                isLivePage: isLivePage,
                edition: edition,
                spaceId: spaceId
            });
            if (isGuest !== undefined) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                isGuest: isGuest
            });
            if (touchpointId) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                touchpointId: touchpointId
            });
            newPayload.source = source || 'unknown';
            if (event.context) {
                const attributesFromContext = (0, $2SowE.extractAttributesFromContext)(event.context);
                newPayload.attributes = {
                    ...newPayload.attributes,
                    ...attributesFromContext
                };
            }
            return newPayload;
        });
    }, [
        contentId,
        source,
        collabService,
        onProseMirrorRendered,
        edition,
        safeEnvironment,
        isLivePage,
        spaceId,
        isGuest,
        touchpointId
    ]);
    const handleFabricElementsEvents = (0, $42omo.useCallback)((event)=>{
        event.update((payload)=>{
            return (0, $2SowE.extendPayloadAttributes)(payload, {
                pageType: contentType,
                editorSource: source,
                objectId: contentId,
                objectType: contentType,
                spaceId: spaceId,
                isLivePage: isLivePage
            });
        });
    }, [
        contentId,
        contentType,
        source,
        isLivePage,
        spaceId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: handleEvent,
        channel: (0, $3pfAb.FabricChannel).editor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: handleFabricElementsEvents,
        channel: (0, $3pfAb.FabricChannel).elements
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: handleFabricElementsEvents,
        channel: (0, $3pfAb.FabricChannel).media
    }, children)));
};
module.exports["EditorAnalyticsListener"] = $4c66dfa08a03eed2$export$2d1d97ac8c5e1e6f;

});

parcelRegister("2dIEg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $csex9 = parcelRequire("csex9");

const $f68cade398718716$export$67e1ff255b9f648f = ({ editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { FeedbackCollector: FeedbackCollector, openFeedbackCollector: openFeedbackCollector } = (0, $csex9.useEditorAIFeedbackCollector)();
    (0, $42omo.useEffect)(()=>{
        if (editorPluginAIFeedbackHandlers.current) editorPluginAIFeedbackHandlers.current.handleFeedbackClicked = openFeedbackCollector;
    }, [
        editorPluginAIFeedbackHandlers,
        cloudId,
        openFeedbackCollector
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FeedbackCollector, null);
};
module.exports["EditorPluginAIWithFeedback"] = $f68cade398718716$export$67e1ff255b9f648f;

});

parcelRegister("csex9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $2Nwuj = parcelRequire("2Nwuj");


var $7gpC4 = parcelRequire("7gpC4");


var $biiXa = parcelRequire("biiXa");


var $dh538 = parcelRequire("dh538");


var $7aRa9 = parcelRequire("7aRa9");


var $jLw6A = parcelRequire("jLw6A");


var $bQm3c = parcelRequire("bQm3c");

const $9006c850d364bf02$var$GAIE_ENTRYPOINT_ID = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $9006c850d364bf02$var$FEEDBACK_CONTEXT_ID = 'customfield_10047';
const $9006c850d364bf02$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $9006c850d364bf02$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $9006c850d364bf02$var$i18n = (0, $cgtv4.defineMessages)({
    feedbackTitle: {
        id: "editor-features.rovo-feedback-collector.title",
        defaultMessage: "Help us make Rovo even better"
    },
    flagTitle: {
        id: "editor-features.ai-feedback-collector.flag-title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "editor-features.ai-feedback-collector.flag-description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    },
    summaryPlaceholder: {
        id: "editor-features.ai-feedback-collector.summary-placeholder",
        defaultMessage: "Let us know what you were trying to do and how it could be better"
    },
    userConsentCheckboxLabel: {
        id: "editor-features.ai-feedback-collector.user-consent-checkbox-label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    canContactText: {
        id: "editor-features.ai-feedback-collector.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "editor-features.ai-feedback-collector.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "editor-features.ai-feedback-collector.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "editor-features.ai-feedback-collector.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $9006c850d364bf02$var$PrivacyPolicyLink = ({ link: link })=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__page-experienc') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $9006c850d364bf02$var$i18n.privacyPolicyLink)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $9006c850d364bf02$var$i18n.privacyPolicyLink));
const $9006c850d364bf02$var$ResearchGroupLink = ({ link: link })=>(0, $dh538.fg)('dst-a11y__replace-anchor-with-link__page-experienc') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $9006c850d364bf02$var$i18n.researchGroupLink)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $9006c850d364bf02$var$i18n.researchGroupLink));
const $9006c850d364bf02$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$9006c850d364bf02$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9006c850d364bf02$var$PrivacyPolicyLink, {
                link: $9006c850d364bf02$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $9006c850d364bf02$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$9006c850d364bf02$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9006c850d364bf02$var$ResearchGroupLink, {
                link: $9006c850d364bf02$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $9006c850d364bf02$var$buildAdditionalFields = ({ feedbackContext: feedbackContext, hasUserConsent: hasUserConsent })=>{
    if (!feedbackContext) return undefined;
    const aiExperience = feedbackContext.getAIExperience?.(hasUserConsent) || {};
    let feedbackMetadataStringified = `sentiment: ${feedbackContext.sentiment}\n`;
    Object.entries({
        ...aiExperience,
        ...feedbackContext.editorAttributes
    }).forEach((item)=>{
        feedbackMetadataStringified += `${item[0]}: ${item[1]}\n`;
    });
    return [
        {
            id: $9006c850d364bf02$var$FEEDBACK_CONTEXT_ID,
            value: feedbackMetadataStringified
        }
    ];
};
const $9006c850d364bf02$var$EditorAIFeedbackCollectorComponent = ({ flags: flags, feedbackTitle: feedbackTitle, feedbackContext: feedbackContext, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { userIdForAnalytics: userIdForAnalytics, displayName: displayName } = (0, $bQm3c.useSessionData)();
    const { loading: loading, error: error, restrictions: restrictions } = (0, $jLw6A.usePageRestrictionsContext)();
    const [hasUserConsent, setHasUserConsent] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        /**
     * Once the check for page restrictions is no longer loading and has no errors,
     * set the user content value based on the levels of restrictions for the page.
     */ if (loading || error || !restrictions) return;
        const isRestricted = restrictions.hasRestrictions || restrictions.hasViewRestrictions || restrictions.hasInheritedRestrictions;
        return setHasUserConsent(!isRestricted);
    }, [
        loading,
        error,
        restrictions
    ]);
    const handleHasUserConsent = (0, $42omo.useCallback)(()=>{
        setHasUserConsent((current)=>!current);
    }, []);
    const { showFlag: showFlag } = flags;
    const displayFlag = ()=>{
        showFlag({
            type: 'success-circle',
            title: formatMessage($9006c850d364bf02$var$i18n.flagTitle),
            description: formatMessage($9006c850d364bf02$var$i18n.flagDescription)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biiXa.default), {
        name: displayName ?? undefined,
        atlassianAccountId: userIdForAnalytics ?? undefined,
        onClose: onClose,
        onSubmit: displayFlag,
        customContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
            label: formatMessage($9006c850d364bf02$var$i18n.userConsentCheckboxLabel),
            onChange: handleHasUserConsent,
            isChecked: hasUserConsent
        }),
        entrypointId: $9006c850d364bf02$var$GAIE_ENTRYPOINT_ID,
        showTypeField: false,
        feedbackTitle: feedbackTitle || formatMessage($9006c850d364bf02$var$i18n.feedbackTitle),
        anonymousFeedback: false,
        summaryPlaceholder: formatMessage($9006c850d364bf02$var$i18n.summaryPlaceholder),
        canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9006c850d364bf02$var$CanContactLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9006c850d364bf02$var$EnrolLabel, null),
        additionalFields: $9006c850d364bf02$var$buildAdditionalFields({
            feedbackContext: feedbackContext,
            hasUserConsent: hasUserConsent
        })
    });
};
const $9006c850d364bf02$var$EditorAIFeedbackCollectorWithFlags = (0, $7aRa9.withFlags)($9006c850d364bf02$var$EditorAIFeedbackCollectorComponent);
const $9006c850d364bf02$export$6ffb247c35565a98 = ()=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [feedbackContext, setFeedbackContext] = (0, $42omo.useState)();
    const onClose = (0, $42omo.useCallback)(()=>{
        setFeedbackContext(undefined);
        setIsOpen(false);
    }, []);
    const openFeedbackCollector = (0, $42omo.useCallback)((feedbackSubmissionArgs)=>{
        setFeedbackContext(feedbackSubmissionArgs);
        setIsOpen(true);
    }, []);
    const EditorAIFeedbackCollector = (0, $42omo.useCallback)(()=>isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9006c850d364bf02$var$EditorAIFeedbackCollectorWithFlags, {
            feedbackContext: feedbackContext,
            onClose: onClose
        }) : null, [
        isOpen,
        onClose,
        feedbackContext
    ]);
    return {
        FeedbackCollector: EditorAIFeedbackCollector,
        openFeedbackCollector: openFeedbackCollector
    };
};
module.exports["useEditorAIFeedbackCollector"] = $9006c850d364bf02$export$6ffb247c35565a98;

});

parcelRegister("f6GmT", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $44ba2156dd739cb9$export$54727fabeade699b = ()=>{
    const editorPluginAIFeedbackHandlers = (0, $42omo.useRef)({
        handleFeedbackClicked: ()=>{},
        handleReviewStateEntered: ()=>{},
        handleExperienceEnded: ()=>{}
    });
    return {
        editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers
    };
};
module.exports["useEditorPluginAIFeedbackHandlers"] = $44ba2156dd739cb9$export$54727fabeade699b;

});

parcelRegister("bK3oZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $7aRa9 = parcelRequire("7aRa9");





var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $e4JJO = parcelRequire("e4JJO");


var $16lEl = parcelRequire("16lEl");

var $kIvLT = parcelRequire("kIvLT");





var $fFa3V = parcelRequire("fFa3V");


var $dh538 = parcelRequire("dh538");





var $fD5Hh = parcelRequire("fD5Hh");


var $6VfGD = parcelRequire("6VfGD");


var $4B9iQ = parcelRequire("4B9iQ");




function $2a68fac7c12ea4ef$export$bef1f36f5486a6a3(message, ...args) {
    try {
        if (window.top?.__aifcDebuggerEnabled__) // eslint-disable-next-line no-console
        console.log(`[editor-rovo-bridge]: ${message}`, ...args);
    } catch (e) {
    // Ignore cross origin frame access errors
    }
}


class $350fe12d8db447f2$export$54019a4b43471d88 {
    updateProps(props) {
        this.props = props;
    }
    deregister() {
    // do nothing
    }
    /**
   * Creates a new command handler instance.
   *
   * @param props - Pass-through props containing callbacks and utilities
   *                    needed for command execution and streaming operations
   */ constructor(props){
        /**
     * Properties passed through from the command manager containing callbacks
     * and utility functions for interacting with the editor and streaming system.
     */ this.props = void 0;
        this.props = props;
    }
}


class $105efb57326a211f$export$3a9b6d9d6180d66 extends (0, $350fe12d8db447f2$export$54019a4b43471d88) {
    execute() {
        (0, $2a68fac7c12ea4ef$export$bef1f36f5486a6a3)('handle rovo-stream-aborted-command');
        try {
            this.onAbort();
        } catch  {
        // TODO: EDITOR-123 - report this error
        }
    }
    constructor(props, onAbort){
        super(props), this.onAbort = onAbort;
    }
}










/** Timeout duration in milliseconds for streaming operations (10 seconds) */ const $dc0b802a9b7b02c4$var$TIMEOUT_MS = 10000;
class $dc0b802a9b7b02c4$export$1673b811578d4e4e extends (0, $350fe12d8db447f2$export$54019a4b43471d88) {
    /**
   * Clears any existing inactivity timeout.
   * This stops the timeout from firing if it hasn't already,
   * preventing unwanted aborts of active streams.
   */ clearInactivityTimeout() {
        if (this.timeout !== null) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    }
    /**
   * Starts or restarts the inactivity timeout for the current stream.
   * If no stream activity occurs within the timeout period (10 seconds),
   * the stream will be automatically aborted and cleaned up.
   *
   * This helps prevent hanging streams and resource leaks when
   * the Rovo bridge stops sending data unexpectedly.
   */ startInactivityTimeout() {
        this.clearInactivityTimeout();
        // Set new timeout for 10 seconds
        this.timeout = setTimeout(()=>{
            // abort when timeout occurs
            this.handleAbort();
            this.props.onStreamTimeout?.({
                streamType: this.streamType
            });
        }, $dc0b802a9b7b02c4$var$TIMEOUT_MS);
    }
    /**
   * Main entry point for processing streaming commands.
   * Manages the complete lifecycle of a streaming operation including:
   * - Timeout management and state tracking
   * - Stream start notifications for first-time streams
   * - Processing individual stream chunks
   * - Stream completion and cleanup
   * - Error handling and recovery
   *
   * @param payload - Command payload containing stream data and completion status
   * @throws Will catch and forward any errors to the error callback
   */ async execute(payload) {
        try {
            // Reset timeout on each chunk to prevent premature timeouts
            this.startInactivityTimeout();
            // Initialize streaming state and notify listeners on first chunk
            if (!this.isStreaming) {
                this.isStreaming = true;
                this.isStreamFinished = false;
                this.finalAdf = undefined;
                this.props.onStreamStart?.({
                    streamType: this.streamType,
                    payload: payload
                });
            }
            // Process the current stream chunk
            await this.process(payload);
            this.props.onStream?.({
                streamType: this.streamType,
                payload: payload
            });
            // Handle stream completion - finalize processing and run cleanup
            if (payload.isStreamComplete) {
                this.clearInactivityTimeout();
                await this.finish();
                this.isStreaming = false;
                this.props.onStreamEnd?.({
                    streamType: this.streamType,
                    payload: payload,
                    adfDoc: this.finalAdf
                });
            }
        } catch (error) {
            this.props.onStreamError?.({
                error: error,
                streamType: this.streamType,
                traceId: typeof payload.traceId === 'string' ? payload.traceId : undefined
            });
            this.handleAbort();
        }
    }
    /**
   * Finalizes the streaming operation.
   * Uses a flag to ensure finishAction is only called once during the stream lifecycle.
   * Automatically triggers image re-uploading for supported stream types.
   */ async finish() {
        if (this.isStreamFinished) return;
        this.isStreamFinished = true;
        this.finalAdf = await this.finishAction();
        // Trigger image re-uploading if we have a document and handler
        if (this.finalAdf && this.props.reuploadImages) {
            if ((0, $dh538.fg)('confluence_frontend_aifc_reupload_image')) await this.props.reuploadImages();
            else if (this.streamType !== 'update') await this.props.reuploadImages(this.finalAdf);
        }
    }
    handleAbort() {
        (0, $2a68fac7c12ea4ef$export$bef1f36f5486a6a3)(`handle abort ${this.streamType} streaming command handler`);
        this.isStreaming = false;
        this.isStreamFinished = false;
        this.finalAdf = undefined;
        this.clearInactivityTimeout();
        this.abort();
    }
    deregister() {
        (0, $2a68fac7c12ea4ef$export$bef1f36f5486a6a3)(`deregister ${this.streamType} streaming command handler`);
        this.isStreaming = false;
        this.isStreamFinished = false;
        this.finalAdf = undefined;
        this.clearInactivityTimeout();
    }
    /**
   * Creates a new streaming command handler instance.
   *
   * @param props - Pass-through props containing callbacks and utilities
   * @param streamType - The type of stream this handler manages (create, update, etc.)
   */ constructor(props, streamType){
        super(props), this.streamType = streamType;
        /** Flag tracking whether a streaming operation is currently active */ this.isStreaming = false;
        /** Handle for the inactivity timeout, null when no timeout is active */ this.timeout = null;
        /** Flag indicating whether finish has been called for this stream */ this.isStreamFinished = false;
        this.finalAdf = void 0;
    }
}


class $b6cae06f30b7714b$export$53d8e34277e6a8ab extends (0, $dc0b802a9b7b02c4$export$1673b811578d4e4e) {
    process(payload) {
        if (!payload.data.adf) return;
        if (!this.createCommandProcessor.isInitialized() && payload.data.previousAccumulatedData) {
            // The scenario where the command processor is not initialized but the payload contains
            // accumulated ADF can happen if the user closes and reopens the modal during streaming.
            // To handle this, we first clear the document (in case it first streamed for long enough
            // to trigger a draft sync) and then stream in the accumulated ADF so that streaming
            // subsequent chunks can continue correctly.
            this.props.editorAPI.core.actions.replaceDocument('', {
                addToHistory: false,
                scrollIntoView: false
            });
            this.createCommandProcessor.stream(payload.data.previousAccumulatedData, false, typeof payload.traceId === 'string' ? payload.traceId : undefined);
        }
        if (!payload.isStreamComplete) this.createCommandProcessor.stream(payload.data.adf, this.isStreamFinished, typeof payload.traceId === 'string' ? payload.traceId : undefined);
    }
    async finishAction() {
        const adfDoc = await this.createCommandProcessor.finish({
            onError: this.props.onStreamError,
            onRepair: this.props.onStreamRepair
        });
        if (adfDoc) {
            this.props.editorAPI.core.actions.replaceDocument(adfDoc, {
                addToHistory: false,
                scrollIntoView: false
            });
            if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) // Ensure all expands are open
            this.props.editorAPI.core.actions.execute(this.props.editorAPI.expand?.commands.toggleExpandRange());
        }
        return adfDoc;
    }
    abort() {
        this.createCommandProcessor.abort();
    }
    constructor(props, createCommandProcessor){
        super(props, 'create'), this.createCommandProcessor = createCommandProcessor;
    }
}






const $cf77c58dc62f4e8e$export$f65ca476c09acec0 = (editorApi)=>{
    return new Promise((resolve)=>{
        try {
            editorApi.core.actions.requestDocument((doc)=>{
                resolve(doc);
            }, {
                alwaysFire: true
            });
        } catch  {
            resolve(undefined);
        }
    });
};
function $cf77c58dc62f4e8e$export$2da47a16c0b6bcb(doc) {
    if (!doc.content || doc.content.length === 0) return true;
    if (doc.content.length === 1) {
        const node = doc.content[0];
        if (node.type === 'paragraph') {
            if (!node.content || node.content.length === 0) return true;
            return $cf77c58dc62f4e8e$var$isOnlyWhitespaceContent(node.content);
        }
        if (node.type === 'heading') {
            if (!node.content || node.content.length === 0) return true;
            return $cf77c58dc62f4e8e$var$isOnlyWhitespaceContent(node.content);
        }
    }
    return false;
}
function $cf77c58dc62f4e8e$var$isOnlyWhitespaceContent(content) {
    for (const node of content){
        if (node.type === 'text') {
            if (node.text && node.text.trim().length > 0) return false;
        } else return false;
    }
    return true;
}
function $cf77c58dc62f4e8e$export$276c2a3f5f3dea14(str, size) {
    const numChunks = Math.ceil(str.length / size);
    const chunks = new Array(numChunks);
    for(let i = 0, o = 0; i < numChunks; ++i, o += size)chunks[i] = str.substring(o, o + size);
    return chunks;
}



const $9d8d447fe2d64b32$export$41ff530af06c946f = async ({ props: props, doc: doc, selectionFragment: selectionFragment, selectionLocalIds: selectionLocalIds, selectionMarkdown: selectionMarkdown })=>{
    let additionalContextFromProps = props.additionalContext || {
        isViewMode: false
    };
    if (typeof additionalContextFromProps === 'function') {
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) try {
            additionalContextFromProps = await additionalContextFromProps();
        // eslint-disable-next-line no-unused-vars
        } catch (err) {
            additionalContextFromProps = {};
        }
        else additionalContextFromProps = await additionalContextFromProps();
    }
    const { isViewMode: isViewMode = false, ...additionalContext } = additionalContextFromProps || {};
    return {
        contentId: props.contentId,
        contentType: props.contentType,
        pageBody: doc,
        selectionFragment: selectionFragment,
        selectionLocalIds: selectionLocalIds,
        selectionMarkdown: selectionMarkdown,
        isViewMode: isViewMode,
        useGenericEditorSkill: props.useGenericEditorSkill,
        additionalContext: Object.keys(additionalContext).length > 0 ? additionalContext : undefined
    };
};
class $9d8d447fe2d64b32$export$ada55596c5cc2d41 extends (0, $350fe12d8db447f2$export$54019a4b43471d88) {
    async execute() {
        const defaultResult = await $9d8d447fe2d64b32$export$41ff530af06c946f({
            props: this.props,
            doc: undefined,
            selectionFragment: '',
            selectionLocalIds: '',
            selectionMarkdown: ''
        });
        try {
            const doc = (0, $dh538.fg)('platform_editor_aifc_rovo_bridge_partial_doc') ? this.props.editorAPI?.aiExperience?.actions.getPartialDocumentFromSelection() : (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? await this.props.editorAPI.core.actions.requestDocumentAsync() : await (0, $cf77c58dc62f4e8e$export$f65ca476c09acec0)(this.props.editorAPI);
            if (!doc) // TODO: EDITOR-123 - report this error
            return defaultResult;
            const selection = this.props.editorAPI.aiExperience?.actions.getAISelectionContext();
            const content = await $9d8d447fe2d64b32$export$41ff530af06c946f({
                props: this.props,
                doc: doc,
                selectionFragment: selection?.selectionFragment ? JSON.stringify(selection.selectionFragment) : '',
                selectionLocalIds: selection?.localIds ? JSON.stringify(selection.localIds) : '',
                selectionMarkdown: selection?.selectionMarkdown ?? ''
            });
            (0, $2a68fac7c12ea4ef$export$bef1f36f5486a6a3)('handle read-content-command result', {
                additionalContext: this.props.additionalContext,
                doc: doc,
                selection: selection,
                content: content
            });
            return content ?? defaultResult;
        } catch  {
            // TODO: EDITOR-123 - report this error
            return defaultResult;
        }
    }
}



class $b4644247c7dc40b4$export$c246e3e964a757d2 extends (0, $350fe12d8db447f2$export$54019a4b43471d88) {
    execute() {
    // Intentional no-op for stream complete. This handler is used to prevent
    // red herring errors in the console when such commands are received.
    }
}




class $dab8eb7e4b62bd25$export$9e34a8a16b80af23 extends (0, $dc0b802a9b7b02c4$export$1673b811578d4e4e) {
    async process(payload) {
        await this.updateCommandProcessor.streamChunk(payload.data.toolCalls, payload.isStreamComplete, payload.traceId);
    }
    async finishAction() {
        await this.updateCommandProcessor.finish();
        return undefined;
    }
    abort() {
        this.updateCommandProcessor.abort();
    }
    constructor(props, updateCommandProcessor){
        super(props, 'update'), this.updateCommandProcessor = updateCommandProcessor;
    }
}





class $9627c9b25c29aea2$export$947fa7da412978d0 {
    getPosition() {
        return this.position;
    }
    reset(input, position = 0) {
        this.input = input;
        this.position = position;
        this.lastTokenType = null;
    }
    isWhitespace(char) {
        return [
            ' ',
            '\n',
            '\t',
            '\r'
        ].includes(char);
    }
    isExpectingKey() {
        return this.lastTokenType === 'LEFT_BRACE' || this.lastTokenType === 'COMMA';
    }
    isDigit(char) {
        return char >= '0' && char <= '9';
    }
    isAlpha(char) {
        return char >= 'a' && char <= 'z' || char >= 'A' && char <= 'Z';
    }
    isHexDigit(char) {
        return char >= '0' && char <= '9' || char >= 'a' && char <= 'f' || char >= 'A' && char <= 'F';
    }
    peek() {
        return this.position < this.input.length ? this.input[this.position] || '\0' : '\0';
    }
    advance() {
        if (this.position < this.input.length) return this.input[this.position++] || '\0';
        return '\0';
    }
    skipWhitespace() {
        while(this.position < this.input.length && this.isWhitespace(this.peek()))this.advance();
    }
    /**
   * Check if a quote is actually closing the string by looking at what follows
   * A closing quote should be followed by: comma, right brace, right bracket, or colon
   * (with optional whitespace in between)
   */ isClosingQuote(position) {
        let i = position + 1; // Skip the quote itself
        // Skip whitespace
        while(i < this.input.length && this.isWhitespace(this.input[i] || ''))i++;
        // Check if followed by valid JSON delimiters or structural characters
        if (i < this.input.length) {
            const nextChar = this.input[i];
            return $9627c9b25c29aea2$export$947fa7da412978d0.CLOSING_DELIMITERS.has(nextChar || '');
        }
        // At EOF, consider it closing
        return true;
    }
    readString() {
        const start = this.position;
        this.advance(); // consume opening quote
        let value = '';
        let hasUnescapedQuotes = false;
        while(this.position < this.input.length){
            if (this.peek() === '\\') {
                this.advance(); // consume backslash
                const escaped = this.advance();
                switch(escaped){
                    case '"':
                        value += '"';
                        break;
                    case '\\':
                        value += '\\';
                        break;
                    case '/':
                        value += '/';
                        break;
                    case 'b':
                        value += '\b';
                        break;
                    case 'f':
                        value += '\f';
                        break;
                    case 'n':
                        value += '\n';
                        break;
                    case 'r':
                        value += '\r';
                        break;
                    case 't':
                        value += '\t';
                        break;
                    case 'u':
                        {
                            // Read hex digits (keep raw if incomplete for streaming)
                            let hex = '';
                            for(let i = 0; i < 4; i++){
                                const ch = this.peek();
                                if (this.isHexDigit(ch)) hex += this.advance();
                                else break;
                            }
                            if (hex.length < 4) {
                                value += '\\u' + hex;
                                break;
                            }
                            const codeUnit = parseInt(hex, 16);
                            // Handle surrogate pairs: \uD8xx\uDCxx
                            if (codeUnit >= 0xd800 && codeUnit <= 0xdbff) {
                                // Lookahead for low-surrogate
                                if (this.position + 6 <= this.input.length && this.input[this.position] === '\\' && this.input[this.position + 1] === 'u') {
                                    const lowHex = this.input.substring(this.position + 2, this.position + 6);
                                    // eslint-disable-next-line require-unicode-regexp
                                    if (/^[0-9a-fA-F]{4}$/.test(lowHex)) {
                                        const low = parseInt(lowHex, 16);
                                        if (low >= 0xdc00 && low <= 0xdfff) {
                                            // Valid surrogate pair, consume and combine
                                            this.advance(); // backslash
                                            this.advance(); // 'u'
                                            for(let i = 0; i < 4; i++)this.advance();
                                            // eslint-disable-next-line no-bitwise
                                            const codePoint = (codeUnit - 0xd800 << 10) + (low - 0xdc00) + 0x10000;
                                            value += String.fromCodePoint(codePoint);
                                            break;
                                        }
                                    }
                                }
                                // No valid low surrogate; emit high surrogate code unit as-is
                                value += String.fromCharCode(codeUnit);
                            } else if (codeUnit >= 0xdc00 && codeUnit <= 0xdfff) // Lone low surrogate; emit as-is
                            value += String.fromCharCode(codeUnit);
                            else value += String.fromCharCode(codeUnit);
                            break;
                        }
                    default:
                        value += escaped;
                        break;
                }
            } else if (this.peek() === '"') {
                // For object keys, always treat quote as closing (strict parsing for missing colon detection)
                // For values, check if it's a real closing quote or unescaped quote inside
                if (!this.lenientStringParsing || this.isExpectingKey() || this.isClosingQuote(this.position)) break;
                else {
                    // Unescaped quote inside a value string - treat as literal character
                    value += this.advance();
                    hasUnescapedQuotes = true;
                }
            } else value += this.advance();
        }
        // Handle EOF mid-string for streaming (return partial, more data may come)
        if (this.peek() === '"') this.advance(); // consume closing quote
        // Report repair if we found unescaped quotes
        if (hasUnescapedQuotes) this.onRepair?.({
            type: 'infer',
            from: 'unescaped_quote',
            to: 'escaped_quote',
            context: 'tokenizer_string'
        });
        return {
            type: 'STRING',
            value: value,
            position: start
        };
    }
    readNumber() {
        const start = this.position;
        let value = '';
        // Handle negative sign
        if (this.peek() === '-') value += this.advance();
        // Handle integer part
        if (this.peek() === '0') value += this.advance();
        else if (this.isDigit(this.peek())) while(this.isDigit(this.peek()))value += this.advance();
        else throw new Error(`Invalid number at position ${this.position}`);
        // Handle decimal part
        if (this.peek() === '.') {
            value += this.advance();
            if (!this.isDigit(this.peek())) throw new Error(`Invalid number at position ${this.position}`);
            while(this.isDigit(this.peek()))value += this.advance();
        }
        // Handle exponent
        if (this.peek() === 'e' || this.peek() === 'E') {
            value += this.advance();
            if (this.peek() === '+' || this.peek() === '-') value += this.advance();
            if (!this.isDigit(this.peek())) throw new Error(`Invalid number at position ${this.position}`);
            while(this.isDigit(this.peek()))value += this.advance();
        }
        return {
            type: 'NUMBER',
            value: value,
            position: start
        };
    }
    readLiteral() {
        const start = this.position;
        let value = '';
        while(this.position < this.input.length && this.isAlpha(this.peek()))value += this.advance();
        // Complete partial literals at EOF for streaming (t→true, f→false, n→null)
        const atEOF = this.position >= this.input.length;
        if (atEOF && value.length > 0 && value.length < 5) {
            const originalValue = value;
            if ('true'.startsWith(value)) value = 'true';
            else if ('false'.startsWith(value)) value = 'false';
            else if ('null'.startsWith(value)) value = 'null';
            if (originalValue !== value) this.onRepair?.({
                type: 'infer',
                from: originalValue,
                to: value,
                context: 'tokenizer_partial_literal'
            });
        }
        // Handle JSON literals
        if (value === 'true' || value === 'false') return {
            type: 'BOOLEAN',
            value: value === 'true' ? 'true' : 'false',
            position: start
        };
        if (value === 'null') return {
            type: 'NULL',
            value: 'null',
            position: start
        };
        // Check for misplaced quote after identifier: content"  :
        // Skip the quote if it's followed by whitespace and a colon
        if (this.peek() === '"') {
            const quotePos = this.position;
            this.advance(); // Skip the quote
            this.skipWhitespace();
            if (this.peek() === ':') // This was a misplaced quote, we've successfully skipped it
            this.onRepair?.({
                type: 'skip',
                from: 'misplaced_quote',
                to: '-',
                context: 'tokenizer_key'
            });
            else // Not a misplaced quote pattern, restore position
            this.position = quotePos;
        }
        // Treat any other unquoted identifier as a string value (lenient parsing)
        // This handles cases like: {"key": world} → {"key": "world"}
        this.onRepair?.({
            type: 'infer',
            from: value,
            to: `"${value}"`,
            context: 'tokenizer_unquoted_string'
        });
        return {
            type: 'STRING',
            value: value,
            position: start
        };
    }
    createSingleCharToken(type, value) {
        const position = this.position;
        this.advance();
        return {
            type: type,
            value: value,
            position: position
        };
    }
    nextToken() {
        this.skipWhitespace();
        if (this.position >= this.input.length) {
            const token = {
                type: 'EOF',
                value: '',
                position: this.position
            };
            this.lastTokenType = token.type;
            return token;
        }
        const char = this.peek();
        let token;
        switch(char){
            case '{':
                token = this.createSingleCharToken('LEFT_BRACE', '{');
                break;
            case '}':
                token = this.createSingleCharToken('RIGHT_BRACE', '}');
                break;
            case '[':
                token = this.createSingleCharToken('LEFT_BRACKET', '[');
                break;
            case ']':
                token = this.createSingleCharToken('RIGHT_BRACKET', ']');
                break;
            case ':':
                token = this.createSingleCharToken('COLON', ':');
                break;
            case ',':
                token = this.createSingleCharToken('COMMA', ',');
                break;
            case '"':
                token = this.readString();
                break;
            case '-':
            case '0':
            case '1':
            case '2':
            case '3':
            case '4':
            case '5':
            case '6':
            case '7':
            case '8':
            case '9':
                token = this.readNumber();
                break;
            default:
                if (this.isAlpha(char)) token = this.readLiteral();
                else throw new Error(`Unexpected character '${char}' at position ${this.position}`);
        }
        this.lastTokenType = token.type;
        return token;
    }
    // eslint-disable-next-line no-useless-constructor
    constructor(input, onRepair, lenientStringParsing = false){
        this.input = input;
        this.onRepair = onRepair;
        this.lenientStringParsing = lenientStringParsing;
        this.position = 0;
        this.lastTokenType = null;
    }
}
// Characters that indicate a quote should close the string
// Includes standard delimiters and structural chars (for malformed JSON with missing braces)
$9627c9b25c29aea2$export$947fa7da412978d0.CLOSING_DELIMITERS = new Set([
    ',',
    '}',
    ']',
    ':',
    '{',
    '['
]);


class $686b256ab99abbdf$export$f692212e574bcc60 {
    getRepairs() {
        return this.repairs;
    }
    /**
   * Process a new chunk of JSON data and return the current partial/complete document.
   * Use this for incremental parsing as data arrives (e.g., from LLM streaming).
   *
   * The parser gracefully handles incomplete JSON by completing open structures.
   * Each call returns a valid ADF document that can be rendered immediately.
   *
   * Note: Once isLastChunk=true is signaled, you must create a new parser instance
   * to parse another document. Use parse() for multiple documents.
   *
   * @param chunk - New JSON data to append
   * @param isLastChunk - If true, signals this is the final chunk (no more data coming)
   * @returns The current document (partial or complete)
   * @throws Error if called after isLastChunk=true was previously signaled
   */ processChunk(chunk, isLastChunk = false) {
        // Prevent reusing after explicit completion signal
        if (this.lastChunkReceived) throw new Error("Cannot call processChunk() after isLastChunk=true was signaled. Create a new AdfParser instance or use parse() for multiple documents.");
        // Accumulate the chunk
        this.accumulatedInput += chunk;
        // Reset parser state for fresh parse (preserve nodeHandles for cross-chunk tracking)
        this.resetParserState(this.accumulatedInput, false);
        this.tokenizer.reset(this.accumulatedInput, 0);
        this.currentToken = this.tokenizer.nextToken();
        // Parse what we have so far - expect() handles EOF gracefully
        const doc = this.parseDocument();
        // Check if parsing is complete
        if (isLastChunk) {
            this.parseComplete = true;
            this.lastChunkReceived = true;
        } else this.parseComplete = this.currentToken.type === 'EOF' && !this.hitEofDuringExpect;
        this.cachedDocument = doc;
        return doc;
    }
    /**
   * Get the partial document parsed so far (even if incomplete)
   * @returns The cached document or null if not yet parsed
   */ getPartialDocument() {
        return this.cachedDocument;
    }
    /**
   * Check if the document is complete
   * @returns True if all data has been received and parsed
   */ isComplete() {
        return this.parseComplete;
    }
    countNodesInTree(node) {
        let count = 1;
        if (Array.isArray(node.marks)) count += node.marks.length;
        if (Array.isArray(node.content)) for (const child of node.content)count += this.countNodesInTree(child);
        return count;
    }
    recordRepair(repair) {
        this.repairs.push(repair);
        this.callbacks.onRepair?.(repair);
    }
    updateNodeHandle(handle, updates) {
        if (handle && this.callbacks.onNodeUpdate) this.callbacks.onNodeUpdate(handle, updates);
    }
    addRepairedNode(repairedNode, content, originalNode, context) {
        if (Array.isArray(repairedNode) && repairedNode.length === 0) return;
        const originalNodeCount = this.countNodesInTree(originalNode);
        const repairedNodeCount = Array.isArray(repairedNode) ? repairedNode.reduce((sum, n)=>sum + this.countNodesInTree(n), 0) : this.countNodesInTree(repairedNode);
        const isUnwrap = Array.isArray(repairedNode);
        const expansion = repairedNodeCount - originalNodeCount;
        const repairedType = isUnwrap ? "\u274C" : repairedNode.type || "\u274C";
        // For unwrap: check if the original node is preserved in the array
        const nodePreserved = isUnwrap && Array.isArray(repairedNode) && repairedNode.length === 1 && repairedNode[0]?.type === originalNode.type;
        const repair = {
            type: isUnwrap ? 'unwrap' : 'wrap',
            from: originalNode.type,
            to: repairedType,
            context: context,
            expansion: expansion,
            nodePreserved: isUnwrap ? nodePreserved : undefined
        };
        this.recordRepair(repair);
        if (Array.isArray(repairedNode)) content.push(...repairedNode);
        else content.push(repairedNode);
    }
    tryAppendNodeToContent(parentType, node, content, isValidChild, options) {
        const topNodeType = options?.topNodeType || this.validator.getTopNodeType();
        // If node has no type, try to let repair strategy fix it
        if (!node?.type) {
            const repairedNode = this.repairStrategy.tryRepair(node, parentType, content);
            // Check if type was inferred (node mutated in place)
            if (node.type) this.recordRepair({
                type: 'infer',
                from: 'missing_type',
                to: node.type,
                context: `inferred_from_properties:${parentType || topNodeType}`
            });
            else if (repairedNode) {
                this.addRepairedNode(repairedNode, content, node, parentType || topNodeType);
                return;
            } else // Still no type after repair - skip it
            return;
        }
        // Handle empty text nodes (ProseMirror doesn't allow them)
        if (node.type === 'text' && (!node.text || node.text.length === 0)) {
            this.recordRepair({
                type: 'skip_empty_text',
                from: 'text',
                to: '-',
                context: parentType || topNodeType
            });
            // Also account for marks on the empty text node
            if (Array.isArray(node.marks)) {
                for (const mark of node.marks)if (mark.type) this.recordRepair({
                    type: 'skip_empty_text',
                    from: mark.type,
                    to: '-',
                    context: `${parentType || topNodeType}:text`
                });
            }
            return;
        }
        // Apply mutations to all nodes (fix timestamps, infer types, etc.)
        this.repairStrategy.applyNodeMutations(node);
        // Check validity first
        const isValid = isValidChild(node.type);
        const needsStructuralFix = this.repairStrategy.shouldAttemptStructuralFix(node, parentType);
        if (!isValid || needsStructuralFix) {
            // Delegate all repairs to the repair strategy
            const repairedNode = this.repairStrategy.tryRepair(node, parentType, content);
            if (repairedNode) {
                this.addRepairedNode(repairedNode, content, node, parentType || topNodeType);
                return;
            }
            this.recordRepair({
                type: 'skip',
                from: node.type,
                to: '-',
                context: parentType || topNodeType
            });
            return;
        }
        content.push(node);
    }
    advance() {
        this.currentToken = this.tokenizer.nextToken();
    }
    peekType(...types) {
        return types.includes(this.currentToken.type);
    }
    isStartOfStructure(type) {
        return type === 'LEFT_BRACE' || type === 'LEFT_BRACKET';
    }
    isPrimitiveToken(type) {
        return type === 'STRING' || type === 'NUMBER' || type === 'BOOLEAN' || type === 'NULL';
    }
    // Check if token type could start an object property value
    isObjectPropertyValueStart(type) {
        return(// Normal: "key": value
        type === 'COLON' || // Missing colon: "key" "value"
        this.isPrimitiveToken(type) || // Missing colon: "key" {...}
        this.isStartOfStructure(type));
    }
    isObjectStart() {
        if (this.currentToken.type !== 'STRING') return false;
        const savedPosition = this.tokenizer.getPosition();
        const savedToken = this.currentToken;
        const nextToken = this.tokenizer.nextToken();
        const isObject = this.isObjectPropertyValueStart(nextToken.type);
        this.tokenizer.reset(this.accumulatedInput, savedPosition);
        this.currentToken = savedToken;
        return isObject;
    }
    // Consume and advance if token type matches, otherwise return null
    consume(type) {
        if (this.currentToken.type === type) {
            const tok = this.currentToken;
            this.advance();
            return tok;
        }
        return null;
    }
    expectAndAdvance(tokenType) {
        this.expect(tokenType);
        if (this.currentToken.type === tokenType) this.advance();
    }
    getTryAppendOptions() {
        return {
            topNodeType: this.currentParentType || this.validator.getTopNodeType()
        };
    }
    // Execute fn within parent context scope, then restore previous parent
    withParentContext(parentType, fn) {
        const previousParent = this.currentParentType;
        this.currentParentType = parentType;
        try {
            return fn();
        } finally{
            this.currentParentType = previousParent;
        }
    }
    expectOptionalDelimiter(delimiter, context) {
        if (this.peekType(delimiter)) {
            this.advance();
            return true;
        } else if (this.peekType('STRING')) {
            this.recordRepair({
                type: 'skip',
                from: `missing_${delimiter}`,
                to: 'inferred',
                context: context
            });
            return false;
        } else if (this.peekType('EOF')) {
            this.expect(delimiter);
            return false;
        } else if (this.peekType('LEFT_BRACE') && delimiter === 'LEFT_BRACKET') return false;
        else throw new Error(`Expected ${delimiter} or STRING, got ${this.currentToken.type} at position ${this.currentToken.position}`);
    }
    expect(tokenType) {
        if (this.currentToken.type !== tokenType) {
            if (this.currentToken.type === 'EOF') {
                this.hitEofDuringExpect = true;
                this.recordRepair({
                    type: 'skip',
                    from: `expected_${tokenType}`,
                    to: 'EOF',
                    context: 'streaming'
                });
                return;
            } else throw new Error(`Expected ${tokenType}, got ${this.currentToken.type} at position ${this.currentToken.position}`);
        }
    }
    parsePrimitiveValue() {
        if (this.currentToken.type === 'STRING') {
            const value = this.currentToken.value;
            this.advance();
            return value;
        } else if (this.currentToken.type === 'NUMBER') {
            const value = Number(this.currentToken.value);
            this.advance();
            return value;
        } else if (this.currentToken.type === 'BOOLEAN') {
            const value = this.currentToken.value === 'true';
            this.advance();
            return value;
        } else if (this.currentToken.type === 'NULL') {
            this.advance();
            return null;
        } else {
            this.skipValue();
            return undefined;
        }
    }
    parseObjectProperties(handler, context = 'object') {
        const hasOpeningBrace = this.expectOptionalDelimiter('LEFT_BRACE', context);
        if (!hasOpeningBrace && this.peekType('EOF')) return;
        const processedKeys = new Set();
        while(!this.peekType('RIGHT_BRACE') && !this.peekType('EOF')){
            // Handle dangling `]` - likely means the object is missing its closing `}`
            // and the `]` belongs to a parent array. Auto-close the object.
            if (this.config.autoCloseObjectOnRightBracket && this.peekType('RIGHT_BRACKET')) {
                this.recordRepair({
                    type: 'infer',
                    from: 'missing_closing_brace_on_object',
                    to: 'inferred',
                    context: context
                });
                // Don't consume the `]` - let the parent array handle it
                return;
            }
            if (!this.peekType('STRING')) {
                this.skipValue();
                continue;
            }
            const keyToken = this.consume('STRING');
            const key = keyToken?.value;
            if (this.consume('COMMA')) {
                this.recordRepair({
                    type: 'skip',
                    from: `key_${key}`,
                    to: '-',
                    context: context
                });
                continue;
            }
            if (this.consume('COLON')) ;
            else if (this.peekType('EOF')) continue;
            else this.recordRepair({
                type: 'skip',
                from: 'missing_colon',
                to: 'inferred',
                context: `${context}.${key}`
            });
            if (processedKeys.has(key)) this.recordRepair({
                type: 'duplicate_key',
                from: key,
                to: 'overwritten',
                context: context
            });
            processedKeys.add(key);
            handler(key);
            // If the handler caused a container break (e.g. content array ended early due to invalid child),
            // we should stop parsing this object so the parent can handle the invalid child.
            if (this.skipContainer) {
                this.skipContainer = false;
                if (this.peekType('LEFT_BRACE')) return;
            }
            this.consume('COMMA');
        }
        this.expect('RIGHT_BRACE');
        this.consume('RIGHT_BRACE');
    }
    skipValue() {
        switch(this.currentToken.type){
            case 'STRING':
            case 'NUMBER':
            case 'BOOLEAN':
            case 'NULL':
                this.advance();
                break;
            case 'LEFT_BRACE':
                this.skipObject();
                break;
            case 'LEFT_BRACKET':
                this.skipArray();
                break;
            case 'RIGHT_BRACE':
            case 'RIGHT_BRACKET':
            case 'COMMA':
            case 'COLON':
                this.recordRepair({
                    type: 'skip',
                    from: this.currentToken.type,
                    to: '-',
                    context: 'parser'
                });
                this.advance();
                break;
            case 'EOF':
                this.recordRepair({
                    type: 'skip',
                    from: this.currentToken.type,
                    to: '-',
                    context: 'parser'
                });
                break;
            default:
                {
                    const tok = this.currentToken;
                    this.recordRepair({
                        type: 'skip',
                        from: tok.type,
                        to: '-',
                        context: 'parser'
                    });
                    this.advance();
                    break;
                }
        }
    }
    skipDelimitedSequence(openDelimiter, closeDelimiter, skipItem) {
        this.expectAndAdvance(openDelimiter);
        while(this.currentToken.type !== closeDelimiter && this.currentToken.type !== 'EOF'){
            skipItem();
            if (this.currentToken.type === 'COMMA') this.advance();
        }
        this.expectAndAdvance(closeDelimiter);
    }
    skipObject() {
        this.skipDelimitedSequence('LEFT_BRACE', 'RIGHT_BRACE', ()=>{
            this.expect('STRING');
            this.advance();
            this.expect('COLON');
            this.advance();
            this.skipValue();
        });
    }
    skipArray() {
        this.skipDelimitedSequence('LEFT_BRACKET', 'RIGHT_BRACKET', ()=>{
            this.skipValue();
        });
    }
    parseArray(parseItem, onItem) {
        this.expectAndAdvance('LEFT_BRACKET');
        while(!this.peekType('RIGHT_BRACKET') && !this.peekType('EOF')){
            if (this.consume('COMMA')) continue;
            const item = parseItem();
            if (item !== null) onItem(item);
        }
        this.expectAndAdvance('RIGHT_BRACKET');
    }
    parseContentArray(parentType) {
        const isValidChild = this.validator.isValidChild(parentType);
        // Case 1: Malformed - missing array brackets
        if (this.peekType('LEFT_BRACE')) {
            this.recordRepair({
                type: 'skip',
                from: 'missing_brackets',
                to: 'inferred_array',
                context: parentType || 'content'
            });
            const content = [];
            while(this.peekType('LEFT_BRACE') || this.isObjectStart()){
                const node = this.parseContentNode();
                if (node) this.tryAppendNodeToContent(parentType, node, content, isValidChild, this.getTryAppendOptions());
                if (this.consume('COMMA')) ;
                else if (this.consume('RIGHT_BRACE')) {
                    if (!this.peekType('LEFT_BRACE')) break;
                } else if (this.peekType('LEFT_BRACE')) ;
                else break;
            }
            return content;
        }
        // Case 2: Normal array
        if (this.consume('LEFT_BRACKET')) {
            const content = [];
            let brokenContainer = false;
            while(!this.peekType('RIGHT_BRACKET') && !this.peekType('EOF')){
                if (this.consume('COMMA') || this.consume('RIGHT_BRACE')) continue;
                if (this.peekType('LEFT_BRACE') || this.isObjectStart()) {
                    const startToken = this.currentToken;
                    const node = this.parseContentNode();
                    if (node) {
                        // Check for implicit container breaks (e.g. missing closing bracket)
                        if (this.config.closeBrokenContent && this.repairStrategy.shouldAttemptStructuralFix(node, parentType)) // If we're not at the root level, structural fixes usually mean we should
                        // break out of the current container (e.g. valid heading inside a table -> table ends).
                        // If we ARE at the root, we can't break out, so we'll rely on tryAppendNodeToContent to wrap/repair in place.
                        {
                            if (parentType !== this.validator.getTopNodeType()) {
                                // Reset parser to start of this node
                                this.tokenizer.reset(this.accumulatedInput, startToken.position);
                                this.currentToken = this.tokenizer.nextToken();
                                this.recordRepair({
                                    type: 'unwrap',
                                    from: 'implicit_container_end',
                                    to: 'break_container',
                                    context: parentType || 'unknown'
                                });
                                brokenContainer = true;
                                break;
                            }
                        }
                        this.tryAppendNodeToContent(parentType, node, content, isValidChild, this.getTryAppendOptions());
                    }
                } else this.skipValue();
            }
            if (!brokenContainer) {
                this.expectAndAdvance('RIGHT_BRACKET');
                this.skipContainer = false;
            } else this.skipContainer = true;
            return content;
        }
        // Case 3: EOF
        if (this.peekType('EOF')) {
            this.expect('LEFT_BRACKET');
            return [];
        }
        // Case 4: Unexpected token
        this.recordRepair({
            type: 'skip',
            from: this.currentToken.type,
            to: 'empty_array',
            context: parentType || 'content'
        });
        this.skipValue();
        return [];
    }
    parseMarks() {
        const marks = [];
        this.parseArray(()=>{
            if (this.currentToken.type !== 'LEFT_BRACE') {
                this.skipValue();
                return null;
            }
            const mark = {};
            this.parseObjectProperties((key)=>{
                if (key === 'type') {
                    if (this.currentToken.type === 'STRING') {
                        mark.type = this.currentToken.value;
                        this.advance();
                    } else this.skipValue();
                } else if (key === 'attrs') {
                    if (this.currentToken.type === 'LEFT_BRACE') mark.attrs = this.parseAttrs();
                    else this.skipValue();
                } else this.skipValue();
            }, 'marks');
            return mark.type ? mark : null;
        }, (m)=>marks.push(m));
        return marks;
    }
    parseAttrs() {
        const attrs = {};
        this.parseObjectProperties((key)=>{
            attrs[key] = this.parsePrimitiveValue();
        }, 'attrs');
        return attrs;
    }
    parseRootNode() {
        const node = {};
        this.parseObjectProperties((key)=>{
            if (key === 'version') {
                if (this.currentToken.type === 'NUMBER') {
                    node.version = Number(this.currentToken.value);
                    this.advance();
                } else this.skipValue();
            } else if (key === 'type') {
                if (this.currentToken.type === 'STRING') {
                    node.type = this.currentToken.value;
                    this.advance();
                } else this.skipValue();
            } else if (key === 'content') node.content = this.withParentContext(node.type, ()=>this.parseContentArray(node.type));
            else if (key === 'attrs') {
                if (this.currentToken.type === 'LEFT_BRACE') node.attrs = this.parseAttrs();
                else this.skipValue();
            } else if (key === 'text') {
                if (this.currentToken.type === 'STRING') {
                    node.text = this.currentToken.value;
                    this.advance();
                } else this.skipValue();
            } else if (key === 'marks') {
                if (this.currentToken.type === 'LEFT_BRACKET') node.marks = this.parseMarks();
                else this.skipValue();
            } else {
                const value = this.parsePrimitiveValue();
                node[key] = value;
            }
        }, node.type || 'root');
        // If no type specified, infer it as the top node type
        if (!node.type) {
            const topNodeType = this.validator.getTopNodeType();
            node.type = topNodeType;
            this.recordRepair({
                type: 'infer',
                from: 'missing_type',
                to: topNodeType,
                context: 'root'
            });
        }
        // Default content to empty array for non-leaf nodes if not provided
        if (node.content === undefined && !this.validator.isLeafNode(node.type)) node.content = [];
        return node;
    }
    parseContentNode() {
        const node = {};
        let handle;
        let nodeStartPosition;
        this.parseObjectProperties((key)=>{
            if (key === 'type') {
                this.expect('STRING');
                nodeStartPosition = this.currentToken.position;
                node.type = this.currentToken.value;
                this.advance();
                // Check if we've already seen this node (by position) in a previous chunk
                const existingHandle = this.nodeHandlesByPosition.get(nodeStartPosition);
                if (existingHandle) // Reuse existing handle for updates
                handle = existingHandle;
                else if (this.callbacks.onNodeStart && node.type) {
                    // First time seeing this node - call onNodeStart
                    handle = this.callbacks.onNodeStart(node.type, this.currentParentType);
                    if (handle !== undefined) this.nodeHandlesByPosition.set(nodeStartPosition, handle);
                }
            } else if (key === 'content') {
                node.content = this.withParentContext(node.type, ()=>this.parseContentArray(node.type));
                this.updateNodeHandle(handle, {
                    content: node.content
                });
            } else if (key === 'attrs') {
                if (this.currentToken.type === 'LEFT_BRACE') {
                    node.attrs = this.parseAttrs();
                    this.updateNodeHandle(handle, {
                        attrs: node.attrs
                    });
                } else this.skipValue();
            } else if (key === 'text') {
                if (this.currentToken.type === 'STRING') {
                    node.text = this.currentToken.value;
                    this.advance();
                    this.updateNodeHandle(handle, {
                        text: node.text
                    });
                } else this.skipValue();
            } else if (key === 'marks') {
                if (this.currentToken.type === 'LEFT_BRACKET') {
                    node.marks = this.parseMarks();
                    this.updateNodeHandle(handle, {
                        marks: node.marks
                    });
                } else this.skipValue();
            } else {
                const value = this.parsePrimitiveValue();
                node[key] = value;
                if (value !== undefined) this.updateNodeHandle(handle, {
                    [key]: value
                });
            }
        }, 'node');
        // Let repair strategy handle missing types
        const completeNode = node;
        if (completeNode && handle) {
            this.callbacks.onNodeComplete?.(handle, completeNode);
            this.nodeHandles.set(completeNode, handle);
        }
        return completeNode;
    }
    resetParserState(input, clearNodeHandles = true) {
        this.repairs = [];
        this.accumulatedInput = input;
        this.parseComplete = false;
        this.cachedDocument = null;
        this.hitEofDuringExpect = false;
        this.skipContainer = false;
        if (clearNodeHandles) this.nodeHandles.clear();
    }
    /**
   * Parse a complete JSON string into an ADF document.
   * This is for synchronous, non-streaming parsing.
   *
   * @param input - The complete JSON string to parse
   * @returns The parsed ADF document
   */ parse(input) {
        // Reset parser state for new document
        this.resetParserState(input);
        // Reset tokenizer with new input
        this.tokenizer.reset(input, 0);
        this.currentToken = this.tokenizer.nextToken();
        const doc = this.parseDocument();
        this.parseComplete = true;
        this.cachedDocument = doc;
        return doc;
    }
    // Internal: shared parsing logic (expects tokenizer to be initialized)
    parseDocument() {
        const rootNode = this.parseRootNode();
        // If root node has content, validate it
        if (Array.isArray(rootNode.content)) {
            const isValidChild = this.validator.isValidChild(rootNode.type);
            for (const node of rootNode.content)if (node.type) isValidChild(node.type);
        }
        // Handle any additional nodes after the root (for multiple top-level objects)
        const allContent = Array.isArray(rootNode.content) ? [
            ...rootNode.content
        ] : [];
        const isValidChild = this.validator.isValidChild(rootNode.type);
        while(this.currentToken.type !== 'EOF'){
            if (this.currentToken.type === 'COMMA') {
                this.advance();
                continue;
            }
            if (this.currentToken.type === 'LEFT_BRACE') {
                const fragment = this.parseContentNode();
                if (fragment && typeof fragment === 'object') this.tryAppendNodeToContent(rootNode.type, fragment, allContent, isValidChild, {
                    topNodeType: rootNode.type
                });
            } else this.advance();
        }
        // Update content if we added more nodes
        if (allContent.length > 0 || Array.isArray(rootNode.content)) rootNode.content = allContent;
        return rootNode;
    }
    constructor(options){
        this.tokenizer = void 0;
        this.currentToken = void 0;
        this.repairs = [];
        this.validator = void 0;
        this.repairStrategy = void 0;
        this.hitEofDuringExpect = false;
        this.config = void 0;
        this.skipContainer = false;
        // Streaming-specific state
        this.callbacks = void 0;
        this.currentParentType = undefined;
        this.nodeHandles = new Map();
        this.nodeHandlesByPosition = new Map();
        // Track handles by node position
        this.accumulatedInput = '';
        this.parseComplete = false;
        this.cachedDocument = null;
        this.lastChunkReceived = false;
        this.validator = options.schemaValidator;
        this.repairStrategy = options.repairStrategy;
        this.callbacks = options.callbacks ?? {};
        this.config = options.config ?? {
            closeBrokenContent: false,
            lenientStringParsing: false,
            localIdTrimming: false,
            autoCloseObjectOnRightBracket: false
        };
        this.repairStrategy.setAdfParserConfig(this.config);
        // Initialize with empty input - will be set by parse() or processChunk()
        this.tokenizer = new (0, $9627c9b25c29aea2$export$947fa7da412978d0)('', (repair)=>this.recordRepair(repair), this.config.lenientStringParsing);
        this.currentToken = this.tokenizer.nextToken();
        this.accumulatedInput = '';
    }
}

class $6ff57709a89aa6f2$export$62e711fe8d5e8f73 {
    setAdfParserConfig(config) {
        this.adfParserConfig = config;
    }
    getNodeType(nodeType) {
        const $nodeType = this.schema.nodes[nodeType];
        return $nodeType || null;
    }
    wrapNodeWithType(node, $nodeType) {
        const $content = this.schema.nodeFromJSON(node);
        const $newContent = $nodeType.createAndFill(null, $content);
        return $newContent?.toJSON() ?? null;
    }
    wrapNode(node, $nodeType, $parentNodeType, siblings) {
        const contentMatch = this.findContentMatchAtPosition($parentNodeType, siblings);
        const wrappers = contentMatch?.findWrapping($nodeType);
        if (!wrappers || wrappers.length === 0) return null;
        let $content = this.schema.nodeFromJSON(node);
        for(let i = wrappers.length - 1; i >= 0; i--){
            const wrapper = wrappers[i];
            const match = wrapper?.contentMatch?.matchType($content.type);
            if (!match || !match.validEnd) return null;
            const $newContent = wrapper?.createAndFill(null, $content);
            if (!$newContent) return null;
            $content = $newContent;
        }
        return $content.toJSON();
    }
    // Convert a mark node (e.g., strong, em) to a proper text node with marks
    convertMarkNodeToMark(node, $parentNodeType) {
        // ProseMirror doesn't allow empty text nodes, use space as fallback
        const text = node.text && node.text.length > 0 ? node.text : ' ';
        const $textNode = this.schema.text(text, [
            this.schema.mark(node.type)
        ]);
        if ($parentNodeType.isTextblock) /**
       * To produce valid ADF, we need to use JSON Transformer
       * However, it will slow down the repair process
       * So, we are ignoring it for now
       */ return $textNode.toJSON();
        // Convert to JSON before wrapping (don't pass the original mark-as-node)
        const textNodeJson = $textNode.toJSON();
        const wrapped = this.wrapNode(textNodeJson, $textNode.type, $parentNodeType, []);
        return wrapped ?? textNodeJson;
    }
    isTableCellNode(node) {
        return node.type === 'tableCell' || node.type === 'tableHeader';
    }
    isListNode(node) {
        return $6ff57709a89aa6f2$export$62e711fe8d5e8f73.LIST_NODE_TYPES.has(node.type);
    }
    // Append node to last sibling if it matches targetType, otherwise null
    appendToLastSibling(node, siblings, targetType) {
        const lastSibling = siblings[siblings.length - 1];
        if (lastSibling && lastSibling.type === targetType) {
            if (!lastSibling.content) lastSibling.content = [];
            lastSibling.content.push(node);
            return []; // Node consumed
        }
        return null;
    }
    /**
   * Generic wrapper function that tries to append a node to existing structures or creates a new wrapper.
   *
   * @param node - The node to wrap/append
   * @param siblings - Sibling nodes to check
   * @param options - Configuration for how to append/wrap
   * @returns The wrapped node or empty array if consumed
   */ wrapOrAppendNode(node, siblings, options) {
        const lastSibling = siblings[siblings.length - 1];
        const parentTypes = Array.isArray(options.directParentTypes) ? options.directParentTypes : [
            options.directParentTypes
        ];
        if (lastSibling) {
            // Check for direct parent match at sibling level
            if (parentTypes.includes(lastSibling.type)) {
                // Handle nested parent type (e.g., table > tableRow for tableCell)
                if (options.nestedParentType) {
                    if (!lastSibling.content) lastSibling.content = [];
                    if (lastSibling.content.length > 0) {
                        const lastContent = lastSibling.content[lastSibling.content.length - 1];
                        if (lastContent && lastContent.type === options.nestedParentType) {
                            // Found nested parent - append to it
                            if (!lastContent.content) lastContent.content = [];
                            lastContent.content.push(node);
                            return []; // Node consumed
                        }
                    }
                    // Nested parent not found but createNestedIfMissing is true
                    if (options.createNestedIfMissing) {
                        lastSibling.content.push({
                            type: options.nestedParentType,
                            content: [
                                node
                            ]
                        });
                        return []; // Node consumed
                    }
                } else {
                    // No nested parent type - append directly
                    if (!lastSibling.content) lastSibling.content = [];
                    lastSibling.content.push(node);
                    return []; // Node consumed
                }
            }
            // Check one level deep for parent match (e.g., expand > bulletList for listItem)
            if (options.checkNestedParent && lastSibling.content && Array.isArray(lastSibling.content) && lastSibling.content.length > 0) {
                const lastContent = lastSibling.content[lastSibling.content.length - 1];
                if (lastContent && parentTypes.includes(lastContent.type)) {
                    if (!lastContent.content) lastContent.content = [];
                    lastContent.content.push(node);
                    return []; // Node consumed
                }
            }
        }
        // No match found - return default wrapper
        return options.defaultWrapper;
    }
    appendToLastTableRow(node, siblings) {
        return this.appendToLastSibling(node, siblings, 'tableRow');
    }
    wrapTableRow(node, siblings) {
        return this.wrapOrAppendNode(node, siblings, {
            directParentTypes: 'table',
            defaultWrapper: {
                type: 'table',
                attrs: {
                    isNumberColumnEnabled: false
                },
                content: [
                    node
                ]
            }
        });
    }
    wrapListItem(node, siblings) {
        return this.wrapOrAppendNode(node, siblings, {
            directParentTypes: [
                'bulletList',
                'orderedList'
            ],
            checkNestedParent: true,
            // Check expand > bulletList
            defaultWrapper: {
                type: 'bulletList',
                content: [
                    node
                ]
            }
        });
    }
    wrapTaskItem(node, siblings) {
        return this.wrapOrAppendNode(node, siblings, {
            directParentTypes: 'taskList',
            checkNestedParent: true,
            // Check expand > taskList
            defaultWrapper: {
                type: 'taskList',
                attrs: {
                    localId: null
                },
                content: [
                    node
                ]
            }
        });
    }
    wrapTableCell(node, siblings) {
        return this.wrapOrAppendNode(node, siblings, {
            directParentTypes: 'table',
            nestedParentType: 'tableRow',
            // table > tableRow > tableCell
            createNestedIfMissing: true,
            // Create tableRow if table exists but no tableRow
            defaultWrapper: {
                type: 'table',
                attrs: {
                    isNumberColumnEnabled: false
                },
                content: [
                    {
                        type: 'tableRow',
                        content: [
                            node
                        ]
                    }
                ]
            }
        });
    }
    shouldAttemptStructuralFix(node, parentType) {
        if (parentType === 'table') // Only attempt structural fix (breaking out) if it's NOT a table part.
        // Table cells/headers are "invalid" but should be handled by wrapping, not breaking.
        return node.type !== 'tableRow' && !this.isTableCellNode(node);
        else if (this.isTableCellNode({
            type: parentType || ''
        }) && node.type === 'tableRow' || parentType === 'tableRow' && !this.isTableCellNode(node)) return true;
        return parentType === 'doc' && (node.type === 'tableRow' || this.isTableCellNode(node));
    }
    isMarkWithOutAttrs(nodeType) {
        const mark = this.schema.marks[nodeType];
        if (!mark) return false;
        return !mark.spec.attrs || Object.keys(mark.spec.attrs).length === 0;
    }
    findContentMatchAtPosition($parentNodeType, siblings) {
        let currentMatch = $parentNodeType.contentMatch;
        for (const sibling of siblings){
            if (!currentMatch) return null;
            const siblingType = this.getNodeType(sibling.type);
            currentMatch = siblingType ? currentMatch.matchType(siblingType) : null;
        }
        return currentMatch;
    }
    isTypeAllowedAt($parentNodeType, siblings) {
        return ($nodeType)=>this.findContentMatchAtPosition($parentNodeType, siblings)?.matchType($nodeType) !== null;
    }
    applyNodeMutations(node) {
        let wasMutated = false;
        // Infer missing type from node properties
        if (!node.type && node.text !== undefined) {
            node.type = 'text';
            wasMutated = true;
        }
        // If still no type, can't proceed with type-specific mutations
        if (!node.type) return wasMutated;
        switch(node.type){
            case 'date':
                const today = new Date().getTime().toString();
                node.attrs = node.attrs || {};
                if (node.attrs.timestamp) {
                    if (typeof node.attrs.timestamp === 'string' && // eslint-disable-next-line require-unicode-regexp
                    !node.attrs.timestamp.match(/^\d+$/)) {
                        const d = new Date(node.attrs.timestamp);
                        node.attrs.timestamp = isNaN(d.getTime()) ? today : d.getTime().toString();
                        return true;
                    }
                } else {
                    node.attrs.timestamp = today;
                    return true;
                }
                break;
        }
        if (this.adfParserConfig.localIdTrimming) {
            if (node.attrs && node.attrs.localId && typeof node.attrs.localId === 'string') {
                node.attrs.localId = node.attrs.localId.substring(0, 36);
                return true;
            }
        }
        return wasMutated;
    }
    tryRepair(node, parentType, siblings) {
        // Apply mutations first (in-place data type fixes, including type inference)
        const wasMutated = this.applyNodeMutations(node);
        // If still no type after mutations, can't repair
        if (!node.type) return null;
        let $parentNodeType;
        if (parentType) $parentNodeType = this.schema.nodes[parentType];
        // Handle marks (strong, em, etc.) appearing as nodes FIRST
        // before trying to access as node types
        if (this.isMarkWithOutAttrs(node.type)) return this.convertMarkNodeToMark(node, $parentNodeType || this.schema.topNodeType);
        const $nodeType = this.schema.nodes[node.type];
        if (!$nodeType) return null;
        if (parentType && $parentNodeType) {
            // Wrap orphaned inline nodes in paragraphs where allowed
            if ($nodeType.isInline) {
                const wrapped = this.wrapNode(node, $nodeType, $parentNodeType, siblings);
                if (wrapped) return wrapped;
            }
            // Unwrap textblocks nested inside other textblocks
            // paragraph -> taskItem, heading -> paragraph, etc.
            if ($parentNodeType.isTextblock && $nodeType.isTextblock) return node.content || null;
            const isTypeAllowed = this.isTypeAllowedAt($parentNodeType, siblings);
            const $nestedExpandType = this.schema.nodes['nestedExpand'];
            if ($nestedExpandType && node.type === 'expand' && isTypeAllowed($nestedExpandType)) return {
                ...node,
                type: 'nestedExpand'
            };
            const $tableType = this.schema.nodes['table'];
            if ($tableType && this.isTableCellNode(node) && isTypeAllowed($tableType)) return this.wrapTableCell(node, siblings);
            // Handle special cases that need custom logic
            switch(parentType){
                case 'doc':
                    if (node.type === 'tableRow') return this.wrapTableRow(node, siblings);
                    if (node.type === 'listItem') return this.wrapListItem(node, siblings);
                    if (node.type === 'taskItem') return this.wrapTaskItem(node, siblings);
                    break;
                case 'expand':
                case 'nestedExpand':
                    if (node.type === 'listItem') return this.wrapListItem(node, siblings);
                    if (node.type === 'taskItem') return this.wrapTaskItem(node, siblings);
                    break;
                case 'table':
                    if (this.isTableCellNode(node)) return this.appendToLastTableRow(node, siblings);
                    break;
                case 'bulletList':
                case 'orderedList':
                    if (this.isListNode(node)) return {
                        type: 'listItem',
                        content: [
                            node
                        ]
                    };
                    else {
                        const wrapped = this.wrapNode(node, $nodeType, $parentNodeType, siblings);
                        if (wrapped) return wrapped;
                    }
                    break;
                case 'paragraph':
                    // bulletList/orderedList/taskList nodes cannot be children of paragraph
                    // Return as array to signal unwrap operation (will replace paragraph with bulletList)
                    if (this.isListNode(node)) return [
                        node
                    ];
                    break;
            }
            // Generic wrapping fallback
            for (const [nodeType, wrapperType] of this.wrappingMap){
                const $wrapperType = this.schema.nodes[wrapperType];
                if ($wrapperType && node.type === nodeType && isTypeAllowed($wrapperType)) return this.wrapNodeWithType(node, $wrapperType);
            }
        }
        // Return mutated node if no structural repair was needed
        return wasMutated ? node : null;
    }
    // eslint-disable-next-line no-useless-constructor
    constructor(schema){
        this.schema = schema;
        this.adfParserConfig = {};
        this.wrappingMap = [
            // NOTE: listItem and taskItem have special handling in switch statement below for intelligent append
            [
                'paragraph',
                'blockTaskItem'
            ],
            [
                'listItem',
                'bulletList'
            ],
            [
                'taskItem',
                'taskList'
            ]
        ];
    }
}
$6ff57709a89aa6f2$export$62e711fe8d5e8f73.LIST_NODE_TYPES = new Set([
    'bulletList',
    'orderedList',
    'taskList'
]);

class $89260be58a566cc0$export$c034a5beeae7d184 {
    isValidChild(parentType) {
        const resolvedParentType = parentType || this.getTopNodeType();
        const $parentNodeType = this.schema.nodes[resolvedParentType];
        if (!$parentNodeType || !$parentNodeType.contentMatch) return ()=>true;
        // Closure maintains contentMatch state
        let currentMatch = $parentNodeType.contentMatch;
        return (childType)=>{
            const childNodeType = this.schema.nodes[childType];
            if (!childNodeType) return false;
            const nextMatch = currentMatch.matchType(childNodeType);
            if (nextMatch) {
                currentMatch = nextMatch;
                return true;
            }
            return false;
        };
    }
    isLeafNode(nodeType) {
        const $nodeType = this.schema.nodes[nodeType];
        return $nodeType ? $nodeType.isLeaf : false;
    }
    getTopNodeType() {
        return this.schema.topNodeType?.name || 'doc';
    }
    // eslint-disable-next-line no-useless-constructor
    constructor(schema){
        this.schema = schema;
    }
}



var $4pSml = parcelRequire("4pSml");


class $62fb057c9c6dd661$export$6d1dc40d9d0d1446 {
    init(traceId) {
        this.editorApi.aiStreamingOrchestrator?.actions.startSession((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? traceId : undefined);
        this.actionId = this.editorApi.aiStreamingOrchestrator?.actions.initAction({
            type: 'appendNode',
            streamingType: 'create'
        }, {
            /**
       * Always hide the loading screen as staging area always shows Rovo conversation
       * and will already have a loading indicator.
       */ hideLoadingScreen: this.contentLocation === 'staging-area'
        });
        if (!this.actionId) throw new Error('Failed to initialize streaming action for create');
        const schema = this.editorApi.core.sharedState.currentState()?.schema;
        if (schema) this.parser = new (0, $686b256ab99abbdf$export$f692212e574bcc60)({
            schemaValidator: new (0, $89260be58a566cc0$export$c034a5beeae7d184)(schema),
            repairStrategy: new (0, $6ff57709a89aa6f2$export$62e711fe8d5e8f73)(schema),
            config: {
                closeBrokenContent: (0, $dh538.fg)('platform_editor_ai_improved_table_parsing'),
                lenientStringParsing: (0, $dh538.fg)('platform_editor_ai_lenient_string_parsing'),
                localIdTrimming: (0, $dh538.fg)('platform_editor_ai_local_id_trimming'),
                autoCloseObjectOnRightBracket: (0, $dh538.fg)('platform_editor_ai_less-aggro-obj-parsing')
            }
        });
        (0, $2a68fac7c12ea4ef$export$bef1f36f5486a6a3)('Initialized editor streaming action', {
            streamType: 'create',
            actionId: this.actionId
        });
    }
    isInitialized() {
        return !!this.actionId;
    }
    stream(adf, isFinished = false, traceId) {
        if (!this.actionId) this.init((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? traceId : undefined);
        if (!adf || !this.actionId) return;
        if (this.parser) {
            this.parser.processChunk(adf, isFinished);
            this.editorApi.aiStreamingOrchestrator?.actions.streamValue(// NOTE: This is a temporary solution before we move the streamer inside `/platform`
            this.actionId, JSON.stringify(this.parser.getPartialDocument()) ?? '');
        } else this.editorApi.aiStreamingOrchestrator?.actions.streamValue(this.actionId, adf);
        if (traceId) this.traceId = traceId;
        this.accumulated += adf;
        (0, $2a68fac7c12ea4ef$export$bef1f36f5486a6a3)('Streaming content', {
            actionId: this.actionId,
            adf: adf
        });
    }
    async finish({ onError: onError, onRepair: onRepair }) {
        if (this.actionId) {
            this.editorApi?.aiStreamingOrchestrator?.actions.finishAction(this.actionId);
            await this.editorApi?.aiStreamingOrchestrator?.actions.endSession();
            (0, $2a68fac7c12ea4ef$export$bef1f36f5486a6a3)('Finished action', {
                actionId: this.actionId,
                fullAdf: this.accumulated
            });
            let finalDoc;
            try {
                const schema = this.editorApi.core.sharedState.currentState()?.schema;
                if (!schema) throw new Error('Schema is not available');
                const parser = new (0, $686b256ab99abbdf$export$f692212e574bcc60)({
                    schemaValidator: new (0, $89260be58a566cc0$export$c034a5beeae7d184)(schema),
                    repairStrategy: new (0, $6ff57709a89aa6f2$export$62e711fe8d5e8f73)(schema),
                    config: {
                        closeBrokenContent: (0, $dh538.fg)('platform_editor_ai_improved_table_parsing'),
                        lenientStringParsing: (0, $dh538.fg)('platform_editor_ai_lenient_string_parsing'),
                        localIdTrimming: (0, $dh538.fg)('platform_editor_ai_local_id_trimming'),
                        autoCloseObjectOnRightBracket: (0, $dh538.fg)('platform_editor_ai_less-aggro-obj-parsing')
                    }
                });
                const doc = parser.parse(this.accumulated);
                const newStreamer = new (0, $4pSml.ADFStreamer)(schema);
                newStreamer.processChunk(JSON.stringify(doc || {}));
                finalDoc = newStreamer.getLastDoc();
                const repairs = parser.getRepairs();
                if (repairs.length > 0) onRepair?.({
                    repairs: repairs,
                    streamType: 'create'
                });
            } catch (error) {
                (0, $2a68fac7c12ea4ef$export$bef1f36f5486a6a3)('New ADF Parser failed, falling back to ADF Streamer', {
                    error: error
                });
                onError?.({
                    error: error,
                    streamType: 'create',
                    traceId: this.traceId
                });
                // Give ADF Streamer a chance to repair the ADF
                const schema = this.editorApi.core.sharedState.currentState()?.schema;
                if (schema) {
                    const newStreamer = new (0, $4pSml.ADFStreamer)(schema);
                    newStreamer.processChunk(this.accumulated);
                    finalDoc = newStreamer.getLastDoc();
                }
            }
            this.accumulated = '';
            this.actionId = undefined;
            this.traceId = undefined;
            return finalDoc;
        }
    }
    abort() {
        this.editorApi.aiStreamingOrchestrator?.actions.abortSession();
    }
    constructor(editorApi, contentLocation){
        this.editorApi = void 0;
        this.contentLocation = void 0;
        this.actionId = void 0;
        this.accumulated = '';
        this.parser = void 0;
        this.traceId = void 0;
        this.editorApi = editorApi;
        this.contentLocation = contentLocation;
    }
}











var $d925B = parcelRequire("d925B");

function $09775c3d01249dfa$export$59f8e7f95aedfc2e(editorApi, result) {
    editorApi.analytics?.actions.fireAnalyticsEvent({
        action: 'error',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreaming',
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            errorMessage: 'Infinite loop detected',
            errorData: {
                action: result.name,
                localId: result.localId
            },
            experienceName: null,
            selectionType: null,
            selectionCategory: null,
            streamId: null,
            source: {
                type: 'orchestrator',
                isCreateAction: false
            }
        }
    });
}





// Map of JSON escape sequences to their unescaped values
const $40e31febec4d6204$var$ESCAPE_MAP = {
    '"': '"',
    '\\': '\\',
    '/': '/',
    b: '\b',
    f: '\f',
    n: '\n',
    r: '\r',
    t: '\t'
};
function $40e31febec4d6204$export$ecec02ace5330ac6(str) {
    // eslint-disable-next-line require-unicode-regexp
    return str.replace(/\\(?:u[0-9a-fA-F]{4}|.)/g, (match)=>{
        // Valid unicode escape is always 6 characters: \uXXXX
        if (match[1] === 'u' && match.length === 6) return String.fromCharCode(parseInt(match.slice(2), 16));
        // Single-character escape: 2 characters (\X)
        return $40e31febec4d6204$var$ESCAPE_MAP[match[1]] ?? match;
    });
}


class $9caa18fb726d84a0$var$ToolCall {
    constructor(){
        this.initialized = false;
        this.name = '';
        this.nameKeyIdx = null;
        this.arguments = {
            localId: null,
            trueValue: '',
            value: '',
            valueStartIdx: null,
            wrapperAttrs: null,
            wrapperType: null,
            attrs: null
        };
    }
}
// KEYS
const $9caa18fb726d84a0$var$NAME = '"name"';
const $9caa18fb726d84a0$var$LOCAL_ID = '"localId"';
const $9caa18fb726d84a0$var$VALUE = '"value"';
const $9caa18fb726d84a0$var$WRAPPER_ATTRS = '"wrapperAttrs"';
const $9caa18fb726d84a0$var$WRAPPER_TYPE = '"wrapperType"';
const $9caa18fb726d84a0$var$ATTRIBUTES_TYPE = '"attrs"';
// ACTIONS
const $9caa18fb726d84a0$var$REPLACE = 'replaceNode';
const $9caa18fb726d84a0$var$INSERT_BEFORE = 'insertNodeBefore';
const $9caa18fb726d84a0$var$INSERT_AFTER = 'insertNodeAfter';
const $9caa18fb726d84a0$var$APPEND = 'appendNode';
const $9caa18fb726d84a0$var$APPEND_TO_END = 'appendNodeToEnd';
const $9caa18fb726d84a0$var$REMOVE = 'removeNode';
const $9caa18fb726d84a0$var$WRAP = 'wrap';
const $9caa18fb726d84a0$var$WRAP_NODE = 'wrapNode';
const $9caa18fb726d84a0$var$SET_ATTRIBUTES = 'setAttrs';
const $9caa18fb726d84a0$var$actionsRequiringValue = new Set([
    $9caa18fb726d84a0$var$REPLACE,
    $9caa18fb726d84a0$var$INSERT_BEFORE,
    $9caa18fb726d84a0$var$INSERT_AFTER,
    $9caa18fb726d84a0$var$APPEND,
    $9caa18fb726d84a0$var$APPEND_TO_END
]);
function $9caa18fb726d84a0$var$isStreamable(actionName) {
    return $9caa18fb726d84a0$var$actionsRequiringValue.has(actionName);
}
const $9caa18fb726d84a0$var$actionsRequiringLocalId = new Set([
    $9caa18fb726d84a0$var$REPLACE,
    $9caa18fb726d84a0$var$INSERT_BEFORE,
    $9caa18fb726d84a0$var$INSERT_AFTER,
    $9caa18fb726d84a0$var$REMOVE,
    $9caa18fb726d84a0$var$WRAP,
    $9caa18fb726d84a0$var$WRAP_NODE,
    $9caa18fb726d84a0$var$SET_ATTRIBUTES
]);
function $9caa18fb726d84a0$var$requiresLocalId(actionName) {
    return $9caa18fb726d84a0$var$actionsRequiringLocalId.has(actionName);
}
function $9caa18fb726d84a0$var$isWrapAction(actionName) {
    return actionName === $9caa18fb726d84a0$var$WRAP || actionName === $9caa18fb726d84a0$var$WRAP_NODE;
}
function $9caa18fb726d84a0$var$isUpdateAction(actionName) {
    return actionName === $9caa18fb726d84a0$var$SET_ATTRIBUTES;
}
class $9caa18fb726d84a0$export$c8af4b703b22343c {
    constructor(name, localId, wrapperType, wrapperAttrs, attrs){
        this.name = void 0;
        this.localId = void 0;
        this.wrapperType = void 0;
        this.wrapperAttrs = void 0;
        this.attrs = void 0;
        this.name = name;
        this.localId = localId;
        this.wrapperType = wrapperType;
        this.wrapperAttrs = wrapperAttrs;
        this.attrs = attrs;
    }
}
class $9caa18fb726d84a0$export$5730dcf0c67ac93b {
    constructor(rawPartialValue){
        this.partialValue = void 0;
        this.rawPartialValue = void 0;
        this.rawPartialValue = rawPartialValue;
        this.partialValue = (0, $dh538.fg)('platform_editor_ai_improved_json_escape') ? (0, $40e31febec4d6204$export$ecec02ace5330ac6)(rawPartialValue) : // eslint-disable-next-line require-unicode-regexp
        rawPartialValue.replace(/\\/g, '');
    }
}
class $9caa18fb726d84a0$export$576d226276925ad4 {
    constructor(){
        this.isFinished = void 0;
        this.isFinished = true;
    }
}
function $9caa18fb726d84a0$var$findValue(input, key) {
    const keyIndex = input.indexOf(key);
    if (keyIndex === -1) return null;
    else {
        let i = keyIndex + key.length;
        let value = '';
        while(i < input.length){
            const char = input[i];
            const prevChar = i > 0 ? input[i - 1] : undefined;
            if ((char === ':' || char === ' ' || char === '"') && value.length === 0) i++;
            else if (char === '"' && prevChar !== '\\') return {
                value: value,
                keyIndex: keyIndex
            };
            else {
                value += char;
                i++;
            }
        }
    }
    return null;
}
function $9caa18fb726d84a0$var$findAdfStartIdx(searchSpace) {
    const key = $9caa18fb726d84a0$var$VALUE;
    const keyIndex = searchSpace.indexOf($9caa18fb726d84a0$var$VALUE);
    if (keyIndex === -1) return null;
    else {
        let i = keyIndex + key.length;
        while(i < searchSpace.length){
            const char = searchSpace[i];
            if (char === '"') return i + 1;
            i++;
        }
    }
    return null;
}
function $9caa18fb726d84a0$var$findAdfEndIdx(searchSpace, startIdx) {
    let partial = '';
    for(let i = startIdx; i < searchSpace.length; i++){
        const char = searchSpace[i];
        const prevChar = i > 0 ? searchSpace[i - 1] : undefined;
        if (char === '"' && prevChar !== '\\') return {
            partial: partial,
            endIndex: i
        };
        else partial += char;
    }
    return {
        partial: partial,
        endIndex: null
    };
}
class $9caa18fb726d84a0$export$6366aec646e3c75 {
    reset() {
        this.toolCalls = [];
        this.accumulated = '';
    }
    parse(input) {
        this.accumulated += input;
        const results = [];
        while(true){
            let toolCall = this.toolCalls.at(-1);
            if (!toolCall) {
                toolCall = new $9caa18fb726d84a0$var$ToolCall();
                this.toolCalls.push(toolCall);
            }
            /**
       * Step 1:
       * Populate the name/type of the command (e.g., appendNode).
       */ if (!toolCall.name) {
                // Start searching from the previous tool call, offset
                // by 1 so we don't find the same one again.
                const previousToolCall = this.toolCalls.at(-2);
                const startIdx = (previousToolCall?.nameKeyIdx ?? -1) + 1;
                const result = $9caa18fb726d84a0$var$findValue(this.accumulated.slice(startIdx), $9caa18fb726d84a0$var$NAME);
                if (result) {
                    toolCall.name = result.value;
                    toolCall.nameKeyIdx = startIdx + result.keyIndex;
                } else return results;
            }
            const searchStartIdx = toolCall.nameKeyIdx;
            if (searchStartIdx === null) return results;
            // TODO: EDITOR-123 - Can we guarantee that the other keys will come after `name`?
            const searchSpace = this.accumulated.slice(searchStartIdx);
            /**
       * Step 2:
       * Populate the local ID if it's required.
       */ if ($9caa18fb726d84a0$var$requiresLocalId(toolCall.name) && !toolCall.arguments.localId) {
                const result = $9caa18fb726d84a0$var$findValue(searchSpace, $9caa18fb726d84a0$var$LOCAL_ID);
                if (result) toolCall.arguments.localId = result.value;
                else return results;
            }
            /**
       * Step 3:
       * Populate the additional wrap parameters if this is a wrap action.
       */ if ($9caa18fb726d84a0$var$isWrapAction(toolCall.name)) {
                if (!toolCall.arguments.wrapperType) {
                    const result = $9caa18fb726d84a0$var$findValue(searchSpace, $9caa18fb726d84a0$var$WRAPPER_TYPE);
                    if (result) toolCall.arguments.wrapperType = result.value;
                    else return results;
                }
                if (!toolCall.arguments.wrapperAttrs) {
                    const result = $9caa18fb726d84a0$var$findValue(searchSpace, $9caa18fb726d84a0$var$WRAPPER_ATTRS);
                    if (result) // eslint-disable-next-line require-unicode-regexp
                    toolCall.arguments.wrapperAttrs = JSON.parse(result.value.replace(/\\/g, ''));
                    else return results;
                }
            }
            /**
       * Step 3.1:
       * Populate the additional update parameters for update attribute actions
       */ if ($9caa18fb726d84a0$var$isUpdateAction(toolCall.name)) {
                if (!toolCall.arguments.attrs) {
                    const result = $9caa18fb726d84a0$var$findValue(searchSpace, $9caa18fb726d84a0$var$ATTRIBUTES_TYPE);
                    if (result) // eslint-disable-next-line require-unicode-regexp
                    toolCall.arguments.attrs = JSON.parse(result.value.replace(/\\/g, ''));
                    else return results;
                }
            }
            /**
       * Step 4:
       * At this point, all the information required for initializing
       * the tool call has been gathered, so push an InitAction and mark
       * the tool call as initialized.
       */ if (!toolCall.initialized) {
                results.push(new $9caa18fb726d84a0$export$c8af4b703b22343c(toolCall.name, // May be null
                toolCall.arguments.localId, // May be null
                toolCall.arguments.wrapperType, // May be null
                toolCall.arguments.wrapperAttrs, // May be null
                toolCall.arguments.attrs));
                toolCall.initialized = true;
            }
            /**
       * Step 5:
       * If this tool call isn't streamable (e.g., removeNode), then
       * we can finalize it and move on to the next tool call.
       */ if (!$9caa18fb726d84a0$var$isStreamable(toolCall.name)) {
                // If this is an action we don't need an ADF value for (e.g., remove), then
                // we're done and can move on to the next tool call.
                results.push(new $9caa18fb726d84a0$export$576d226276925ad4());
                this.toolCalls.push(new $9caa18fb726d84a0$var$ToolCall());
                continue;
            }
            /**
       * Step 6:
       * Find the starting index of the ADF value.
       * Example:
       * "value": "{\"content..."
       *           ^
       *           |
       *           +-- This is the start of the ADF value
       */ if (!toolCall.arguments.valueStartIdx) {
                const adfStartIdx = $9caa18fb726d84a0$var$findAdfStartIdx(searchSpace);
                if (adfStartIdx !== null) toolCall.arguments.valueStartIdx = searchStartIdx + adfStartIdx;
                else return results;
            }
            /**
       * Step 7:
       * Start looking for the end of the ADF value. If partial ADF has been
       * found, we push a StreamAction with the new content. If the end index
       * has been found, we push a FinishAction and move to the next tool call.
       */ const valueEnd = $9caa18fb726d84a0$var$findAdfEndIdx(this.accumulated.slice(toolCall.arguments.valueStartIdx), toolCall.arguments.value.length);
            if (valueEnd.partial.length > 0) {
                toolCall.arguments.value += valueEnd.partial;
                results.push(new $9caa18fb726d84a0$export$5730dcf0c67ac93b(valueEnd.partial));
            }
            if (valueEnd.endIndex === null) // We haven't reached the end of the ADF yet
            return results;
            else {
                // Move to the next tool call
                results.push(new $9caa18fb726d84a0$export$576d226276925ad4());
                this.toolCalls.push(new $9caa18fb726d84a0$var$ToolCall());
            }
        }
        return results;
    }
    constructor(){
        this.toolCalls = [];
        this.accumulated = '';
    }
}


/**
 * The total amount of times we're happy to process the same toolcall command. If more sequential toolcalls exist then
 * what this value is set too, then we have detected a possible infinite loop and we will abort the stream.
 */ const $a3e9a7cbc2f4d95c$var$MAX_INFINITE_LOOP_COUNT = 5;
const $a3e9a7cbc2f4d95c$var$SKIP_INFINITE_LOOP_ACTIONS = [
    'insertNodeAfter',
    'insertNodeBefore'
];
class $a3e9a7cbc2f4d95c$var$ToolCallProcessor {
    stream(adf, isFinished) {
        if (!adf) return;
        if (this.parser && (0, $dh538.fg)('platform_editor_ai_aifc_adf_parser_on_update')) {
            this.parser.processChunk(adf, isFinished);
            this.editorApi.aiStreamingOrchestrator?.actions.streamValue(this.actionId, JSON.stringify(this.parser.getPartialDocument()) ?? '');
        } else this.editorApi.aiStreamingOrchestrator?.actions.streamValue(this.actionId, adf);
        this.accumulated += adf;
        (0, $2a68fac7c12ea4ef$export$bef1f36f5486a6a3)('Streaming content', {
            actionId: this.actionId,
            adf: adf
        });
    }
    finish() {
        this.editorApi?.aiStreamingOrchestrator?.actions.finishAction(this.actionId);
        (0, $2a68fac7c12ea4ef$export$bef1f36f5486a6a3)('Finished action', {
            actionId: this.actionId,
            fullAdf: this.accumulated
        });
        this.accumulated = '';
    }
    constructor(editorApi, contentLocation, command){
        this.editorApi = editorApi;
        this.contentLocation = contentLocation;
        this.actionId = void 0;
        this.accumulated = '';
        this.parser = void 0;
        const actionId = this.editorApi?.aiStreamingOrchestrator?.actions.initAction(command, {
            /**
       * Always hide the loading screen as staging area always shows Rovo conversation
       * and will already have a loading indicator.
       */ hideLoadingScreen: this.contentLocation === 'staging-area'
        });
        if (!actionId) throw new Error('Failed to initialize streaming action for update');
        this.actionId = actionId;
        (0, $2a68fac7c12ea4ef$export$bef1f36f5486a6a3)('Initialized editor streaming action', {
            streamType: 'update',
            actionId: actionId,
            command: command
        });
        if ((0, $dh538.fg)('platform_editor_ai_aifc_adf_parser_on_update')) {
            const schema = this.editorApi.core.sharedState.currentState()?.schema;
            if (schema) this.parser = new (0, $686b256ab99abbdf$export$f692212e574bcc60)({
                schemaValidator: new (0, $89260be58a566cc0$export$c034a5beeae7d184)(schema),
                repairStrategy: new (0, $6ff57709a89aa6f2$export$62e711fe8d5e8f73)(schema),
                config: {
                    closeBrokenContent: (0, $dh538.fg)('platform_editor_ai_improved_table_parsing'),
                    lenientStringParsing: (0, $dh538.fg)('platform_editor_ai_lenient_string_parsing'),
                    localIdTrimming: (0, $dh538.fg)('platform_editor_ai_local_id_trimming'),
                    autoCloseObjectOnRightBracket: (0, $dh538.fg)('platform_editor_ai_less-aggro-obj-parsing')
                }
            });
        }
    }
}
function $a3e9a7cbc2f4d95c$var$assertUnreachable(_x) {}
class $a3e9a7cbc2f4d95c$export$37d5c27ac1ce34a8 {
    reset() {
        this.accumulated = '';
        this.lastAction = null;
        this.currentToolCall = undefined;
        this.hasDetectedInfiniteLoop = false;
        this.loopsDetected = 0;
        this.parser.reset();
    }
    createToolCallProcessor(toolCall) {
        const type = toolCall.name;
        const localId = toolCall.localId ?? '';
        let command;
        switch(type){
            case 'replaceNode':
            case 'insertNodeBefore':
            case 'insertNodeAfter':
            case 'removeNode':
                command = {
                    type: type,
                    localId: localId
                };
                break;
            case 'appendNode':
            case 'appendNodeToEnd':
                command = {
                    type: type
                };
                break;
            case 'wrap':
            case 'wrapNode':
                const wrapperType = toolCall.wrapperType;
                const wrapperAttrs = toolCall.wrapperAttrs;
                if (!wrapperType || !wrapperAttrs) return;
                command = {
                    type: type,
                    localId: localId,
                    wrapperType: wrapperType,
                    wrapperAttrs: wrapperAttrs
                };
                break;
            case 'setAttrs':
                const attrs = toolCall.attrs;
                if (!attrs) return;
                command = {
                    type: type,
                    localId: localId,
                    attrs: attrs
                };
                break;
            default:
                $a3e9a7cbc2f4d95c$var$assertUnreachable(type);
                return;
        }
        return new $a3e9a7cbc2f4d95c$var$ToolCallProcessor(this.editorApi, this.contentLocation, command);
    }
    streamChunk(chunk, isFinished, traceId) {
        // The last message contains a copy of the full, accumulated tool call structure. We
        // don't want to reprocess this, so we just return instead.
        if (isFinished) return;
        if (this.accumulated.length === 0) {
            this.reset();
            this.editorApi.aiStreamingOrchestrator?.actions.startSession((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? traceId : undefined);
        }
        this.accumulated += chunk;
        return this.stream(chunk, isFinished);
    }
    stream(chunk, isFinished) {
        // Once we detect an infinite loop and call finish(), we won't be able to recover
        if (this.hasDetectedInfiniteLoop) return;
        const results = this.parser.parse(chunk);
        for (const result of results){
            if (result instanceof (0, $9caa18fb726d84a0$export$c8af4b703b22343c)) {
                if (result.localId) {
                    if ((0, $dh538.fg)('platform_editor_ai_aifc_toolcall_loop_limiting')) {
                        if (this.lastAction === `${result.name}-${result.localId}` && !$a3e9a7cbc2f4d95c$var$SKIP_INFINITE_LOOP_ACTIONS.includes(result.name)) {
                            this.loopsDetected++;
                            if (this.loopsDetected >= $a3e9a7cbc2f4d95c$var$MAX_INFINITE_LOOP_COUNT) {
                                this.hasDetectedInfiniteLoop = true;
                                (0, $09775c3d01249dfa$export$59f8e7f95aedfc2e)(this.editorApi, result);
                                return;
                            } else this.currentToolCall = this.createToolCallProcessor(result);
                        } else {
                            this.loopsDetected = 0;
                            this.currentToolCall = this.createToolCallProcessor(result);
                        }
                    } else if (this.lastAction === `${result.name}-${result.localId}` && !$a3e9a7cbc2f4d95c$var$SKIP_INFINITE_LOOP_ACTIONS.includes(result.name)) {
                        // Once we detect an infinite loop, we keep skipping and wait for the streaming to finish.
                        this.hasDetectedInfiniteLoop = true;
                        this.finish();
                        (0, $09775c3d01249dfa$export$59f8e7f95aedfc2e)(this.editorApi, result);
                    } else {
                        this.hasDetectedInfiniteLoop = false;
                        this.currentToolCall = this.createToolCallProcessor(result);
                    }
                    this.lastAction = `${result.name}-${result.localId}`;
                } else {
                    this.lastAction = null;
                    this.currentToolCall = this.createToolCallProcessor(result);
                }
            } else if (result instanceof (0, $9caa18fb726d84a0$export$5730dcf0c67ac93b)) this.currentToolCall?.stream(result.partialValue, isFinished);
            else if (result instanceof (0, $9caa18fb726d84a0$export$576d226276925ad4)) this.currentToolCall?.finish();
            else throw new Error('Unknown action type from partial stream parser');
        }
    }
    async finish() {
        if (this.hasDetectedInfiniteLoop) {
            this.rovoBridgeAPI.send((0, $6VfGD.InlineInputBoxAbortMessageCommand), {
                receiverId: (0, $6VfGD.ROVO_CHAT_CLIENT_ID),
                senderId: this.clientId
            });
            this.reset();
            await this.editorApi.aiStreamingOrchestrator?.actions.endSession();
        } else {
            this.accumulated = '';
            await this.editorApi.aiStreamingOrchestrator?.actions.endSession();
            this.lastAction = null;
            this.currentToolCall = undefined;
            this.parser.reset();
        }
    }
    abort() {
        this.reset();
        this.editorApi.aiStreamingOrchestrator?.actions.abortSession();
    }
    constructor(editorApi, contentLocation, clientId, rovoBridgeAPI){
        this.editorApi = editorApi;
        this.contentLocation = contentLocation;
        this.clientId = clientId;
        this.rovoBridgeAPI = rovoBridgeAPI;
        this.parser = void 0;
        this.currentToolCall = void 0;
        this.accumulated = '';
        this.lastAction = void 0;
        this.hasDetectedInfiniteLoop = false;
        this.loopsDetected = 0;
        this.parser = new (0, $9caa18fb726d84a0$export$6366aec646e3c75)();
        this.lastAction = null;
    }
}



class $78494542878b4a31$export$475014de15a4c342 {
    /**
   * Products can use this method to add custom command handlers
   * they can also add default command handlers using addDefaultCommandHandlers
   *
   * @param command - The command constructor
   * @param handler - The command handler
   * @returns The command manager
   */ addCommandHandler(command, handler) {
        this.commandHandlers.set(command, handler);
        return this;
    }
    /**
   * Products can use this method to add default command handlers
   * they can also add custom command handlers using addCommandHandler
   *
   * @returns The command manager
   */ addDefaultCommandHandlers() {
        this.addCreateCommandHandler();
        this.addUpdateCommandHandler();
        this.addReadCommandHandler();
        this.addAbortCommandHandler();
        this.addRovoStreamCompletedCommandHandler();
        return this;
    }
    registerCommandsToRovoBridge() {
        this.commandHandlers.forEach((handler, command)=>{
            this.rovoBridgeAPI.on(this.clientId, command, (payload)=>{
                return handler.execute(payload);
            });
        });
    }
    /**
   * Add commands and register them to the rovo bridge
   */ addAndRegisterCommands() {
        if (this.addCommandHandlers) this.addCommandHandlers({
            commandManager: this
        });
        else this.addDefaultCommandHandlers();
        this.registerCommandsToRovoBridge();
    }
    deregisterCommandsFromRovoBridge() {
        this.commandHandlers.forEach((handler, command)=>{
            this.rovoBridgeAPI.off(this.clientId, command);
            handler.deregister();
        });
    }
    /**
   * Deregister all commands
   */ deregisterCommands() {
        (0, $2a68fac7c12ea4ef$export$bef1f36f5486a6a3)('deregister commands');
        this.deregisterCommandsFromRovoBridge();
        this.commandHandlers.clear();
    }
    /**
   * Update clientId
   */ updateClientId(clientId, rovoBridgeAPI) {
        if (this.clientId === clientId && this.rovoBridgeAPI === rovoBridgeAPI) return;
        // add analytics event for the re-registration
        (0, $2a68fac7c12ea4ef$export$bef1f36f5486a6a3)('update clientId');
        this.deregisterCommandsFromRovoBridge();
        this.clientId = clientId;
        this.rovoBridgeAPI = rovoBridgeAPI;
        this.registerCommandsToRovoBridge();
    }
    /**
   * Update commandProps
   */ updateCommandProps(commandProps) {
        if (this.commandProps === commandProps) return;
        (0, $2a68fac7c12ea4ef$export$bef1f36f5486a6a3)('update commandProps');
        this.commandProps = commandProps;
        this.commandHandlers.forEach((handler)=>{
            handler.updateProps(commandProps);
        });
    }
    /**
   * Update addCommandHandlers
   */ updateAddCommandHandlers(addCommandHandlers) {
        if (this.addCommandHandlers === addCommandHandlers) return;
        (0, $2a68fac7c12ea4ef$export$bef1f36f5486a6a3)('update addCommandHandlers');
        this.addCommandHandlers = addCommandHandlers;
        this.deregisterCommands();
        this.addAndRegisterCommands();
    }
    addCreateCommandHandler() {
        const createCommandHandler = new (0, $b6cae06f30b7714b$export$53d8e34277e6a8ab)(this.commandProps, this.createCommandProcessor);
        this.addCommandHandler((0, $6VfGD.ConfluencePageCreateCommand), createCommandHandler);
    }
    addUpdateCommandHandler() {
        const updateCommandHandler = new (0, $dab8eb7e4b62bd25$export$9e34a8a16b80af23)(this.commandProps, this.updateCommandProcessor);
        this.addCommandHandler((0, $6VfGD.ConfluenceUpdatePageCommand), updateCommandHandler);
    }
    addReadCommandHandler() {
        const readCommandHandler = new (0, $9d8d447fe2d64b32$export$ada55596c5cc2d41)(this.commandProps);
        this.addCommandHandler((0, $6VfGD.ReadContentCommand), readCommandHandler);
    }
    addAbortCommandHandler() {
        const abortCommandHandler = new (0, $105efb57326a211f$export$3a9b6d9d6180d66)(this.commandProps, ()=>{
            this.commandHandlers.forEach((handler)=>{
                if (handler instanceof (0, $dc0b802a9b7b02c4$export$1673b811578d4e4e)) handler.handleAbort();
            });
            this.commandProps.onStreamAbort?.();
        });
        this.addCommandHandler((0, $6VfGD.RovoStreamAbortedCommand), abortCommandHandler);
    }
    addRovoStreamCompletedCommandHandler() {
        const streamCompletedHandler = new (0, $b4644247c7dc40b4$export$c246e3e964a757d2)(this.commandProps);
        this.addCommandHandler((0, $6VfGD.RovoStreamCompletedCommand), streamCompletedHandler);
    }
    constructor(clientId, rovoBridgeAPI, commandProps, addCommandHandlers){
        this.clientId = clientId;
        this.rovoBridgeAPI = rovoBridgeAPI;
        this.commandProps = commandProps;
        this.addCommandHandlers = addCommandHandlers;
        this.commandHandlers = new Map();
        this.createCommandProcessor = void 0;
        this.updateCommandProcessor = void 0;
        this.createCommandProcessor = new (0, $62fb057c9c6dd661$export$6d1dc40d9d0d1446)(this.commandProps.editorAPI, this.commandProps.contentLocation);
        this.updateCommandProcessor = new (0, $a3e9a7cbc2f4d95c$export$37d5c27ac1ce34a8)(this.commandProps.editorAPI, this.commandProps.contentLocation, this.clientId, this.rovoBridgeAPI);
    }
}






var $grxv4 = parcelRequire("grxv4");




const $09b7c50aa62be5be$export$62377526511be117 = ({ mediaProvider: mediaProvider, createMediaProvider: createMediaProvider, onUploadImageError: onUploadImageError })=>{
    const mediaProviderRef = (0, $42omo.useRef)(Promise.resolve());
    const mediaClientCacheRef = (0, $42omo.useRef)(new Map());
    // Store media provider as a ref so it can be accessed mid-processing without recreating callbacks or triggering re-renders
    (0, $42omo.useEffect)(()=>{
        if (mediaProvider) mediaProviderRef.current = mediaProvider;
    }, [
        mediaProvider
    ]);
    // Get or create media client for a specific content ID, used for retrieving the original image URL
    // Leverages a cache to avoid creating multiple media clients for the same content ID
    const getViewMediaClientForContentId = (0, $42omo.useCallback)(async (originalContentId)=>{
        // Check media client cache first
        const cache = mediaClientCacheRef.current;
        const item = cache.get(originalContentId);
        if (item) return item;
        if (!createMediaProvider) throw new Error('No createMediaProvider function provided');
        // Create renderer media provider for the original content
        const mediaProvider = await createMediaProvider({
            contentId: originalContentId
        });
        // Get media client from the provider
        const mediaClient = (0, $grxv4.getMediaClient)(mediaProvider.viewMediaClientConfig);
        // Cache it
        cache.set(originalContentId, mediaClient);
        return mediaClient;
    }, [
        createMediaProvider
    ]);
    // Processes ADF nodes recursively, reuploading images when necessary, and tracking whether ADF changes (reuploads) were made
    const processAdfNodes = (0, $42omo.useCallback)(async (adfContent, mediaClient, targetCollection, getViewMediaClientForContentId)=>{
        let hasChanges = false; // Stable state in closure
        const changedNodesByLocalId = new Map(); // Track changed nodes by their localId
        // Inner recursive function - no change tracking in return type
        const processNode = async (node)=>{
            if (!node || typeof node !== 'object') return node;
            // Process single image node
            if ($09b7c50aa62be5be$var$isImageNode(node) && $09b7c50aa62be5be$var$needsReupload(node, targetCollection)) {
                hasChanges = true;
                try {
                    const newImageData = await $09b7c50aa62be5be$var$reuploadImageNode(node, mediaClient, targetCollection, getViewMediaClientForContentId);
                    const updatedNode = {
                        ...node,
                        attrs: {
                            ...node.attrs,
                            ...newImageData
                        }
                    };
                    if ((0, $dh538.fg)('confluence_frontend_aifc_reupload_image')) {
                        const localId = node.attrs?.localId;
                        if (!localId) throw new Error('localId is required for image re-uploading');
                        changedNodesByLocalId.set(localId, updatedNode);
                    }
                    return updatedNode;
                } catch (error) {
                    onUploadImageError?.({
                        error: $09b7c50aa62be5be$var$enhanceError(error, `Failed to reupload image to collection ${targetCollection}`)
                    });
                    return node; // Return original ADF on error
                }
            }
            // Process objects like: `{ type: "table", content: [...] } or { type: "mediaSingle", content: [...] }`
            const processedNode = {
                ...node
            };
            if (node.content && Array.isArray(node.content)) processedNode.content = await Promise.all(node.content.map((item)=>{
                return item ? processNode(item) : item;
            }));
            return processedNode;
        };
        const processedAdf = await processNode(adfContent);
        return {
            processedAdf: processedAdf,
            hasChanges: hasChanges,
            changedNodesByLocalId: changedNodesByLocalId
        };
    }, [
        onUploadImageError
    ]);
    /**
	 * Process ADF content to fix image collection IDs by reuploading images to mediaProvider's collection
	 * @param adfContent - The ADF content to process
	 * @returns Promise resolving to an object containing:
	 *   - processedAdf: The processed ADF content with updated, reuploaded image collection IDs
	 *   - hasChanges: Boolean indicating if any changes were made to the ADF
	 *   - error?: Optional error if processing failed
	 *   - changedNodesByLocalId?: Map of localId to updated media nodes
	 */ const processImagesInAdf = (0, $42omo.useCallback)(async (adfContent)=>{
        try {
            const mediaProvider = await mediaProviderRef.current;
            if (!mediaProvider?.uploadMediaClientConfig || !mediaProvider.uploadParams?.collection) return {
                processedAdf: adfContent,
                hasChanges: false,
                error: new Error('No media provider')
            }; // Return original ADF if no media provider
            let mediaClient;
            let targetCollection;
            try {
                mediaClient = (0, $grxv4.getMediaClient)(mediaProvider.uploadMediaClientConfig);
                targetCollection = mediaProvider.uploadParams.collection;
            } catch (error) {
                return {
                    processedAdf: adfContent,
                    hasChanges: false,
                    error: $09b7c50aa62be5be$var$enhanceError(error, 'Error getting media client')
                }; // Return original ADF on error
            }
            try {
                return await processAdfNodes(adfContent, mediaClient, targetCollection, getViewMediaClientForContentId);
            } catch (error) {
                return {
                    processedAdf: adfContent,
                    hasChanges: false,
                    error: $09b7c50aa62be5be$var$enhanceError(error, 'Error processing ADF nodes')
                }; // Return original ADF on error
            }
        } catch (error) {
            return {
                processedAdf: adfContent,
                hasChanges: false,
                error: $09b7c50aa62be5be$var$enhanceError(error, 'Error processing images in ADF')
            }; // Return original ADF on error
        }
    }, [
        getViewMediaClientForContentId,
        processAdfNodes
    ]);
    return (0, $42omo.useMemo)(()=>{
        return {
            processImagesInAdf: processImagesInAdf
        };
    }, [
        processImagesInAdf
    ]);
};
// Adds helpful message to error object
function $09b7c50aa62be5be$var$enhanceError(error, message) {
    return new Error(`${message}: ${error.message}`);
}
// Helper function to extract content ID from collection pattern
function $09b7c50aa62be5be$var$extractContentIdFromCollection(collection) {
    // eslint-disable-next-line require-unicode-regexp
    const match = collection.match(/^contentId-(\d+)$/);
    return match ? match[1] : null;
}
// Checks if a node is an image node
function $09b7c50aa62be5be$var$isImageNode(node) {
    return node?.type && (node?.attrs?.id || node?.attrs?.url) && [
        'media',
        'mediaInline',
        'mediaSingle'
    ].includes(node?.type);
}
// Determines if an image node needs re-uploading
function $09b7c50aa62be5be$var$needsReupload(node, targetCollection) {
    return !node.attrs?.collection || // no collection
    node.attrs.collection !== targetCollection // collection needs to change
    ;
}
// Re-uploads an image node with correct collection ID
async function $09b7c50aa62be5be$var$reuploadImageNode(node, editorMediaClient, targetCollection, getViewMediaClientForContentId) {
    let sourceUrl = node.attrs?.url;
    // If we have an ID but wrong collection, try to get the URL from original content
    if (node.attrs?.id && node.attrs?.collection && !sourceUrl) try {
        // Extract original content ID from collection pattern
        const originalContentId = $09b7c50aa62be5be$var$extractContentIdFromCollection(node.attrs.collection);
        if (originalContentId) {
            // Get media client for the original content
            const originalViewMediaClient = await getViewMediaClientForContentId(originalContentId);
            // Use MediaClient's getImageUrl method to properly construct the absolute URL
            // This handles auth and baseUrl construction automatically
            sourceUrl = await originalViewMediaClient.getImageUrl(node.attrs.id, {
                collection: node.attrs.collection
            });
        } else throw new Error(`Invalid collection format: ${node.attrs.collection}`);
    } catch (error) {
        // Fall back to using the original ID/collection if we can't get URL
        throw $09b7c50aa62be5be$var$enhanceError(error, `Could not access source image: ${node.attrs.id}`);
    }
    if (!sourceUrl) throw new Error('No source URL available for image re-upload');
    // Upload to target collection
    const uploader = await editorMediaClient.file.uploadExternal(sourceUrl, targetCollection);
    const result = await uploader;
    return {
        id: result.uploadableFileUpfrontIds.id,
        collection: targetCollection
    };
}



const $9bbbf468d399974e$var$bindRovoBridgeTeardown = (teardown)=>{
    const run = ()=>{
        /**
		 * @description We do NOT want to yield a return value here. It can cause certain unload
		 * handlers to display a window alert with "Are you sure you want to leave this page?".
		 * Specifically, see @see https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event,
		 * which is remarked to be a cancellable event by browsers.
		 */ teardown();
        // Although unnecessary (the JS context is being destroyed), we remove the event listeners
        // to avoid any potential memory leaks due to hanging references - side effects can cause this.
        unbind();
    };
    // Below, we attempt to teardown on different event handlers which we know will trigger
    // on complete unmount of the document in this JS context. Note: Same-origin iframes are
    // indeed considered their own JS context here; just that they have access to other contexts.
    // Browsers report `unload` and `beforeunload` to be unreliable. Hence, we leverage a chain
    // of these events. See official MDN documentation for more (linked below).
    /**
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
	 * TODO - bring beforeunload back by consolidating handlers per discussion at -
	 * https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/207747/overview#comment-674441389
	 */ // window.addEventListener('beforeunload', run, { once: true });
    /**
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/pagehide_event
	 */ const unbind = (0, $fFa3V.bindAll)(window, [
        {
            type: 'unload',
            listener: run,
            options: {
                once: true
            }
        },
        {
            type: 'pagehide',
            listener: run,
            options: {
                once: true
            }
        }
    ]);
    return unbind;
};
function $9bbbf468d399974e$var$useRovoBridgeLifecycle(props) {
    const contentType = 'page';
    const { clientId: clientId, contentLocation: contentLocation, contentId: contentId, rovoBridgeAPI: rovoBridgeAPI } = props;
    (0, $42omo.useEffect)(()=>{
        if (!rovoBridgeAPI) return;
        rovoBridgeAPI.ready(clientId);
        rovoBridgeAPI.send((0, $6VfGD.ContentReadyCommand), {
            senderId: clientId,
            receiverId: (0, $6VfGD.ROVO_CHAT_CLIENT_ID),
            contentId: contentId,
            contentType: contentType,
            canProvideContext: true,
            contentContext: contentLocation
        });
        function rovoBridgeTeardown() {
            if (!rovoBridgeAPI) return;
            rovoBridgeAPI.send((0, $6VfGD.ContentDestroyCommand), {
                senderId: clientId,
                receiverId: (0, $6VfGD.ROVO_CHAT_CLIENT_ID),
                contentId: contentId,
                contentType: contentType,
                contentContext: contentLocation
            });
            rovoBridgeAPI.teardown(clientId);
        }
        const unbind = $9bbbf468d399974e$var$bindRovoBridgeTeardown(()=>rovoBridgeTeardown());
        return ()=>{
            try {
                unbind();
                rovoBridgeTeardown();
            // TODO: EDITOR-123 - clear inactivity timeouts?
            } catch  {
            // TODO: EDITOR-123 - handle errors; should go to Sentry
            // could be sent in future by navigation lockout
            }
        };
    }, [
        clientId,
        contentLocation,
        contentId,
        contentType,
        rovoBridgeAPI
    ]);
}
const $9bbbf468d399974e$export$5203c6a0fdaaa3b = ({ contentLocation: contentLocation, contentId: contentId, editorAPI: editorAPI, useGenericEditorSkill: useGenericEditorSkill, additionalContext: additionalContext, mediaProvider: mediaProvider, createMediaProvider: createMediaProvider, onUploadImageError: onUploadImageError, onStreamStart: onStreamStart, onStream: onStream, onStreamEnd: onStreamEnd, onStreamAbort: onStreamAbort, onStreamTimeout: onStreamTimeout, onStreamError: onStreamError, onStreamRepair: onStreamRepair, addCommandHandlers: addCommandHandlers })=>{
    const contentType = 'page';
    const clientId = (0, $6VfGD.getConfluenceEditorClientId)(contentId);
    (0, $42omo.useEffect)(()=>{
        if (!editorAPI) return;
        editorAPI.aiExperience?.actions.updateTargetId(contentId);
    }, [
        editorAPI,
        contentId
    ]);
    const rovoBridgeAPI = (0, $42omo.useMemo)(()=>{
        if (!editorAPI) return null;
        return (0, $fD5Hh.getBrowserBridgeAPI)();
    }, [
        editorAPI
    ]);
    const imageProcessor = (0, $09b7c50aa62be5be$export$62377526511be117)({
        mediaProvider: mediaProvider,
        createMediaProvider: createMediaProvider,
        onUploadImageError: onUploadImageError
    });
    const reuploadImages = (0, $42omo.useCallback)(async (adfDoc)=>{
        const processImagesAndUpdateDocument = async ()=>{
            if (!imageProcessor?.processImagesInAdf) throw new Error('Image processor not available for image re-uploading in editor streaming');
            if (!editorAPI) throw new Error('Editor API not available for image re-uploading in editor streaming');
            if ((0, $dh538.fg)('confluence_frontend_aifc_reupload_image')) {
                const editorDoc = await editorAPI.core.actions.requestDocumentAsync();
                if (!editorDoc) throw new Error('Could not get document from editor for image re-uploading');
                const { error: error, hasChanges: hasChanges, changedNodesByLocalId: changedNodesByLocalId } = await imageProcessor.processImagesInAdf(editorDoc);
                (0, $2a68fac7c12ea4ef$export$bef1f36f5486a6a3)('reuploadImages', {
                    error: error,
                    hasChanges: hasChanges,
                    adfDoc: adfDoc,
                    changedNodesByLocalId: changedNodesByLocalId
                });
                if (error) throw error;
                if (hasChanges && changedNodesByLocalId && changedNodesByLocalId.size > 0) {
                    // Get the editor's schema to convert ADF to ProseMirror nodes
                    const schema = editorAPI.core.sharedState.currentState()?.schema;
                    if (!schema) throw new Error('Could not get editor schema for image re-uploading');
                    // Replace individual nodes
                    changedNodesByLocalId.forEach((adfNode, localId)=>{
                        // Convert ADF to ProseMirror node
                        const pmNode = schema.nodeFromJSON(adfNode);
                        editorAPI?.localId?.actions.replaceNode({
                            localId: localId,
                            value: pmNode
                        });
                    });
                }
            } else {
                if (!adfDoc) throw new Error('adfDoc is required for image re-uploading when feature flag is off');
                const { error: error, hasChanges: hasChanges, processedAdf: processedAdf } = await imageProcessor.processImagesInAdf(adfDoc);
                (0, $2a68fac7c12ea4ef$export$bef1f36f5486a6a3)('reuploadImages', {
                    error: error,
                    hasChanges: hasChanges,
                    processedAdf: processedAdf,
                    adfDoc: adfDoc
                });
                if (error) throw error;
                if (hasChanges) editorAPI?.core.actions.replaceDocument(processedAdf, {
                    scrollIntoView: false
                });
            }
        };
        try {
            await processImagesAndUpdateDocument();
        } catch (error) {
            (0, $4B9iQ.sendAIFCExperienceTrackingToParent)({
                status: 'fail',
                actionType: 'page',
                actionId: contentId,
                contentContext: contentLocation,
                experienceName: (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED,
                error: error.message
            });
            onUploadImageError?.({
                error: error
            });
        }
    }, [
        imageProcessor,
        editorAPI,
        contentId,
        contentLocation,
        onUploadImageError
    ]);
    const commandProps = (0, $42omo.useMemo)(()=>{
        if (!editorAPI) return null;
        return {
            clientId: clientId,
            contentLocation: contentLocation,
            contentId: contentId,
            contentType: contentType,
            editorAPI: editorAPI,
            useGenericEditorSkill: useGenericEditorSkill,
            additionalContext: additionalContext,
            onStreamStart: onStreamStart,
            onStream: onStream,
            onStreamEnd: onStreamEnd,
            onStreamAbort: onStreamAbort,
            onStreamTimeout: onStreamTimeout,
            onStreamError: onStreamError,
            onStreamRepair: onStreamRepair,
            reuploadImages: reuploadImages
        };
    }, [
        clientId,
        contentLocation,
        contentId,
        contentType,
        editorAPI,
        useGenericEditorSkill,
        additionalContext,
        onStreamStart,
        onStream,
        onStreamEnd,
        onStreamAbort,
        onStreamTimeout,
        onStreamError,
        onStreamRepair,
        reuploadImages
    ]);
    const commandManagerRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (!editorAPI || !rovoBridgeAPI || !commandProps) return;
        // only initialize command manager once because
        // createCommandProcessor is stateful and doesn't support re-creation for now
        if (!commandManagerRef.current) {
            commandManagerRef.current = new (0, $78494542878b4a31$export$475014de15a4c342)(clientId, rovoBridgeAPI, commandProps, addCommandHandlers);
            commandManagerRef.current.addAndRegisterCommands();
        }
    }, [
        editorAPI,
        clientId,
        rovoBridgeAPI,
        commandProps,
        addCommandHandlers
    ]);
    // clientId shouldn't change, but just in case
    // when it changes, we re-register the commands to the updated clientId
    (0, $42omo.useEffect)(()=>{
        if (!commandManagerRef.current || !rovoBridgeAPI) return;
        commandManagerRef.current.updateClientId(clientId, rovoBridgeAPI);
    }, [
        clientId,
        rovoBridgeAPI
    ]);
    // when commandProps changes, we update the command props
    (0, $42omo.useEffect)(()=>{
        if (!commandManagerRef.current || !commandProps) return;
        commandManagerRef.current.updateCommandProps(commandProps);
    }, [
        commandProps
    ]);
    // when addCommandHandlers changes, we deregister and register the commands
    (0, $42omo.useEffect)(()=>{
        if (!commandManagerRef.current) return;
        commandManagerRef.current.updateAddCommandHandlers(addCommandHandlers);
    }, [
        addCommandHandlers
    ]);
    // when the component unmounts, we deregister the commands
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            commandManagerRef.current?.deregisterCommands();
        };
    }, []);
    $9bbbf468d399974e$var$useRovoBridgeLifecycle({
        contentLocation: contentLocation,
        contentId: contentId,
        editorAPI: editorAPI,
        onStreamStart: onStreamStart,
        onStream: onStream,
        onStreamEnd: onStreamEnd,
        onStreamAbort: onStreamAbort,
        onStreamTimeout: onStreamTimeout,
        onStreamError: onStreamError,
        onStreamRepair: onStreamRepair,
        addCommandHandlers: addCommandHandlers,
        clientId: clientId,
        rovoBridgeAPI: rovoBridgeAPI
    });
};









var $2O3ot = parcelRequire("2O3ot");


var $3IBnw = parcelRequire("3IBnw");


var $4IoVL = parcelRequire("4IoVL");


var $6mKj3 = parcelRequire("6mKj3");





var $5ZqQS = parcelRequire("5ZqQS");


var $8aF6s = parcelRequire("8aF6s");


var $bQm3c = parcelRequire("bQm3c");


var $9cZ1w = parcelRequire("9cZ1w");


var $cJeDc = parcelRequire("cJeDc");


var $jyA9t = parcelRequire("jyA9t");


var $b7FrM = parcelRequire("b7FrM");


var $b0F8r = parcelRequire("b0F8r");


var $lpRYt = parcelRequire("lpRYt");


function $908492137eb1f6c4$export$bef1f36f5486a6a3(message, ...args) {
    try {
        if (window.top?.__aifcDebuggerEnabled__) // eslint-disable-next-line no-console
        console.log(`[AIFC]: ${message}`, ...args);
    } catch (e) {
    // Ignore cross origin frame access errors
    }
}


class $e1270e15c69ffc89$export$a7898906d711def9 extends (0, $dc0b802a9b7b02c4$export$1673b811578d4e4e) {
    async process(payload) {
        if (payload.isStreamComplete) this.streamedMd = payload.data.content;
        else this.streamedMd += payload.data.content;
        const adfDoc = this.streamingAdfEncoder.encode(this.streamedMd);
        // Temporarily using replaceDocument since the editor streaming plugin does not support streaming MD or multiple ADF docs
        this.props.editorAPI.core.actions.replaceDocument(adfDoc, {
            scrollIntoView: false
        });
    }
    async finishAction() {
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('handle confluence-deep-research-page-create-command');
        const adfDoc = this.streamedMd ? this.streamingAdfEncoder.encode(this.streamedMd) : undefined;
        this.streamedMd = '';
        return adfDoc;
    }
    abort() {
    // No-op
    }
    constructor(props){
        super(props, 'deep-research-create');
        // Streaming Markdown -> ADF encoder for Deep Research content
        this.streamingAdfEncoder = void 0;
        this.streamedMd = '';
        const pluginConfig = {
            linkify: {
                findFilepaths: $b0F8r.findFilepaths,
                isLinkInMatches: $b0F8r.isLinkInMatches
            },
            smartLinks: {
                regexStorage: globalThis.localStorage
            }
        };
        this.streamingAdfEncoder = new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, pluginConfig, true));
    }
}











var $9K5In = parcelRequire("9K5In");

class $a9ad9677fcca25bd$export$8b2d6af8570e89fc extends (0, $350fe12d8db447f2$export$54019a4b43471d88) {
    async execute(payload) {
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('handle confluence-page-init-command');
        const document = await (0, $9K5In.getDocument)(this.props.editorAPI);
        if (!document) {
            (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('PageInitCommand received but document is not available');
            return;
        }
        const isEmpty = (0, $9K5In.isEmptyDocument)(document);
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)(`Received ConfluencePageInitCommand with isEmpty: ${isEmpty}`, payload?.data);
        if (!isEmpty) return;
        const editorSchema = this.props.editorAPI.core.sharedState.currentState()?.schema;
        if (!editorSchema) {
            (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('Editor schema is not available');
            return;
        }
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('Streaming initial ADF from ConfluencePageInitCommand', payload?.data.adf);
        this.props.onStreamStart?.({
            streamType: 'init',
            payload: payload
        });
        this.props.onStream?.({
            streamType: 'init',
            payload: payload
        });
        // In case ADF is invalid, we chunk it to retain as much of the ADF as possible
        const streamer = new (0, $4pSml.ADFStreamer)(editorSchema);
        const adfChunks = (0, $9K5In.chunkSubstr)(payload.data.adf, 50);
        for (const chunk of adfChunks){
            (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('Processing chunk from ConfluencePageInitCommand', chunk);
            streamer.processChunk(chunk);
        }
        const adfDoc = streamer.getLastDoc();
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('Replacing document with ADF from ConfluencePageInitCommand', adfDoc);
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('Replace document function - ', this.props.editorAPI.core.actions.replaceDocument);
        this.props.editorAPI.core.actions.replaceDocument(adfDoc, {
            scrollIntoView: false
        });
        // Trigger image re-uploading if handler is available
        if ((0, $9wGTI.fg)('confluence_frontend_aifc_reupload_image')) await this.props.reuploadImages?.();
        else if (adfDoc) await this.props.reuploadImages?.(adfDoc);
        this.props.onStreamEnd?.({
            streamType: 'init',
            payload: payload
        });
    }
}




class $dab8e08b53df3f80$export$1591457cbf726478 extends (0, $350fe12d8db447f2$export$54019a4b43471d88) {
    execute() {
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('handle prepare-content-for-finalization-command');
        return new Promise(async (resolve)=>{
            try {
                const document = await this.extraProps.forceDraftSync?.();
                resolve({
                    success: true,
                    content: document
                });
            } catch  {
                resolve({
                    success: false,
                    content: undefined
                });
            }
        });
    }
    constructor(props, extraProps){
        super(props), this.extraProps = extraProps;
    }
}







class $2d58d664ae64ca90$export$60cb93fdd3fa65f9 extends (0, $350fe12d8db447f2$export$54019a4b43471d88) {
    execute(payload) {
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('handle confluence-prompt-submit-on-page-create-command');
        if (this.extraProps.generateAIHeaderImage && (0, $9wGTI.fg)('aifc_header_image_pseudo_title_enabled')) return this.extraProps.generateAIHeaderImage({
            adfContent: payload.userPrompt,
            showAcceptanceFlow: true
        });
        return Promise.resolve();
    }
    constructor(props, extraProps){
        super(props), this.extraProps = extraProps;
    }
}







var $aSsfA = parcelRequire("aSsfA");


var $efvKr = parcelRequire("efvKr");


var $cD1qu = parcelRequire("cD1qu");

function $6110298a09c933b1$export$9f74cfd73dac3627() {
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [{ isViewMode: isViewMode }] = (0, $efvKr.useLivePageMode)();
    // Handle each page mode explicitly
    if (pageMode === (0, $cD1qu.PageMode).EDIT) return false;
    if (pageMode === (0, $cD1qu.PageMode).LIVE) return isViewMode;
    // PageMode.VIEW or unknown modes default to view mode
    return true;
}


const $f6e2b5ede1c96960$export$123c48b30e85000 = ({ contentId: contentId, contentLocation: contentLocation, editorAPI: editorAPI, setEditorDisabled: setEditorDisabled, setTitlePlaceholderState: setTitlePlaceholderState, onTitleChange: onTitleChange, mediaProvider: mediaProvider, fakeGenerateAIHeaderImage: fakeGenerateAIHeaderImage, generateAIHeaderImage: generateAIHeaderImage, forceDraftSync: forceDraftSync, flags: flags, useGenericEditorSkill: useGenericEditorSkill, additionalContext: additionalContextFromProps })=>{
    const contentType = 'page';
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isViewMode = (0, $6110298a09c933b1$export$9f74cfd73dac3627)();
    const intl = (0, $8C5kA.default)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
    const { stagingAreaMode: stagingAreaMode } = (0, $2O3ot.useStagingAreaState)();
    const createMediaProvider = (0, $42omo.useCallback)(async ({ contentId: contentId })=>{
        return (0, $4IoVL.createRendererMediaProvider)({
            contentId: contentId,
            isExternalShare: false
        });
    }, []);
    const onUploadImageError = (0, $42omo.useCallback)(({ error: error })=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
    }, []);
    const sendInitialCreationAnalytics = (0, $42omo.useCallback)(async ()=>{
        try {
            let features;
            if (editorAPI) {
                const doc = await (0, $9K5In.getDocument)(editorAPI);
                if (doc) features = (0, $e4JJO.extractContentFeatures)(doc);
            }
            sendAnalyticsEvent({
                eventType: 'track',
                actionSubject: 'smartCreateContent',
                action: 'initialContentCreated',
                attributes: {
                    createdContentProduct: 'confluence',
                    createdContentType: contentType,
                    createdContentFeatures: features,
                    createdContentMetadata: {
                        contentId: contentId
                    }
                }
            });
        } catch (error) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PAGE_MODES
            });
        }
    }, [
        editorAPI,
        contentId,
        contentType,
        sendAnalyticsEvent
    ]);
    // Called once when streaming starts
    const onStreamStart = (0, $42omo.useCallback)(({ streamType: streamType })=>{
        setEditorDisabled?.(true);
        if (streamType === 'create' || streamType === 'deep-research-create') {
            setTitlePlaceholderState?.(true);
            if ((0, $6mKj3.isExperimentEnabled)('confluence_aifc_image_generation_experiment')) {
                if (!(0, $9wGTI.fg)('aifc_header_image_pseudo_title_enabled')) fakeGenerateAIHeaderImage?.();
            }
        }
        // Succeed the AIFC_INITIAL_DATA_RECEIVED experience since content has started streaming.
        // This ensures this experience won't timeout and then fail the AIFC_GENERATE_CONTENT or AIFC_UPDATE_CONTENT experience.
        // NOTE: This experience isn't started for all flows, it'll be a no-op if it's not started.
        (0, $4B9iQ.sendAIFCExperienceTrackingToParent)({
            status: 'success',
            actionType: contentType,
            actionId: contentId,
            contentContext: contentLocation,
            experienceName: (0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED
        });
    }, [
        setEditorDisabled,
        fakeGenerateAIHeaderImage,
        setTitlePlaceholderState,
        contentId,
        contentType,
        contentLocation
    ]);
    // Called on every stream chunk
    const onStream = (0, $42omo.useCallback)(({ payload: payload })=>{
        if ('title' in payload.data) {
            const title = payload?.data?.title;
            onTitleChange?.(title);
            if (title) setTitlePlaceholderState?.(false);
        }
    }, [
        onTitleChange,
        setTitlePlaceholderState
    ]);
    const showCreateWithRovoModalCloseFeedbackFlag = (0, $9cZ1w.useLazyShowFeedbackFlag)(flags, intl, showModal, createAnalyticsEvent);
    // Called when streaming ends
    const onStreamEnd = (0, $42omo.useCallback)(async ({ streamType: streamType, payload: payload })=>{
        try {
            // reuploadImages is handled in platform
            if (streamType === 'create') {
                const title = 'title' in payload?.data ? payload.data.title : undefined;
                if (title) {
                    if ((0, $6mKj3.isExperimentEnabled)('confluence_aifc_image_generation_experiment')) {
                        if (!(0, $9wGTI.fg)('aifc_header_image_pseudo_title_enabled')) generateAIHeaderImage?.({
                            adfContent: title
                        });
                    }
                }
            }
            // This experience success is a no-op if AIFC_ALL_DATA_HANDLED is not started. It may not be started for all flows.
            (0, $4B9iQ.sendAIFCExperienceTrackingToParent)({
                status: 'success',
                actionType: contentType,
                actionId: contentId,
                contentContext: contentLocation,
                experienceName: (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED
            });
            if (streamType === 'create' || streamType === 'deep-research-create') sendInitialCreationAnalytics();
            else if (streamType === 'update') {
                if (!showSmartCreationModal && stagingAreaMode !== 'modal') {
                    const traceId = typeof payload?.traceId === 'string' ? payload.traceId : undefined;
                    const requestId = typeof payload?.requestId === 'string' ? payload.requestId : undefined;
                    showCreateWithRovoModalCloseFeedbackFlag({
                        feedbackVariant: (0, $cJeDc.FeedbackVariant).AFTER_UPDATE_STREAM_COMPLETE,
                        contentType: contentType,
                        cloudId: cloudId,
                        traceId: traceId,
                        requestId: requestId
                    });
                }
            }
        } finally{
            setEditorDisabled?.(false);
        }
    }, [
        contentId,
        contentType,
        contentLocation,
        setEditorDisabled,
        generateAIHeaderImage,
        sendInitialCreationAnalytics,
        showCreateWithRovoModalCloseFeedbackFlag,
        showSmartCreationModal,
        stagingAreaMode,
        cloudId
    ]);
    const onStreamAbort = (0, $42omo.useCallback)(()=>{
        setEditorDisabled?.(false);
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'aborted',
            actionSubject: 'smartCreateContent',
            attributes: {
                contentType: contentType,
                contentId: contentId
            }
        });
    }, [
        setEditorDisabled,
        contentId,
        contentType,
        sendAnalyticsEvent
    ]);
    const onStreamTimeout = (0, $42omo.useCallback)(({ streamType: streamType })=>{
        setEditorDisabled?.(false);
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'timeout',
            actionSubject: 'smartCreateContent',
            attributes: {
                contentType: contentType,
                contentId: contentId,
                streamType: streamType
            }
        });
    }, [
        setEditorDisabled,
        contentId,
        contentType,
        sendAnalyticsEvent
    ]);
    const onStreamError = (0, $42omo.useCallback)(({ error: error, streamType: streamType, traceId: traceId })=>{
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('Error in command handler:', error);
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'error',
            actionSubject: 'smartCreateContent',
            attributes: {
                contentType: contentType,
                error: error instanceof Error ? error.message : String(error),
                stack: error instanceof Error && error.stack ? error.stack : undefined,
                streamType: streamType,
                traceId: traceId,
                contentId: contentId
            }
        });
        (0, $4B9iQ.sendAIFCExperienceTrackingToParent)({
            status: 'fail',
            actionType: contentType,
            actionId: contentId,
            contentContext: contentLocation,
            experienceName: (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED,
            error: error instanceof Error ? error.message : String(error)
        });
        if ((0, $9wGTI.fg)('platform_editor_ai_aifc_streaming')) setEditorDisabled?.(false);
    }, [
        contentId,
        contentType,
        contentLocation,
        sendAnalyticsEvent,
        setEditorDisabled
    ]);
    const onStreamRepair = (0, $42omo.useCallback)(({ streamType: streamType, repairs: repairs })=>{
        sendAnalyticsEvent({
            eventType: 'operational',
            actionSubject: 'smartCreateContent',
            action: 'adfRepaired',
            attributes: {
                contentType: contentType,
                contentId: contentId,
                streamType: streamType,
                repairCount: repairs.length,
                // Manually selecting properties to avoid sending UGC
                // in case more properties are added in the future.
                repairs: repairs.map((repair)=>({
                        type: repair.type,
                        from: repair.from,
                        to: repair.to,
                        context: repair.context,
                        expansion: repair.expansion
                    }))
            }
        });
    }, [
        contentId,
        contentType,
        sendAnalyticsEvent
    ]);
    const additionalContext = (0, $42omo.useMemo)(()=>{
        if ((0, $9wGTI.fg)('platform_editor_aifc_in_page_comment')) return async ()=>{
            const more = typeof additionalContextFromProps === 'function' ? await additionalContextFromProps() : additionalContextFromProps;
            return {
                ...more,
                isViewMode: isViewMode
            };
        };
        return {
            isViewMode: isViewMode
        };
    }, [
        isViewMode,
        additionalContextFromProps
    ]);
    const addCommandHandlers = (0, $42omo.useCallback)(({ commandManager: commandManager })=>{
        commandManager.addDefaultCommandHandlers().addCommandHandler((0, $6VfGD.ConfluenceDeepResearchPageCreateCommand), new (0, $e1270e15c69ffc89$export$a7898906d711def9)(commandManager.commandProps)).addCommandHandler((0, $6VfGD.ConfluencePageInitCommand), new (0, $a9ad9677fcca25bd$export$8b2d6af8570e89fc)(commandManager.commandProps)).addCommandHandler((0, $6VfGD.PrepareContentForFinalizationCommand), new (0, $dab8e08b53df3f80$export$1591457cbf726478)(commandManager.commandProps, {
            forceDraftSync: forceDraftSync
        })).addCommandHandler((0, $6VfGD.ConfluenceSubmitPromptOnPageCreateCommand), new (0, $2d58d664ae64ca90$export$60cb93fdd3fa65f9)(commandManager.commandProps, {
            generateAIHeaderImage: generateAIHeaderImage
        }));
    }, [
        forceDraftSync,
        generateAIHeaderImage
    ]);
    (0, $9bbbf468d399974e$export$5203c6a0fdaaa3b)({
        contentLocation: contentLocation,
        contentId: contentId,
        editorAPI: editorAPI,
        addCommandHandlers: addCommandHandlers,
        additionalContext: additionalContext,
        mediaProvider: mediaProvider,
        createMediaProvider: createMediaProvider,
        onUploadImageError: onUploadImageError,
        onStreamStart: onStreamStart,
        onStream: onStream,
        onStreamEnd: onStreamEnd,
        onStreamAbort: onStreamAbort,
        onStreamTimeout: onStreamTimeout,
        onStreamError: onStreamError,
        onStreamRepair: onStreamRepair,
        useGenericEditorSkill: useGenericEditorSkill
    });
};


const $93a541b5565bf74f$var$EditorRovoBridgeCommandListenerImpl = (props)=>{
    (0, $f6e2b5ede1c96960$export$123c48b30e85000)(props);
    return null;
};
const $93a541b5565bf74f$var$RovoBridgeCommandListenerInternal = (props)=>{
    if (!(0, $9wGTI.fg)('aifc_create_enabled')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($93a541b5565bf74f$var$EditorRovoBridgeCommandListenerImpl, props);
};
const $93a541b5565bf74f$export$f25e76eabfc04dee = (0, $7aRa9.withFlags)($93a541b5565bf74f$var$RovoBridgeCommandListenerInternal);
module.exports["RovoBridgeCommandListener"] = $93a541b5565bf74f$export$f25e76eabfc04dee;

});

parcelRegister("9K5In", function(module, exports) {
const $f5dd267bff559452$export$f65ca476c09acec0 = async (editorApi)=>{
    return new Promise((resolve)=>{
        try {
            editorApi.core.actions.requestDocument((doc)=>{
                resolve(doc);
            }, {
                alwaysFire: true
            });
        } catch  {
            resolve(null);
        }
    });
};
function $f5dd267bff559452$export$2da47a16c0b6bcb(doc) {
    if (!doc.content || doc.content.length === 0) return true;
    if (doc.content.length === 1) {
        const node = doc.content[0];
        if (node.type === 'paragraph') {
            if (!node.content || node.content.length === 0) return true;
            return $f5dd267bff559452$var$isOnlyWhitespaceContent(node.content);
        }
        if (node.type === 'heading') {
            if (!node.content || node.content.length === 0) return true;
            return $f5dd267bff559452$var$isOnlyWhitespaceContent(node.content);
        }
    }
    return false;
}
function $f5dd267bff559452$var$isOnlyWhitespaceContent(content) {
    for (const node of content){
        if (node.type === 'text') {
            if (node.text && node.text.trim().length > 0) return false;
        } else return false;
    }
    return true;
}
function $f5dd267bff559452$export$276c2a3f5f3dea14(str, size) {
    const numChunks = Math.ceil(str.length / size);
    const chunks = new Array(numChunks);
    for(let i = 0, o = 0; i < numChunks; ++i, o += size)chunks[i] = str.substring(o, o + size);
    return chunks;
}
module.exports["getDocument"] = $f5dd267bff559452$export$f65ca476c09acec0;
module.exports["isEmptyDocument"] = $f5dd267bff559452$export$2da47a16c0b6bcb;
module.exports["chunkSubstr"] = $f5dd267bff559452$export$276c2a3f5f3dea14;

});

parcelRegister("foVrt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4acD6 = parcelRequire("4acD6");


var $ihTS4 = parcelRequire("ihTS4");


var $jhcFr = parcelRequire("jhcFr");


var $9Tkc6 = parcelRequire("9Tkc6");


var $2Yc46 = parcelRequire("2Yc46");


var $9wGTI = parcelRequire("9wGTI");


var $7QM6o = parcelRequire("7QM6o");


var $bQm3c = parcelRequire("bQm3c");


var $02cx8 = parcelRequire("02cx8");


var $lmEhP = parcelRequire("lmEhP");


var $hfIjM = parcelRequire("hfIjM");

const $820a39291628bd44$var$CARD_OPTIONS = {
    allowDatasource: true
};
const $820a39291628bd44$var$defaultOptions = {
    appearance: 'full-page',
    onFeedbackClicked: ()=>{},
    onReviewStateEntered: ()=>{},
    onExperienceComplete: ()=>{},
    aiGlobalOptIn: {
        status: 'disabled',
        triggerOptInFlow: ()=>{}
    }
};
const $820a39291628bd44$export$ac968d961305af39 = (options)=>{
    const optionsToUse = options || $820a39291628bd44$var$defaultOptions;
    const createEditorPluginAIOptions = (0, $42omo.useMemo)(()=>optionsToUse.appearance === 'page-comment' ? (0, $9Tkc6.createPageCommentEditorPluginAIOptions) : (0, $9Tkc6.createPageEditorPluginAIOptions), [
        optionsToUse.appearance
    ]);
    const optionsToUseRef = (0, $42omo.useRef)(optionsToUse);
    optionsToUseRef.current = optionsToUse;
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    // Memoize session data to avoid recreating the object on every render
    const sessionData = (0, $42omo.useMemo)(()=>userId && cloudId ? {
            userId: userId,
            cloudId: cloudId
        } : undefined, [
        userId,
        cloudId
    ]);
    // Use the dedicated hook for auto-apply state management
    const autoApplyState = (0, $2Yc46.useAutoApplyState)((0, $9wGTI.fg)('enable_auto_apply_toggling') ? sessionData : undefined);
    const isInDocumentStreamingAllowed = (0, $9wGTI.fg)('enable_auto_apply_toggling') ? autoApplyState?.enabled ?? false : false;
    const refresh = autoApplyState?.refresh;
    // Listen for changes from other parts of the app
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('enable_auto_apply_toggling') || !refresh) return;
        const handleAutoApplyChange = ()=>{
            // Refresh the state from backend/localStorage when toggle changes
            refresh();
        };
        window.addEventListener('autoApplyChanged', handleAutoApplyChange);
        return ()=>window.removeEventListener('autoApplyChanged', handleAutoApplyChange);
    }, [
        refresh
    ]);
    // Use a ref to avoid recreating the options object on every state update
    const isInDocumentStreamingAllowedRef = (0, $42omo.useRef)(isInDocumentStreamingAllowed);
    isInDocumentStreamingAllowedRef.current = isInDocumentStreamingAllowed;
    const productConfig = (0, $42omo.useMemo)(()=>({
            product: 'confluence',
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const linkPicker = (0, $jhcFr.useLinkPickerEditorProps)(undefined, productConfig);
    const spaceId = (0, $7QM6o.useSpaceId)();
    const mentionProvider = (0, $hfIjM.useMentionProvider)(spaceId);
    const linkingProp = (0, $lmEhP.useLinkingFeatures)($820a39291628bd44$var$CARD_OPTIONS);
    const PromptEditor = (0, $42omo.useMemo)(()=>(0, $ihTS4.createPromptEditor)({
            linkPicker: linkPicker,
            enableLinks: true,
            linking: linkingProp.linking,
            mentionProvider: mentionProvider,
            featureFlags: {}
        }), [
        linkingProp.linking,
        linkPicker,
        mentionProvider
    ]);
    const editorRovoButtonActions = (0, $02cx8.useEditorRovoButtonActions)();
    const isAISmartButtonEnabled = (0, $42omo.useMemo)(()=>optionsToUse.appearance !== 'page-comment' && optionsToUse.aiGlobalOptIn.status === 'enabled', [
        optionsToUse.appearance,
        optionsToUse.aiGlobalOptIn.status
    ]);
    const { setNudges: setNudges } = (0, $4acD6.useAISmartButtonActions)();
    const aiSmartButtonOptions = (0, $42omo.useMemo)(()=>isAISmartButtonEnabled ? {
            actions: {
                ...editorRovoButtonActions,
                setNudges: setNudges
            }
        } : undefined, [
        isAISmartButtonEnabled,
        editorRovoButtonActions,
        setNudges
    ]);
    return (0, $42omo.useMemo)(()=>{
        return createEditorPluginAIOptions({
            aiGlobalOptIn: optionsToUseRef.current.aiGlobalOptIn,
            /**
			 * Hide AI button in primary toolbar when AI proactive is enabled or
			 * 	when appearance is full-page and AI smart button is enabled
			 */ hidePrimaryToolbarButton: optionsToUse.appearance === 'full-page' && optionsToUse.aiGlobalOptIn.status === 'enabled',
            generativeAIApiUrl: `${window.location.origin}/gateway/api/editor-ai/v1/generative/ai`,
            handleFeedbackSubmission: async (feedbackMetadata)=>{
                try {
                    // TODO: EDF-831: Fix and ensure types match with handleFeedbackSubmission
                    optionsToUseRef.current.onFeedbackClicked?.(feedbackMetadata);
                    return {
                        status: 'submitted'
                    };
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                } catch (error) {
                    return {
                        status: 'failed'
                    };
                }
            },
            onAnnotationsRemoved: (0, $9wGTI.fg)('platform_editor_ai_aifc_streaming') ? optionsToUseRef.current.onAnnotationsRemoved : undefined,
            onExperienceEvent: {
                // Thumbs up and down are being deprecated and are no longer used.
                THUMBS_UP: ()=>{},
                THUMBS_DOWN: ()=>{},
                REVIEW_STATE_ENTERED: ()=>{
                    optionsToUseRef.current.onReviewStateEntered?.();
                },
                EXPERIENCE_COMPLETE: ()=>{
                    optionsToUseRef.current.onExperienceComplete?.();
                }
            },
            onDocChangeByAgent: (_agent)=>{
            // TODO Integrate with confluence
            },
            onAIProviderChanged: (source, aiProvider)=>{
                if (optionsToUseRef.current.onAIProviderChanged) optionsToUseRef.current.onAIProviderChanged(source, aiProvider);
            },
            getUserPreferences: ()=>{
                if (!(0, $9wGTI.fg)('enable_auto_apply_toggling')) return {};
                return {
                    isInDocumentStreamingAllowed: isInDocumentStreamingAllowedRef.current
                };
            },
            getChannelVariables: optionsToUseRef.current.getChannelVariables,
            product: 'CONFLUENCE',
            objectId: optionsToUseRef.current.contentId,
            PromptEditor: PromptEditor,
            AIButtonWrapper: options?.AIButtonWrapper,
            providers: options?.providers,
            /**
			 * Need to audit logs only for confluence page as of now.
			 */ auditLogSettings: optionsToUse.appearance !== 'page-comment' && optionsToUse.contentId ? {
                enabled: true,
                eventData: {
                    type: 'page',
                    pageId: optionsToUse.contentId
                }
            } : {
                enabled: false
            },
            ...isAISmartButtonEnabled && {
                aiSmartButtonOptions: aiSmartButtonOptions
            },
            ...optionsToUse.usePlatformPrompt && {
                onSubmit: ()=>{}
            }
        });
    }, [
        createEditorPluginAIOptions,
        optionsToUse.appearance,
        optionsToUse.contentId,
        PromptEditor,
        options?.AIButtonWrapper,
        options?.providers,
        isAISmartButtonEnabled,
        aiSmartButtonOptions,
        optionsToUse.aiGlobalOptIn.status,
        optionsToUse.usePlatformPrompt
    ]);
};
module.exports["useEditorPluginAIOptions"] = $820a39291628bd44$export$ac968d961305af39;

});

parcelRegister("9Tkc6", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $AMCQl = parcelRequire("AMCQl");

var $bpQiY = parcelRequire("bpQiY");

var $7ShCl = parcelRequire("7ShCl");


var $drPNW = parcelRequire("drPNW");

var $oeZjt = parcelRequire("oeZjt");

var $j398X = parcelRequire("j398X");

var $iulqN = parcelRequire("iulqN");

var $j8LwF = parcelRequire("j8LwF");

var $eugUs = parcelRequire("eugUs");

var $cH4SO = parcelRequire("cH4SO");

var $dLjaJ = parcelRequire("dLjaJ");


var $cbtR4 = parcelRequire("cbtR4");


var $dh538 = parcelRequire("dh538");


var $5SuLc = parcelRequire("5SuLc");


var $42omo = parcelRequire("42omo");








var $3HOqx = parcelRequire("3HOqx");

const $3aec6cdf0df0a4db$export$ced89349fedce38 = ({ size: size = 'medium' } = {})=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
        label: "",
        spacing: "spacious",
        size: size
    });



var $jc4DP = parcelRequire("jc4DP");


var $bwpRs = parcelRequire("bwpRs");

const $27f50db3f6ad9211$export$683185be8e4be56f = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).BRAINSTORM,
        title: (0, $AMCQl.aiConfigItemMessages).brainstormTitle,
        description: (0, $AMCQl.aiConfigItemMessages).brainstormDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3aec6cdf0df0a4db$export$ced89349fedce38), null),
        promptLabel: (0, $AMCQl.aiConfigItemMessages).brainstormPromptLabel,
        promptHint: (0, $AMCQl.aiConfigItemMessages).brainstormPromptHint,
        doNotHighlightDocWhenSelectionIsEmpty: true,
        agentId: 'editor_agent',
        intentSchemaId: 'brainstorm_intent_schema.json',
        featureId: 'brainstorm',
        alwaysNoDocAndSelection: true,
        actions: {
            empty: [
                (0, $jc4DP.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $27f50db3f6ad9211$export$dddd8d441293ae3 = (options)=>({
        config: $27f50db3f6ad9211$export$683185be8e4be56f(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 0
            },
            selection: {
                enabled: false
            }
        }
    });



var $l5nYy = parcelRequire("l5nYy");








var $cUQMr = parcelRequire("cUQMr");







const $42e6feb7d3869fde$var$intentSchemaId = 'convert_to_bullet_points.json';
const $42e6feb7d3869fde$export$c791aa34bcfdf607 = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).CONVERT_TO_BULLETED_LIST,
        title: (0, $AMCQl.aiConfigItemMessages).convertToBulletListTitle,
        description: (0, $AMCQl.aiConfigItemMessages).convertToBulletListDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), {
                label: "",
                spacing: "spacious"
            }),
        statusLozengeType: 'beta',
        intentSchemaId: $42e6feb7d3869fde$var$intentSchemaId,
        actions: {
            selection: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ]
        }
    });
const $42e6feb7d3869fde$export$37c986c539d0ca07 = (options)=>({
        config: $42e6feb7d3869fde$export$c791aa34bcfdf607(options),
        triggers: {
            empty: {
                enabled: false
            },
            selection: {
                enabled: true
            }
        }
    });









var $4ymSL = parcelRequire("4ymSL");







const $db220b5201a1bbd7$var$intentSchemaId = 'convert_to_table.json';
const $db220b5201a1bbd7$export$a7ada90d2d2877a7 = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).CONVERT_TO_TABLE,
        title: (0, $AMCQl.aiConfigItemMessages).convertToTableTitle,
        description: (0, $AMCQl.aiConfigItemMessages).convertToTableDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ymSL))), {
                label: "",
                spacing: "spacious"
            }),
        statusLozengeType: 'beta',
        intentSchemaId: $db220b5201a1bbd7$var$intentSchemaId,
        actions: {
            selection: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ]
        }
    });
const $db220b5201a1bbd7$export$d67616d0b45ccf63 = (options)=>({
        config: $db220b5201a1bbd7$export$a7ada90d2d2877a7(options),
        triggers: {
            empty: {
                enabled: false
            },
            selection: {
                enabled: true
            }
        }
    });



var $iBSwI = parcelRequire("iBSwI");












var $c6GJD = parcelRequire("c6GJD");

const $63b70a897e24cdc6$export$cd87ff8f4335648e = ()=>{
    const getExperimentValue = (0, $c6GJD.default).getExperimentValue;
    const variation = getExperimentValue('platform_editor_ai-prompts-placeholder', 'cohort', 'not-enrolled');
    if (variation !== 'control' && variation !== 'not-enrolled') {
        const label = getExperimentValue('platform_editor_ai-prompts-placeholder', 'label', '');
        const description = getExperimentValue('platform_editor_ai-prompts-placeholder', 'description', '');
        const intent = getExperimentValue('platform_editor_ai-prompts-placeholder', 'intent', '');
        const listOrder = getExperimentValue('platform_editor_ai-prompts-placeholder', 'list_order', 0);
        const analyticsExperienceName = getExperimentValue('platform_editor_ai-prompts-placeholder', 'analytics_experience_name', '');
        // The follow are optional backwards compatible properties which can be configured in the experiment
        const showOnEmpty = getExperimentValue('platform_editor_ai-prompts-placeholder', 'show_on_empty_page', true);
        const statusType = getExperimentValue('platform_editor_ai-prompts-placeholder', 'prompt_status_type', '');
        if (label && description && intent && analyticsExperienceName) return {
            label: {
                id: label,
                description: label,
                defaultMessage: label
            },
            description: {
                id: description,
                description: description,
                defaultMessage: description
            },
            intent: intent,
            listOrder: listOrder,
            analyticsExperienceName: analyticsExperienceName,
            showOnEmpty: showOnEmpty,
            statusType: statusType
        };
    }
};


const $84071a294f2874db$export$6cd03141a939166d = ()=>{
    const configurations = (0, $63b70a897e24cdc6$export$cd87ff8f4335648e)();
    if (configurations) {
        const statusLozengeType = configurations.statusType.toLowerCase() === 'new' || configurations.statusType.toLowerCase() === 'beta' ? configurations.statusType.toLowerCase() : undefined;
        return {
            ...configurations,
            configItem: {
                key: (0, $bwpRs.CONFIG_ITEM_KEYS).EXPERIMENTAL_PROMPT_PLACEHOLDER,
                title: configurations.label,
                description: configurations.description,
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3aec6cdf0df0a4db$export$ced89349fedce38), null),
                statusLozengeType: statusLozengeType,
                intentSchemaId: configurations.intent,
                actions: {
                    empty: [
                        (0, $jc4DP.createInsertAtCurrentPosition)({
                            appearance: 'secondary'
                        }),
                        (0, $jc4DP.createInsertAtTop)({
                            appearance: 'primary'
                        })
                    ],
                    selection: [
                        (0, $jc4DP.createInsertBelow)({
                            appearance: 'secondary'
                        }),
                        (0, $jc4DP.createReplace)({
                            appearance: 'primary'
                        })
                    ]
                },
                getBackendModel: ()=>{
                    return 'assistance-service';
                }
            }
        };
    }
};
const $84071a294f2874db$export$d991dc90761ce2a0 = ()=>{
    const res = $84071a294f2874db$export$6cd03141a939166d();
    if (res) {
        const { configItem: configItem, ...others } = res;
        return {
            configItemWithOptions: {
                config: configItem,
                triggers: {
                    empty: {
                        enabled: true,
                        docMinSize: 1
                    },
                    selection: {
                        enabled: true
                    }
                }
            },
            ...others
        };
    }
};












var $54tpX = parcelRequire("54tpX");

const $c28ec1426b832604$export$6eebfc33bd4f687b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($54tpX))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });








const $3e2ed2d891be3ae7$export$acf0f0fea45f23f0 = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).FIND_ACTION_ITEMS,
        title: (0, $AMCQl.aiConfigItemMessages).findActionItemsTitle,
        description: (0, $AMCQl.aiConfigItemMessages).findActionItemsDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c28ec1426b832604$export$6eebfc33bd4f687b), null),
        intentSchemaId: 'action_items_intent_schema.json',
        featureId: 'find_action_items',
        actions: {
            empty: [
                (0, $jc4DP.createInsertAtTop)({
                    appearance: 'secondary'
                }),
                (0, $jc4DP.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $jc4DP.createInsertAtTop)({
                    appearance: 'secondary'
                }),
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'primary',
                    factoryOptions: options
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $3e2ed2d891be3ae7$export$8edb35f92492e5cd = (options)=>({
        config: $3e2ed2d891be3ae7$export$acf0f0fea45f23f0(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });






var $SFzFl = parcelRequire("SFzFl");




const $3502234323631fdc$export$28052871323f977f = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).FREE_GENERATE_AIFC,
        // This is to avoid StateMachine `guard` check
        title: {
            id: 'free-generate-aifc-title',
            defaultMessage: 'Free Generate AIFC'
        },
        description: (0, $SFzFl.default).aiUniversalLongCallToAction,
        promptHint: (0, $AMCQl.aiConfigItemMessages).freeGeneratePromptHint,
        adfPrompt: true,
        doNotHighlightDocWhenSelectionIsEmpty: true,
        insertOnEmptySelection: true,
        intentSchemaId: 'custom_free_generate_intent_schema.json',
        actions: {},
        getBackendModel: ()=>'aifc-bridge'
    });



var $i5NyM = parcelRequire("i5NyM");


var $2KJU8 = parcelRequire("2KJU8");


var $96Uu5 = parcelRequire("96Uu5");


var $kOMDA = parcelRequire("kOMDA");


var $70Lwl = parcelRequire("70Lwl");


var $iipo1 = parcelRequire("iipo1");


var $6PN31 = parcelRequire("6PN31");


var $8vIZB = parcelRequire("8vIZB");


var $klIiV = parcelRequire("klIiV");

const $34183cfe058a8bad$export$fa98ce94fc01fa17 = {
    brainstormConfigItem: (0, $27f50db3f6ad9211$export$683185be8e4be56f)(),
    freeGenerateAifcConfigItem: (0, $3502234323631fdc$export$28052871323f977f)()
};
function $34183cfe058a8bad$var$getDynamicSurfaceConfigItems(opts) {
    const dynamicSurfaceConfigItems = [
        // Only brainstorm, suggest title and find action items are enabled for empty
        {
            config: (0, $iBSwI.improveWriting)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $iBSwI.fixSpellingAndGrammar)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToProfessional)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToEmpathetic)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToCasual)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToEducational)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $96Uu5.makeShorter)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $2KJU8.makeLonger)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        (0, $kOMDA.addPolishWithOptions)(opts),
        // Convert to table and bullet list are already on enabled for selection
        (0, $42e6feb7d3869fde$export$37c986c539d0ca07)(opts),
        (0, $db220b5201a1bbd7$export$d67616d0b45ccf63)(opts),
        (0, $3e2ed2d891be3ae7$export$8edb35f92492e5cd)(opts),
        (0, $70Lwl.suggestTitleForConfluenceTitleToolbarWithOptions)(opts),
        {
            config: (0, $iipo1.summarizeWriting)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        ...(0, $6PN31.translationConfigItemWithOptionsEnabledForSelectionOnly)(opts)
    ];
    // Fix this const name after team 25 with platform_editor_ai_aifc_streaming being cleaned up
    const dynamicSurfaceConfigItemsTeam25 = [
        {
            config: (0, $iBSwI.improveWriting)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        ...(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? [
            (0, $kOMDA.addPolishWithOptions)(opts)
        ] : [],
        {
            config: (0, $iBSwI.fixSpellingAndGrammar)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToCasual)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToEmpathetic)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToProfessional)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $96Uu5.makeShorter)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $2KJU8.makeLonger)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        ...!(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? [
            (0, $kOMDA.addPolishWithOptions)(opts)
        ] : [],
        ...(0, $6PN31.translationConfigItemWithOptionsEnabledForSelectionOnly)(opts)
    ];
    return opts.isInDocumentStreamingEnabled ? dynamicSurfaceConfigItemsTeam25 : dynamicSurfaceConfigItems;
}
const $34183cfe058a8bad$export$25814a113f71ded2 = (props)=>{
    const { editorView: editorView, configItem: configItem } = props;
    const openAIModalCommand = (0, $5SuLc.createOpenAIModalCommand)({
        state: editorView.state,
        configItem: configItem,
        lastTriggeredFrom: 'triggerConfigItem',
        aiGlobalOptIn: {
            status: 'enabled',
            triggerOptInFlow: ()=>{}
        }
    });
    openAIModalCommand(editorView.state, editorView.dispatch);
};
function $34183cfe058a8bad$export$15d114523124a386(options) {
    /**
   * Not abstracting these defaults up, in order to be explicit about possible
   * different behaviours between page comment and page editors.
   */ // Now deprecated - migrate to handleFeedbackSubmission
    const onExperienceEvent = options.onExperienceEvent || {
        THUMBS_UP: ()=>{},
        THUMBS_DOWN: ()=>{},
        REVIEW_STATE_ENTERED: ()=>{},
        EXPERIENCE_COMPLETE: ()=>{}
    };
    function getConfigItems(opts) {
        const list = [
            (0, $l5nYy.changeToneToProfessionalWithOptions)(opts),
            (0, $iipo1.summarizeWritingWithOptions)(opts),
            (0, $iBSwI.improveWritingWithOptions)(opts),
            (0, $iBSwI.fixSpellingAndGrammarWithOptions)(opts),
            (0, $96Uu5.makeShorterWithOptions)(opts),
            (0, $2KJU8.makeLongerWithOptions)(opts),
            (0, $42e6feb7d3869fde$export$37c986c539d0ca07)(opts),
            (0, $db220b5201a1bbd7$export$d67616d0b45ccf63)(opts),
            (0, $70Lwl.suggestTitleWithOptions)(opts),
            (0, $l5nYy.changeToneToEmpatheticWithOptions)(opts),
            (0, $l5nYy.changeToneToCasualWithOptions)(opts),
            (0, $l5nYy.changeToneToEducationalWithOptions)(opts),
            ...(0, $6PN31.translationConfigItemWithOptions)(opts)
        ];
        const experimentalPromptPlaceholderData = (0, $84071a294f2874db$export$d991dc90761ce2a0)();
        if (experimentalPromptPlaceholderData) {
            const { listOrder: listOrder, configItemWithOptions: configItemWithOptions } = experimentalPromptPlaceholderData;
            list.splice(listOrder, 0, configItemWithOptions);
        }
        return list;
    }
    const product = options.product ? options.product : 'CONFLUENCE';
    const isInDocumentStreamingEnabled = options.isInDocumentStreamingEnabled ?? (0, $dh538.fg)('platform_editor_ai_aifc_streaming');
    return {
        aiGlobalOptIn: options.aiGlobalOptIn,
        baseGenerate: (0, $i5NyM.freeGenerate)(),
        configItemWithOptions: getConfigItems({
            product: product,
            isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
        }),
        disableAISelectionToolbar: true,
        product: product,
        objectId: options.objectId,
        getFetchCustomHeaders: options.getFetchCustomHeaders || (0, $klIiV._getFetchCustomHeaders),
        onExperienceEvent: onExperienceEvent,
        handleFeedbackSubmission: options.handleFeedbackSubmission,
        AIButtonWrapper: options.AIButtonWrapper,
        PromptEditor: options.PromptEditor,
        providers: options.providers,
        auditLogSettings: options.auditLogSettings,
        /**
     * Below options are added to use rovo agent behind the scenes for free generate.
     *
     * Need to load rovo agents, so getChannelVariables and isRovoEnabled is set.
     * showRovoAgentsInCommandPalette will disable showing Rovo agents section.
     * useFreeGenerateEditorAgent will swap standard free generate prompt with
     * 	rovo agent enabled free generate after agents are loaded.
     * If loading agents fails, then fallback to standard free generate.
     */ getChannelVariables: options.getChannelVariables,
        isRovoEnabled: options.isRovoEnabled ?? true,
        showRovoAgentsInCommandPalette: options.showRovoAgentsInCommandPalette ?? false,
        useFreeGenerateEditorAgent: options.useFreeGenerateEditorAgent ?? true,
        onSubmit: options.onSubmit,
        onAnnotationsRemoved: options.onAnnotationsRemoved,
        getUserPreferences: options.getUserPreferences,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
    };
}
const $34183cfe058a8bad$export$b2747cd26144b27d = (options)=>{
    /**
   * Not abstracting these defaults up, in order to be explicit about possible
   * different behaviours between page comment and page editors.
   */ // Now deprecated - migrate to handleFeedbackSubmission
    const onExperienceEvent = options.onExperienceEvent || {
        THUMBS_UP: ()=>{},
        THUMBS_DOWN: ()=>{},
        REVIEW_STATE_ENTERED: ()=>{},
        EXPERIENCE_COMPLETE: ()=>{}
    };
    function getConfigItems(opts) {
        const list = [
            (0, $l5nYy.changeToneToProfessionalWithOptions)(opts),
            (0, $iipo1.summarizeWritingWithOptions)(opts),
            (0, $iBSwI.improveWritingWithOptions)(opts),
            (0, $iBSwI.fixSpellingAndGrammarWithOptions)(opts),
            (0, $96Uu5.makeShorterWithOptions)(opts),
            (0, $2KJU8.makeLongerWithOptions)(opts),
            (0, $42e6feb7d3869fde$export$37c986c539d0ca07)(opts),
            (0, $db220b5201a1bbd7$export$d67616d0b45ccf63)(opts),
            (0, $3e2ed2d891be3ae7$export$8edb35f92492e5cd)(opts),
            (0, $70Lwl.suggestTitleWithOptions)(opts),
            (0, $l5nYy.changeToneToEmpatheticWithOptions)(opts),
            (0, $l5nYy.changeToneToCasualWithOptions)(opts),
            (0, $l5nYy.changeToneToEducationalWithOptions)(opts),
            (0, $kOMDA.addPolishWithOptions)(opts),
            ...(0, $6PN31.translationConfigItemWithOptions)(opts)
        ];
        const newListOrder = [
            (0, $iBSwI.fixSpellingAndGrammarWithOptions)(opts),
            (0, $l5nYy.changeToneToProfessionalWithOptions)(opts),
            (0, $96Uu5.makeShorterWithOptions)(opts),
            (0, $iipo1.summarizeWritingWithOptions)(opts),
            (0, $iBSwI.improveWritingWithOptions)(opts),
            (0, $2KJU8.makeLongerWithOptions)(opts),
            (0, $42e6feb7d3869fde$export$37c986c539d0ca07)(opts),
            (0, $db220b5201a1bbd7$export$d67616d0b45ccf63)(opts),
            (0, $3e2ed2d891be3ae7$export$8edb35f92492e5cd)(opts),
            (0, $70Lwl.suggestTitleWithOptions)(opts),
            (0, $l5nYy.changeToneToEmpatheticWithOptions)(opts),
            (0, $l5nYy.changeToneToCasualWithOptions)(opts),
            (0, $l5nYy.changeToneToEducationalWithOptions)(opts),
            (0, $kOMDA.addPolishWithOptions)(opts),
            ...(0, $6PN31.translationConfigItemWithOptions)(opts)
        ];
        const experimentalPromptPlaceholderData = (0, $84071a294f2874db$export$d991dc90761ce2a0)();
        if (experimentalPromptPlaceholderData && !opts.isInDocumentStreamingEnabled) {
            const { listOrder: listOrder, configItemWithOptions: configItemWithOptions } = experimentalPromptPlaceholderData;
            list.splice(listOrder, 0, configItemWithOptions);
        }
        return opts.isInDocumentStreamingEnabled ? newListOrder : list;
    }
    const product = options.product ? options.product : 'CONFLUENCE';
    const isInDocumentStreamingEnabled = options.isInDocumentStreamingEnabled ?? (0, $dh538.fg)('platform_editor_ai_aifc_streaming');
    const configItemOptions = {
        product: product,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
    };
    return {
        aiGlobalOptIn: options.aiGlobalOptIn,
        baseGenerate: (0, $i5NyM.freeGenerate)(configItemOptions),
        configItemWithOptions: getConfigItems(configItemOptions),
        getSelectionToolbarDropdowns () {
            const selectionToolbarOptions = [
                {
                    id: 'change-tone',
                    label: (0, $7ShCl.aiMessages).confluenceChangeToneSelectionToolbarDropdownMenuTitle,
                    options: [
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).changeToneProfessionalToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $l5nYy.changeToneToProfessional)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).changeToneEmpatheticToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $l5nYy.changeToneToEmpathetic)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).changeToneCasualToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $l5nYy.changeToneToCasual)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).changeToneNeutralToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $l5nYy.changeToneToNeutral)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).changeToneEducationalToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $l5nYy.changeToneToEducational)(configItemOptions)
                        }
                    ]
                },
                {
                    id: 'rewrite',
                    label: (0, $7ShCl.aiMessages).confluenceRewriteSelectionToolbarDropdownMenuTitle,
                    options: [
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).improveWritingSelectionToolbarDropdownItemTitle,
                            configItem: (0, $iBSwI.improveWriting)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).fixSpellingGrammarSelectionToolbarDropdownItemTitle,
                            configItem: (0, $iBSwI.fixSpellingAndGrammar)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).summarizeWritingSelectionToolbarDropdownItemTitle,
                            configItem: (0, $iipo1.summarizeWriting)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).makeShorterSelectionToolbarDropdownItemTitle,
                            configItem: (0, $96Uu5.makeShorter)(configItemOptions)
                        }
                    ]
                }
            ];
            const translationConfigItemsMap = (0, $6PN31.createTranslationConfigItems)(configItemOptions);
            const translateOptions = (0, $8vIZB.getSortedSupportedTranslationLanguages)().map((language)=>{
                const label = (0, $bpQiY.aiLanguageMessages)[language];
                return {
                    label: label,
                    configItem: translationConfigItemsMap[language]
                };
            });
            selectionToolbarOptions.push({
                id: 'translate',
                label: (0, $7ShCl.aiMessages).confluenceTranslateSelectionToolbarDropdownMenuTitle,
                options: translateOptions
            });
            return selectionToolbarOptions;
        },
        disableAISelectionToolbar: false,
        hidePrimaryToolbarButton: isInDocumentStreamingEnabled ? false : options.hidePrimaryToolbarButton,
        product: product,
        objectId: options.objectId,
        getFetchCustomHeaders: options.getFetchCustomHeaders || (0, $klIiV._getFetchCustomHeaders),
        getChannelVariables: options.getChannelVariables,
        onDocChangeByAgent: options.onDocChangeByAgent,
        onAIProviderChanged: options.onAIProviderChanged,
        onExperienceEvent: onExperienceEvent,
        handleFeedbackSubmission: options.handleFeedbackSubmission,
        AIButtonWrapper: options.AIButtonWrapper,
        PromptEditor: options.PromptEditor,
        disableInterrogation: options.disableInterrogation ?? false,
        aiUsageDisclaimer: options.aiUsageDisclaimer,
        isRovoEnabled: options.isRovoEnabled ?? true,
        /**
     * Below options are added because;
     * - Show rovo agents in command palette.
     */ showRovoAgentsInCommandPalette: options.showRovoAgentsInCommandPalette ?? true,
        providers: options.providers,
        auditLogSettings: options.auditLogSettings,
        aiSmartButtonOptions: options.aiSmartButtonOptions,
        heroConfigItem: isInDocumentStreamingEnabled ? (0, $iBSwI.improveWritingWithOptions)(configItemOptions) : undefined,
        ...options.aiGlobalOptIn.status === 'enabled' && (0, $dh538.fg)('ai-smart-button-team-25') && {
            dynamicSurfaceConfigItems: $34183cfe058a8bad$var$getDynamicSurfaceConfigItems(configItemOptions)
        },
        onAnnotationsRemoved: options.onAnnotationsRemoved,
        getUserPreferences: options.getUserPreferences,
        onSubmit: options.onSubmit,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
    };
};
const $34183cfe058a8bad$export$679d027153aa30cf = (editorApi)=>{
    const onActionClick = (configItem)=>{
        return ()=>{
            editorApi.aiExperience?.actions.openAIModal({
                invokedFrom: 'objectSidebar',
                configItem: configItem
            });
        };
    };
    const configItemOptions = {
        product: 'CONFLUENCE',
        isInDocumentStreamingEnabled: (0, $dh538.fg)('platform_editor_ai_aifc_streaming')
    };
    const changeToneActionItems = [
        {
            title: (0, $7ShCl.aiMessages).moreProfessionalToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($oeZjt))),
            onClick: onActionClick((0, $l5nYy.changeToneToProfessional)(configItemOptions))
        },
        {
            title: (0, $7ShCl.aiMessages).moreCasualToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($j398X))),
            onClick: onActionClick((0, $l5nYy.changeToneToCasual)(configItemOptions))
        },
        {
            title: (0, $7ShCl.aiMessages).moreEmpatheticToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($j8LwF))),
            onClick: onActionClick((0, $l5nYy.changeToneToEmpathetic)(configItemOptions))
        }
    ];
    const adjustLengthActionItems = [
        {
            title: (0, $7ShCl.aiMessages).makeShorterToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cH4SO))),
            onClick: onActionClick((0, $96Uu5.makeShorter)(configItemOptions))
        },
        {
            title: (0, $7ShCl.aiMessages).makeLongerToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($eugUs))),
            onClick: onActionClick((0, $2KJU8.makeLonger)(configItemOptions))
        }
    ];
    const objectSideBarButtons = [
        {
            title: (0, $7ShCl.aiMessages).spellingAndGrammarToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dLjaJ))),
            onClick: onActionClick((0, $iBSwI.fixSpellingAndGrammar)(configItemOptions))
        },
        {
            title: (0, $7ShCl.aiMessages).changeToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iulqN))),
            subItems: changeToneActionItems
        },
        {
            title: (0, $7ShCl.aiMessages).adjustLengthToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($drPNW))),
            subItems: adjustLengthActionItems
        },
        {
            title: (0, $AMCQl.aiConfigItemMessages).addPolishTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cbtR4))),
            onClick: onActionClick((0, $kOMDA.addPolish)(configItemOptions))
        }
    ];
    return objectSideBarButtons;
};
module.exports["UNSTABLE_configItems"] = $34183cfe058a8bad$export$fa98ce94fc01fa17;
module.exports["createPageCommentEditorPluginAIOptions"] = $34183cfe058a8bad$export$15d114523124a386;
module.exports["createPageEditorPluginAIOptions"] = $34183cfe058a8bad$export$b2747cd26144b27d;
module.exports["getEditorActionsForObjectSidebar"] = $34183cfe058a8bad$export$679d027153aa30cf;

});

parcelRegister("a37Yb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");





var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $iXCQx = parcelRequire("iXCQx");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");

var $8tIbq = parcelRequire("8tIbq");


var $fT2ta = parcelRequire("fT2ta");


var $cO1el = parcelRequire("cO1el");


var $eiA8Z = parcelRequire("eiA8Z");


var $lsxnT = parcelRequire("lsxnT");


var $bPDOf = parcelRequire("bPDOf");


var $ivb8S = parcelRequire("ivb8S");




const $3da6770d1388bea2$var$i18n = (0, $cgtv4.defineMessages)({
    AIStreamingSpotlightTitle: {
        id: "onboarding-ai-first-create.ai-streaming.spotlight.title",
        defaultMessage: "View changes or undo"
    },
    AIStreamingSpotlightDescription: {
        id: "onboarding-ai-first-create.ai-streamin.spotlight.description",
        defaultMessage: "Compare your edits and Rovo\u2019s to a prior version and undo if needed."
    },
    AIStreamingSpotlightCTA: {
        id: "onboarding-ai-first-create.ai-streamin.spotlight.cta",
        defaultMessage: "OK"
    }
});
const $3da6770d1388bea2$export$cdcb27ae41cfd474 = ({ children: children, editorAPIRef: editorAPIRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $42omo.useState)(false);
    const [streamingState, setStreamingState] = (0, $42omo.useState)('initial');
    const { isStreaming: isStreaming, isShowDiffAvailable: isShowDiffAvailable } = (0, $eiA8Z.useSharedPluginStateWithSelector)(editorAPIRef?.current, [
        'aiExperience',
        'trackChanges'
    ], (states)=>{
        return {
            isStreaming: states?.aiExperienceState?.isStreaming,
            isShowDiffAvailable: states?.trackChangesState?.isShowDiffAvailable
        };
    });
    (0, $42omo.useEffect)(()=>{
        if (isStreaming) {
            if (streamingState === 'initial') setStreamingState('streaming');
        } else if (streamingState === 'streaming' && isShowDiffAvailable) setStreamingState('completed');
        else setStreamingState('initial');
    }, [
        isStreaming,
        isShowDiffAvailable,
        streamingState
    ]);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        ...Object.values((0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS))
    ], !(0, $9wGTI.fg)('cc_aifc_ai_streaming_spotlight') || !(0, $9wGTI.fg)('aifc_create_enabled'));
    const { hasSeenTrackChangesStreamingSpotlight: hasSeenTrackChangesStreamingSpotlight } = (0, $ivb8S.deserializeState)(data);
    const handleSpotlightStart = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS).hasSeenTrackChangesStreamingSpotlight,
            value: 'true'
        });
        setIsSpotlightActive(true);
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'AIStreamingSpotlight',
                attributes: {
                    source: 'onboarding-ai-first-create'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        setOnboardingState
    ]);
    const handleSpotlightStop = (0, $42omo.useCallback)(()=>{
        setIsSpotlightActive(false);
    }, []);
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const aiStreamingSpotlightChoreographer = useChoreographer('AIStreamingSpotlight', {
        start: handleSpotlightStart,
        stop: handleSpotlightStop
    });
    const handleSpotlightInteraction = (0, $42omo.useCallback)((action, actionSubject, actionSubjectIdSuffix)=>{
        setIsSpotlightActive(false);
        aiStreamingSpotlightChoreographer.stopMessage();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: `AIStreamingSpotlight${actionSubjectIdSuffix ?? ''}`,
                source: 'onboarding-ai-first-create'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        aiStreamingSpotlightChoreographer
    ]);
    const handleOnClick = (0, $42omo.useCallback)(()=>{
        handleSpotlightInteraction('clicked', 'button', 'CTA');
    }, [
        handleSpotlightInteraction
    ]);
    const handleOnDismiss = (0, $42omo.useCallback)(()=>{
        handleSpotlightInteraction('clicked', 'button', 'Dismiss');
    }, [
        handleSpotlightInteraction
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!loading && !error && !hasSeenTrackChangesStreamingSpotlight && !isStreaming && isShowDiffAvailable && streamingState === 'completed' && (0, $9wGTI.fg)('cc_aifc_ai_streaming_spotlight')) aiStreamingSpotlightChoreographer.startMessage();
    }, [
        loading,
        error,
        hasSeenTrackChangesStreamingSpotlight,
        aiStreamingSpotlightChoreographer,
        isStreaming,
        isShowDiffAvailable,
        streamingState
    ]);
    if (!isSpotlightActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8tIbq.UNSAFE_UpdateOnChange), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        dismiss: handleOnDismiss,
        isVisible: isSpotlightActive,
        placement: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        entranceDirection: "left"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
            testId: "ai-streaming-spotlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            as: "span",
            size: "small"
        }, formatMessage($3da6770d1388bea2$var$i18n.AIStreamingSpotlightTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($3da6770d1388bea2$var$i18n.AIStreamingSpotlightDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
            onClick: handleOnClick
        }, formatMessage($3da6770d1388bea2$var$i18n.AIStreamingSpotlightCTA)))))))));
};


const $10850ba042c4d830$export$8476ffec3fa9a1c6 = ({ editorAPIRef: editorAPIRef })=>{
    const pluginOptions = (0, $42omo.useMemo)(()=>{
        if (!(0, $9wGTI.fg)('cc_aifc_ai_streaming_spotlight')) return {};
        return {
            ButtonWrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3da6770d1388bea2$export$cdcb27ae41cfd474), {
                    editorAPIRef: editorAPIRef
                }, children)
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        pluginOptions: pluginOptions
    };
};
module.exports["useTrackChangesPlugin"] = $10850ba042c4d830$export$8476ffec3fa9a1c6;

});

parcelRegister("84Iqc", function(module, exports) {

var $6tl2G = parcelRequire("6tl2G");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $cO9ey = parcelRequire("cO9ey");


var $ftzrq = parcelRequire("ftzrq");

// eslint-disable-next-line @atlassian/tangerine/import/entry-points

var $a4TK8 = parcelRequire("a4TK8");


var $2XqLN = parcelRequire("2XqLN");


var $6rMOj = parcelRequire("6rMOj");


var $2pjJ5 = parcelRequire("2pjJ5");





var $9YoeD = parcelRequire("9YoeD");


var $aXG5V = parcelRequire("aXG5V");

const $295ce6c80dd2e5a4$var$filterUndefined = (x)=>!!x;
// Currently allow attributes that indicats a change in media image
const $295ce6c80dd2e5a4$var$allowedAttrs = [
    'id',
    'collection',
    'url'
];
const $295ce6c80dd2e5a4$export$34445edbbb29aecb = (doc, steps)=>{
    return steps.map((step)=>{
        if (step instanceof (0, $aXG5V.AttrStep) && $295ce6c80dd2e5a4$var$allowedAttrs.includes(step.attr) || step instanceof (0, $9YoeD.SetAttrsStep) && step.attrs && [
            ...Object.keys(step.attrs)
        ].some((v)=>$295ce6c80dd2e5a4$var$allowedAttrs.includes(v))) {
            const $pos = doc.resolve(step.pos);
            if ($pos.parent.type === doc.type.schema.nodes.mediaSingle) {
                const startPos = $pos.pos + $pos.parentOffset;
                return {
                    fromB: startPos,
                    toB: startPos + $pos.parent.nodeSize - 1
                };
            }
        }
        return undefined;
    }).filter($295ce6c80dd2e5a4$var$filterUndefined);
};
const $295ce6c80dd2e5a4$export$78b37f7430a7646c = (step, beforeDoc, afterDoc)=>{
    try {
        if (step instanceof (0, $aXG5V.AttrStep) || step instanceof (0, $9YoeD.SetAttrsStep)) {
            const attrStepAfter = afterDoc.nodeAt(step.pos);
            const attrStepBefore = beforeDoc.nodeAt(step.pos);
            // The change affected the document
            if (attrStepAfter && attrStepBefore && !attrStepAfter.eq(attrStepBefore)) return true;
        }
        return false;
    } catch (e) {
        return false;
    }
};



var $24P9d = parcelRequire("24P9d");





var $dh538 = parcelRequire("dh538");





var $808tb = parcelRequire("808tb");





const $56ac3b5fb8d3a4d7$export$4be2f4158e5479e9 = (0, $24P9d.convertToInlineCss)({
    borderLeft: `2px solid ${"var(--ds-border-accent-gray, #7D818A)"}`
});
const $56ac3b5fb8d3a4d7$export$a26de8170ba89016 = (0, $24P9d.convertToInlineCss)({
    marginTop: "var(--ds-space-150, 12px)",
    paddingTop: "var(--ds-space-025, 2px)",
    paddingBottom: "var(--ds-space-025, 2px)",
    paddingLeft: "var(--ds-space-025, 2px)",
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $56ac3b5fb8d3a4d7$export$781ad9e3e3929b91 = (0, $24P9d.convertToInlineCss)({
    marginTop: "var(--ds-space-150, 12px)",
    paddingTop: "var(--ds-space-025, 2px)",
    paddingBottom: "var(--ds-space-025, 2px)",
    paddingLeft: "var(--ds-space-025, 2px)",
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $56ac3b5fb8d3a4d7$export$2b892754935ecdf0 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $56ac3b5fb8d3a4d7$export$2881f0731c48e52 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $56ac3b5fb8d3a4d7$export$95d973a7458c1194 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $56ac3b5fb8d3a4d7$export$4d45bc5137e495cf = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $56ac3b5fb8d3a4d7$var$lozengeStyle = (0, $24P9d.convertToInlineCss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    position: 'static',
    blockSize: 'min-content',
    borderRadius: "var(--ds-radius-small, 4px)",
    overflow: 'hidden',
    paddingInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 653)",
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: "var(--ds-text-warning-inverse, #292A2E)"
});
const $56ac3b5fb8d3a4d7$export$d22dbdfe71f2ad25 = (nodeName, colourScheme)=>{
    const isTraditional = colourScheme === 'traditional';
    switch(nodeName){
        case 'blockquote':
            return (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? isTraditional ? $56ac3b5fb8d3a4d7$export$781ad9e3e3929b91 : $56ac3b5fb8d3a4d7$export$a26de8170ba89016 : $56ac3b5fb8d3a4d7$export$4be2f4158e5479e9;
        case 'expand':
        case 'decisionList':
            return isTraditional && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? $56ac3b5fb8d3a4d7$export$2881f0731c48e52 : $56ac3b5fb8d3a4d7$export$2b892754935ecdf0;
        case 'panel':
        case 'codeBlock':
            return isTraditional && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? $56ac3b5fb8d3a4d7$export$4d45bc5137e495cf : $56ac3b5fb8d3a4d7$export$95d973a7458c1194;
        default:
            return undefined;
    }
};
const $56ac3b5fb8d3a4d7$export$70c259518319d790 = (nodeName)=>{
    switch(nodeName){
        case 'expand':
        case 'codeBlock':
        case 'mediaSingle':
        case 'panel':
        case 'decisionList':
            return true;
        case 'embedCard':
        case 'blockquote':
            return (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers');
        default:
            return false;
    }
};
const $56ac3b5fb8d3a4d7$export$27f77745f9d2a9d3 = (nodeName)=>{
    switch(nodeName){
        case 'mediaSingle':
        case 'embedCard':
            return true;
        case 'blockquote':
            return (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers');
        default:
            return false;
    }
};
const $56ac3b5fb8d3a4d7$export$ed15446970dd2546 = (nodeName)=>{
    return nodeName === 'heading' || nodeName === 'blockquote' && !(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers');
};
const $56ac3b5fb8d3a4d7$export$7e94a71f2afbef46 = (intl, nodeName)=>{
    const container = document.createElement('span');
    let borderTopRightRadius;
    if ([
        'expand',
        'decisionList'
    ].includes(nodeName || '')) borderTopRightRadius = "var(--ds-radius-small, 4px)";
    else if ([
        'panel',
        'codeBlock',
        'mediaSingle'
    ].includes(nodeName || '')) borderTopRightRadius = `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`;
    const containerStyle = (0, $24P9d.convertToInlineCss)({
        position: 'absolute',
        top: (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? "var(--ds-space-075, 6px)" : "var(--ds-space-0, 0px)",
        right: (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? "var(--ds-space-075, 6px)" : "var(--ds-space-0, 0px)",
        zIndex: 2,
        pointerEvents: 'none',
        display: 'flex',
        ...!(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? {
            overflow: 'hidden',
            borderTopRightRadius: borderTopRightRadius
        } : {}
    });
    container.setAttribute('style', containerStyle);
    container.setAttribute('data-testid', 'show-diff-removed-lozenge');
    // Create vanilla HTML lozenge element with Atlaskit Lozenge styling (visual refresh)
    const lozengeElement = document.createElement('span');
    lozengeElement.setAttribute('style', $56ac3b5fb8d3a4d7$var$lozengeStyle);
    lozengeElement.textContent = intl.formatMessage((0, $808tb.trackChangesMessages).removed).toUpperCase();
    container.appendChild(lozengeElement);
    return container;
};
const $56ac3b5fb8d3a4d7$export$5b1e956de560c1c8 = ()=>{
    const wrapper = document.createElement('div');
    const baseStyle = (0, $24P9d.convertToInlineCss)({
        position: 'relative',
        display: 'block',
        opacity: 1
    });
    wrapper.setAttribute('style', baseStyle);
    return wrapper;
};
const $56ac3b5fb8d3a4d7$export$f4f691d3bcec255 = (colourScheme)=>{
    const wrapper = document.createElement('span');
    wrapper.setAttribute('style', (0, $3dc8b0bd0fe77648$export$e981ebd97f4ac3fc)(colourScheme));
    return wrapper;
};
const $56ac3b5fb8d3a4d7$export$98e90fe61e416ef5 = (element, targetNode, colourScheme)=>{
    const currentStyle = element.getAttribute('style') || '';
    const deletedContentStyle = (0, $3dc8b0bd0fe77648$export$e981ebd97f4ac3fc)(colourScheme);
    const nodeSpecificStyle = $56ac3b5fb8d3a4d7$export$d22dbdfe71f2ad25(targetNode.type.name, colourScheme) || '';
    element.setAttribute('style', `${currentStyle}${deletedContentStyle}${nodeSpecificStyle}`);
};
const $56ac3b5fb8d3a4d7$export$a9f129b53cfeba21 = (nodeView, targetNode, colourScheme)=>{
    const contentWrapper = document.createElement('div');
    const nodeStyle = $56ac3b5fb8d3a4d7$export$d22dbdfe71f2ad25(targetNode.type.name, colourScheme);
    contentWrapper.setAttribute('style', `${(0, $3dc8b0bd0fe77648$export$e981ebd97f4ac3fc)(colourScheme)}${nodeStyle || ''}`);
    contentWrapper.append(nodeView);
    return contentWrapper;
};
const $56ac3b5fb8d3a4d7$export$1de4fbcdb1cd74f8 = (dom, nodeView, targetNode, lozenge, colourScheme)=>{
    if (targetNode.type.name !== 'embedCard' || !(nodeView instanceof HTMLElement)) return false;
    const richMediaItem = nodeView.querySelector('.rich-media-item');
    if (richMediaItem instanceof HTMLElement) richMediaItem.appendChild(lozenge);
    else {
        const observer = new MutationObserver((_, obs)=>{
            const loadedRichMedia = nodeView.querySelector('.rich-media-item');
            if (loadedRichMedia instanceof HTMLElement) {
                loadedRichMedia.appendChild(lozenge);
                obs.disconnect();
            }
        });
        observer.observe(nodeView, {
            childList: true,
            subtree: true
        });
    }
    if ($56ac3b5fb8d3a4d7$export$27f77745f9d2a9d3(targetNode.type.name)) {
        const showDiffDeletedNodeClass = colourScheme === 'traditional' ? 'show-diff-deleted-node-traditional' : 'show-diff-deleted-node';
        nodeView.classList.add(showDiffDeletedNodeClass);
    }
    dom.append(nodeView);
    return true;
};
const $56ac3b5fb8d3a4d7$export$29cfe496bdd27d2a = (dom, nodeView, targetNode, lozenge, colourScheme)=>{
    if (targetNode.type.name !== 'mediaSingle' || !(nodeView instanceof HTMLElement)) return false;
    const mediaNode = nodeView.querySelector('[data-prosemirror-node-name="media"]');
    if (!mediaNode || !(mediaNode instanceof HTMLElement)) return false;
    // Add relative positioning to media node to anchor lozenge
    const currentStyle = mediaNode.getAttribute('style') || '';
    const relativePositionStyle = (0, $24P9d.convertToInlineCss)({
        position: 'relative'
    });
    mediaNode.setAttribute('style', `${currentStyle}${relativePositionStyle}`);
    mediaNode.append(lozenge);
    // Add deleted node class if needed
    if ($56ac3b5fb8d3a4d7$export$27f77745f9d2a9d3(targetNode.type.name)) {
        const showDiffDeletedNodeClass = colourScheme === 'traditional' && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? 'show-diff-deleted-node-traditional' : 'show-diff-deleted-node';
        nodeView.classList.add(showDiffDeletedNodeClass);
    }
    dom.append(nodeView);
    return true;
};
const $56ac3b5fb8d3a4d7$export$a6d5dd7a5e2cb70d = (dom, nodeView, targetNode, colourScheme, intl)=>{
    const blockWrapper = $56ac3b5fb8d3a4d7$export$5b1e956de560c1c8();
    if ($56ac3b5fb8d3a4d7$export$70c259518319d790(targetNode.type.name)) {
        const lozenge = $56ac3b5fb8d3a4d7$export$7e94a71f2afbef46(intl);
        if ($56ac3b5fb8d3a4d7$export$1de4fbcdb1cd74f8(dom, nodeView, targetNode, lozenge, colourScheme) && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) return;
        if ($56ac3b5fb8d3a4d7$export$29cfe496bdd27d2a(dom, nodeView, targetNode, lozenge, colourScheme)) return;
        blockWrapper.append(lozenge);
    }
    const contentWrapper = $56ac3b5fb8d3a4d7$export$a9f129b53cfeba21(nodeView, targetNode, colourScheme);
    blockWrapper.append(contentWrapper);
    if (nodeView instanceof HTMLElement && $56ac3b5fb8d3a4d7$export$27f77745f9d2a9d3(targetNode.type.name)) {
        const showDiffDeletedNodeClass = colourScheme === 'traditional' && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? 'show-diff-deleted-node-traditional' : 'show-diff-deleted-node';
        nodeView.classList.add(showDiffDeletedNodeClass);
    }
    dom.append(blockWrapper);
};
const $56ac3b5fb8d3a4d7$export$f5e827fa766eb13e = (dom, nodeView, targetNode, colourScheme, intl)=>{
    if ($56ac3b5fb8d3a4d7$export$ed15446970dd2546(targetNode.type.name) && nodeView instanceof HTMLElement) {
        // Apply deleted styles directly to preserve natural block-level margins
        $56ac3b5fb8d3a4d7$export$98e90fe61e416ef5(nodeView, targetNode, colourScheme);
        dom.append(nodeView);
    } else // Use wrapper approach for other block nodes
    $56ac3b5fb8d3a4d7$export$a6d5dd7a5e2cb70d(dom, nodeView, targetNode, colourScheme, intl);
};









var $8m4tT = parcelRequire("8m4tT");





var $LmqWp = parcelRequire("LmqWp");




function $3ac82b36c61b257d$export$c531c54bff461ffa(doc, pos, slice) {
    if (pos > doc.content.size) return doc.content.size;
    let $pos = doc.resolve(pos);
    while(!(0, $8m4tT.canInsert)($pos, slice.content) && slice.content.firstChild?.type.name !== 'paragraph'){
        if ($pos.pos + 1 > doc.content.size) break;
        $pos = doc.resolve($pos.pos + 1);
    }
    return $pos.pos;
}


const $a1720879622e745c$var$deletedRowStyle = (0, $24P9d.convertToInlineCss)({
    color: "var(--ds-text-accent-gray, #505258)",
    textDecoration: 'line-through',
    opacity: 0.6,
    display: 'table-row'
});
const $a1720879622e745c$var$deletedTraditionalRowStyle = (0, $24P9d.convertToInlineCss)({
    textDecorationColor: "var(--ds-border-accent-red, #E2483D)",
    textDecoration: 'line-through',
    opacity: 0.6,
    display: 'table-row'
});
/**
 * Extracts information about deleted table rows from a change
 */ const $a1720879622e745c$var$extractDeletedRows = (change, originalDoc, newDoc)=>{
    const deletedRows = [];
    // Find the table in the original document
    const $fromPos = originalDoc.resolve(change.fromA);
    const tableOld = (0, $8m4tT.findParentNodeClosestToPos)($fromPos, (node)=>node.type.name === 'table');
    if (!tableOld) return deletedRows;
    const oldTableMap = (0, $LmqWp.TableMap).get(tableOld.node);
    // Find the table in the new document at the insertion point
    const $newPos = newDoc.resolve(change.fromB);
    const tableNew = (0, $8m4tT.findParentNodeClosestToPos)($newPos, (node)=>node.type.name === 'table');
    if (!tableNew) return deletedRows;
    const newTableMap = (0, $LmqWp.TableMap).get(tableNew.node);
    // If no rows were deleted, return empty
    if (oldTableMap.height <= newTableMap.height || // For now ignore if there are column deletions as well
    oldTableMap.width !== newTableMap.width) return deletedRows;
    // Find which rows were deleted by analyzing the change range
    const changeStartInTable = change.fromA - tableOld.pos - 1;
    const changeEndInTable = change.toA - tableOld.pos - 1;
    let currentOffset = 0;
    let rowIndex = 0;
    tableOld.node.content.forEach((rowNode, index)=>{
        const rowStart = currentOffset;
        const rowEnd = currentOffset + rowNode.nodeSize;
        // Check if this row overlaps with the deletion range
        const rowOverlapsChange = rowStart >= changeStartInTable && rowStart < changeEndInTable || rowEnd > changeStartInTable && rowEnd <= changeEndInTable || rowStart < changeStartInTable && rowEnd > changeEndInTable;
        if (rowOverlapsChange && rowNode.type.name === 'tableRow' && !$a1720879622e745c$var$isEmptyRow(rowNode)) {
            const startOfRow = newTableMap.mapByRow.slice().reverse().find((row)=>row[0] + tableNew.pos < change.fromB && change.fromB < row[row.length - 1] + tableNew.pos);
            deletedRows.push({
                rowIndex: rowIndex,
                rowNode: rowNode,
                fromA: tableOld.pos + 1 + rowStart,
                toA: tableOld.pos + 1 + rowEnd,
                fromB: startOfRow ? startOfRow[0] + tableNew.start : change.fromB
            });
        }
        currentOffset += rowNode.nodeSize;
        if (rowNode.type.name === 'tableRow') rowIndex++;
    });
    // Filter changes that never truly got deleted
    return deletedRows.filter((deletedRow)=>{
        return !tableNew.node.children.some((newRow)=>(0, $2pjJ5.areNodesEqualIgnoreAttrs)(newRow, deletedRow.rowNode));
    });
};
/**
 * Checks if a table row is empty (contains no meaningful content)
 */ const $a1720879622e745c$var$isEmptyRow = (rowNode)=>{
    let isEmpty = true;
    rowNode.descendants((node)=>{
        if (!isEmpty) return false;
        // If we find any inline content with size > 0, the row is not empty
        if (node.isInline && node.nodeSize > 0) {
            isEmpty = false;
            return false;
        }
        // If we find text content, the row is not empty
        if (node.isText && node.text && node.text.trim() !== '') {
            isEmpty = false;
            return false;
        }
        return true;
    });
    return isEmpty;
};
/**
 * Creates a DOM representation of a deleted table row
 */ const $a1720879622e745c$var$createDeletedRowDOM = (rowNode, nodeViewSerializer, colourScheme)=>{
    const tr = document.createElement('tr');
    tr.setAttribute('style', colourScheme === 'traditional' ? $a1720879622e745c$var$deletedTraditionalRowStyle : $a1720879622e745c$var$deletedRowStyle);
    tr.setAttribute('data-testid', 'show-diff-deleted-row');
    // Serialize each cell in the row
    rowNode.content.forEach((cellNode)=>{
        if (cellNode.type.name === 'tableCell' || cellNode.type.name === 'tableHeader') {
            const nodeView = nodeViewSerializer.tryCreateNodeView(cellNode);
            if (nodeView) tr.appendChild(nodeView);
            else {
                // Fallback to fragment serialization
                const serializedContent = nodeViewSerializer.serializeFragment(cellNode.content);
                if (serializedContent) tr.appendChild(serializedContent);
            }
        }
    });
    return tr;
};
/**
 * Expands a diff to include whole deleted rows when table rows are affected
 */ const $a1720879622e745c$var$expandDiffForDeletedRows = (changes, originalDoc, newDoc)=>{
    const deletedRowInfo = [];
    for (const change of changes){
        // Check if this change affects table content
        const deletedRows = $a1720879622e745c$var$extractDeletedRows(change, originalDoc, newDoc);
        if (deletedRows.length > 0) deletedRowInfo.push(...deletedRows);
    }
    return deletedRowInfo;
};
const $a1720879622e745c$export$ad8852400818e745 = ({ deletedRows: deletedRows, originalDoc: originalDoc, newDoc: newDoc, nodeViewSerializer: nodeViewSerializer, colourScheme: colourScheme })=>{
    return deletedRows.map((deletedRow)=>{
        const rowDOM = $a1720879622e745c$var$createDeletedRowDOM(deletedRow.rowNode, nodeViewSerializer, colourScheme);
        // Find safe insertion position for the deleted row
        const safeInsertPos = (0, $3ac82b36c61b257d$export$c531c54bff461ffa)(newDoc, deletedRow.fromB - 1, // -1 to find the first safe position from the table
        originalDoc.slice(deletedRow.fromA, deletedRow.toA));
        return (0, $ftzrq.Decoration).widget(safeInsertPos, rowDOM, {});
    });
};
const $a1720879622e745c$export$50cf234bf9fce100 = (changes, originalDoc, newDoc, nodeViewSerializer, colourScheme)=>{
    // First, expand the changes to include complete deleted rows
    const deletedRows = $a1720879622e745c$var$expandDiffForDeletedRows(changes.filter((change)=>change.deleted.length > 0), originalDoc, newDoc);
    const allDecorations = $a1720879622e745c$export$ad8852400818e745({
        deletedRows: deletedRows,
        originalDoc: originalDoc,
        newDoc: newDoc,
        nodeViewSerializer: nodeViewSerializer,
        colourScheme: colourScheme
    });
    return {
        decorations: allDecorations
    };
};



const $3dc8b0bd0fe77648$var$editingStyle = (0, $24P9d.convertToInlineCss)({
    background: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-border-accent-purple, #AF59E1)"
});
const $3dc8b0bd0fe77648$var$traditionalInsertStyle = (0, $24P9d.convertToInlineCss)({
    background: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textDecoration: 'underline',
    textDecorationStyle: 'solid',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-border-accent-green, #22A06B)"
});
const $3dc8b0bd0fe77648$export$69543ba6b110e31c = (change, colourScheme)=>(0, $ftzrq.Decoration).inline(change.fromB, change.toB, {
        style: colourScheme === 'traditional' ? $3dc8b0bd0fe77648$var$traditionalInsertStyle : $3dc8b0bd0fe77648$var$editingStyle,
        'data-testid': 'show-diff-changed-decoration'
    }, {});
const $3dc8b0bd0fe77648$var$getEditorStyleNode = (nodeName, colourScheme)=>{
    switch(nodeName){
        case 'blockquote':
            return colourScheme === 'traditional' ? $3dc8b0bd0fe77648$var$traditionalStyleQuoteNode : $3dc8b0bd0fe77648$var$editingStyleQuoteNode;
        case 'mediaSingle':
        case 'mediaGroup':
        case 'table':
        case 'tableRow':
        case 'tableCell':
        case 'tableHeader':
            return undefined;
        // Handle table separately to avoid border issues
        case 'paragraph':
        case 'heading':
        case 'hardBreak':
            return undefined;
        // Paragraph and heading nodes do not need special styling
        case 'decisionList':
        case 'taskList':
        case 'taskItem':
        case 'bulletList':
        case 'orderedList':
            return undefined;
        case 'extension':
        case 'embedCard':
        case 'listItem':
            return (0, $24P9d.convertToInlineCss)({
                '--diff-decoration-marker-color': colourScheme === 'traditional' ? "var(--ds-border-accent-green, #22A06B)" : "var(--ds-border-accent-purple, #AF59E1)"
            });
        case 'layoutSection':
            return undefined;
        // Layout nodes do not need special styling
        case 'rule':
            return colourScheme === 'traditional' ? $3dc8b0bd0fe77648$var$traditionalStyleRuleNode : $3dc8b0bd0fe77648$var$editingStyleRuleNode;
        case 'blockCard':
            return colourScheme === 'traditional' ? $3dc8b0bd0fe77648$var$traditionalStyleCardBlockNode : $3dc8b0bd0fe77648$var$editingStyleCardBlockNode;
        default:
            return colourScheme === 'traditional' ? $3dc8b0bd0fe77648$var$traditionalStyleNode : $3dc8b0bd0fe77648$var$editingStyleNode;
    }
};
const $3dc8b0bd0fe77648$var$editingStyleQuoteNode = (0, $24P9d.convertToInlineCss)({
    borderLeft: `2px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`
});
const $3dc8b0bd0fe77648$var$traditionalStyleQuoteNode = (0, $24P9d.convertToInlineCss)({
    borderLeft: `2px solid ${"var(--ds-border-accent-green, #22A06B)"}`
});
const $3dc8b0bd0fe77648$var$editingStyleRuleNode = (0, $24P9d.convertToInlineCss)({
    backgroundColor: "var(--ds-border-accent-purple, #AF59E1)"
});
const $3dc8b0bd0fe77648$var$traditionalStyleRuleNode = (0, $24P9d.convertToInlineCss)({
    backgroundColor: "var(--ds-border-accent-green, #22A06B)"
});
const $3dc8b0bd0fe77648$var$editingStyleNode = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $3dc8b0bd0fe77648$var$traditionalStyleNode = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-green, #22A06B)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $3dc8b0bd0fe77648$var$editingStyleCardBlockNode = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    borderRadius: "var(--ds-radius-medium, 6px)"
});
const $3dc8b0bd0fe77648$var$traditionalStyleCardBlockNode = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-green, #22A06B)"}`,
    borderRadius: "var(--ds-radius-medium, 6px)"
});
const $3dc8b0bd0fe77648$var$deletedContentStyle = (0, $24P9d.convertToInlineCss)({
    color: "var(--ds-text-accent-gray, #505258)",
    textDecoration: 'line-through',
    position: 'relative',
    opacity: 0.6
});
const $3dc8b0bd0fe77648$var$deletedContentStyleNew = (0, $24P9d.convertToInlineCss)({
    color: "var(--ds-text-accent-gray, #505258)",
    textDecoration: 'line-through',
    position: 'relative',
    opacity: 0.8
});
const $3dc8b0bd0fe77648$var$deletedContentStyleUnbounded = (0, $24P9d.convertToInlineCss)({
    position: 'absolute',
    top: '50%',
    width: '100%',
    display: 'inline-block',
    borderTop: `1px solid ${"var(--ds-text-accent-gray, #505258)"}`,
    pointerEvents: 'none',
    zIndex: 1
});
const $3dc8b0bd0fe77648$var$deletedTraditionalContentStyle = (0, $24P9d.convertToInlineCss)({
    textDecorationColor: "var(--ds-border-accent-red, #E2483D)",
    textDecoration: 'line-through',
    position: 'relative',
    opacity: 1
});
const $3dc8b0bd0fe77648$var$deletedTraditionalContentStyleUnbounded = (0, $24P9d.convertToInlineCss)({
    position: 'absolute',
    top: '50%',
    width: '100%',
    display: 'inline-block',
    borderTop: `1px solid ${"var(--ds-border-accent-red, #E2483D)"}`,
    pointerEvents: 'none',
    zIndex: 1
});
const $3dc8b0bd0fe77648$export$8482edbd6aeab6ec = (colourScheme)=>colourScheme === 'traditional' ? $3dc8b0bd0fe77648$var$deletedTraditionalContentStyleUnbounded : $3dc8b0bd0fe77648$var$deletedContentStyleUnbounded;
const $3dc8b0bd0fe77648$export$e981ebd97f4ac3fc = (colourScheme)=>colourScheme === 'traditional' ? $3dc8b0bd0fe77648$var$deletedTraditionalContentStyle : (0, $dh538.fg)('platform_editor_jan_a11y_fixes') ? $3dc8b0bd0fe77648$var$deletedContentStyleNew : $3dc8b0bd0fe77648$var$deletedContentStyle;
const $3dc8b0bd0fe77648$var$getNodeClass = (name)=>{
    switch(name){
        case 'extension':
            return 'show-diff-changed-decoration-node';
        default:
            return undefined;
    }
};
const $3dc8b0bd0fe77648$export$8df64513a6dc1f2a = (change, colourScheme)=>(0, $ftzrq.Decoration).node(change.from, change.to, {
        style: $3dc8b0bd0fe77648$var$getEditorStyleNode(change.name, colourScheme),
        'data-testid': 'show-diff-changed-decoration-node',
        class: $3dc8b0bd0fe77648$var$getNodeClass(change.name)
    }, {});
const $3dc8b0bd0fe77648$export$afefde4fd21bcada = ({ change: change, doc: doc, nodeViewSerializer: nodeViewSerializer, colourScheme: colourScheme, newDoc: newDoc, intl: intl })=>{
    const slice = doc.slice(change.fromA, change.toA);
    if (slice.content.content.length === 0) return;
    const isTableCellContent = slice.content.content.some(()=>slice.content.content.some((siblingNode)=>[
                'tableHeader',
                'tableCell'
            ].includes(siblingNode.type.name)));
    const isTableRowContent = slice.content.content.some(()=>slice.content.content.some((siblingNode)=>[
                'tableRow'
            ].includes(siblingNode.type.name)));
    if (isTableCellContent) return;
    if (isTableRowContent) {
        if (!(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) return;
        const { decorations: decorations } = (0, $a1720879622e745c$export$50cf234bf9fce100)([
            change
        ], doc, newDoc, nodeViewSerializer, colourScheme);
        return decorations;
    }
    const serializer = nodeViewSerializer;
    // For non-table content, use the existing span wrapper approach
    const dom = document.createElement('span');
    /*
   * The thinking is we separate out the fragment we got from doc.slice
   * and if it's the first or last content, we go in however many the sliced Open
   * or sliced End depth is and match only the entire node.
   */ slice.content.forEach((node)=>{
        // Create a wrapper for each node with strikethrough
        const createWrapperWithStrikethrough = ()=>{
            const wrapper = document.createElement('span');
            const baseStyle = (0, $24P9d.convertToInlineCss)({
                position: 'relative',
                width: 'fit-content'
            });
            wrapper.setAttribute('style', `${baseStyle}${$3dc8b0bd0fe77648$export$e981ebd97f4ac3fc(colourScheme)}`);
            const strikethrough = document.createElement('span');
            strikethrough.setAttribute('style', $3dc8b0bd0fe77648$export$8482edbd6aeab6ec(colourScheme));
            wrapper.append(strikethrough);
            return wrapper;
        };
        // Helper function to handle multiple child nodes
        const handleMultipleChildNodes = (node)=>{
            if (node.content.childCount > 1 && node.type.inlineContent) {
                node.content.forEach((childNode)=>{
                    const childNodeView = serializer.tryCreateNodeView(childNode);
                    if (childNodeView) {
                        const lineBreak = document.createElement('br');
                        targetNode = node;
                        dom.append(lineBreak);
                        const wrapper = createWrapperWithStrikethrough();
                        wrapper.append(childNodeView);
                        dom.append(wrapper);
                    } else {
                        // Fallback to serializing the individual child node
                        const serializedChild = serializer.serializeNode(childNode);
                        if (serializedChild) {
                            const wrapper = createWrapperWithStrikethrough();
                            wrapper.append(serializedChild);
                            dom.append(wrapper);
                        }
                    }
                });
                return true; // Indicates we handled multiple children
            }
            return false; // Indicates single child, continue with normal logic
        };
        // Determine which node to use and how to serialize
        const isFirst = slice.content.firstChild === node;
        const isLast = slice.content.lastChild === node;
        const hasInlineContent = node.content.childCount > 0 && node.type.inlineContent === true;
        let targetNode;
        let fallbackSerialization;
        if ((isFirst || isLast && slice.content.childCount > 2) && hasInlineContent) {
            if (handleMultipleChildNodes(node)) return;
            targetNode = node;
            fallbackSerialization = ()=>serializer.serializeFragment(node.content);
        } else if (isLast && slice.content.childCount === 2) {
            if (handleMultipleChildNodes(node)) return;
            targetNode = node;
            fallbackSerialization = ()=>{
                if (node.type.name === 'text') return document.createTextNode(node.text || '');
                if (node.type.name === 'paragraph') {
                    const lineBreak = document.createElement('br');
                    dom.append(lineBreak);
                    return serializer.serializeFragment(node.content);
                }
                return serializer.serializeFragment(node.content);
            };
        } else {
            if (handleMultipleChildNodes(node)) return;
            targetNode = node;
            fallbackSerialization = ()=>serializer.serializeNode(node);
        }
        // Try to create node view, fallback to serialization
        const nodeView = serializer.tryCreateNodeView(targetNode);
        if (nodeView) {
            if (targetNode.isInline) {
                const wrapper = createWrapperWithStrikethrough();
                wrapper.append(nodeView);
                dom.append(wrapper);
            } else // Handle all block nodes with unified function
            (0, $56ac3b5fb8d3a4d7$export$f5e827fa766eb13e)(dom, nodeView, targetNode, colourScheme, intl);
        } else if (nodeViewSerializer.getFilteredNodeViewBlocklist([
            'paragraph',
            'tableRow'
        ]).has(targetNode.type.name)) // Skip the case where the node is a paragraph or table row that way it can still be rendered and delete the entire table
        return;
        else {
            const fallbackNode = fallbackSerialization();
            if (fallbackNode) {
                const wrapper = (0, $56ac3b5fb8d3a4d7$export$f4f691d3bcec255)(colourScheme);
                wrapper.append(fallbackNode);
                dom.append(wrapper);
            }
        }
    });
    dom.setAttribute('data-testid', 'show-diff-deleted-decoration');
    // Widget decoration used for deletions as the content is not in the document
    // and we want to display the deleted content with a style.
    const safeInsertPos = (0, $3ac82b36c61b257d$export$c531c54bff461ffa)(newDoc, change.fromB, slice);
    return [
        (0, $ftzrq.Decoration).widget(safeInsertPos, dom)
    ];
};





const $17b314da77ea36bc$var$filterUndefined = (x)=>!!x;
const $17b314da77ea36bc$export$cb37e032b0f65b99 = (steps)=>{
    return steps.map((step)=>{
        if (step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep)) return {
            fromB: step.from,
            toB: step.to
        };
        return undefined;
    }).filter($17b314da77ea36bc$var$filterUndefined);
};



var $jy7VG = parcelRequire("jy7VG");










/**
 * Attempts to merge two consecutive ReplaceStep operations.
 * This merges steps where:
 * - Both steps replace content at the same starting position
 * - The second step's range encompasses the first step's range
 * - The second step has content to insert
 * Returns null if steps cannot be merged.
 */ function $77c34b4e3d11b0db$var$mergeReplaceSteps(step1, step2) {
    if (!(step1 instanceof (0, $aXG5V.ReplaceStep)) || !(step2 instanceof (0, $aXG5V.ReplaceStep))) return null;
    // Confirm the step overlaps exactly with the previous
    const step2Length = step2.to - step2.from;
    if (step1.from === step2.from && step2.to >= step1.to && step2.slice.size >= step2Length && step2Length === step1.slice.size && step2.slice.size >= step1.slice.size && step1.slice.openEnd === step2.slice.openEnd && step1.slice.openStart === step2.slice.openStart) return new (0, $aXG5V.ReplaceStep)(step1.from, step1.to, step2.slice);
    return null;
}
function $77c34b4e3d11b0db$export$320ba57788df881b(steps, originalDoc) {
    const stepsToFilter = (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? $77c34b4e3d11b0db$var$removeUnusedSteps(steps, originalDoc) : steps;
    return stepsToFilter// Remove steps that don't affect document structure or content
    .filter((step)=>!(step instanceof (0, $jy7VG.AnalyticsStep)))// Merge consecutive steps where possible
    .reduce((acc, step)=>{
        const lastStep = acc[acc.length - 1];
        const merged = (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? lastStep?.merge?.(step) ?? $77c34b4e3d11b0db$var$mergeReplaceSteps(lastStep, step) : lastStep?.merge?.(step);
        if (merged) acc[acc.length - 1] = merged;
        else acc.push(step);
        return acc;
    }, []);
}
/**
 * Does a first pass to remove steps that don't impact the document
 */ function $77c34b4e3d11b0db$var$removeUnusedSteps(steps, originalDoc) {
    const finalSteps = [];
    let firstPassDoc = originalDoc;
    for (const step of steps){
        const result = step.apply(firstPassDoc);
        if (result.failed === null && result.doc && !(0, $2pjJ5.areNodesEqualIgnoreAttrs)(firstPassDoc, result.doc, [
            'localId'
        ])) {
            finalSteps.push(step);
            firstPassDoc = result.doc;
        }
    }
    return finalSteps;
}


const $6a1dd0c85e18c1ea$var$calculateNodesForBlockDecoration = (doc, from, to, colourScheme)=>{
    const decorations = [];
    // Iterate over the document nodes within the range
    doc.nodesBetween(from, to, (node, pos)=>{
        if (node.isBlock) decorations.push((0, $3dc8b0bd0fe77648$export$8df64513a6dc1f2a)({
            from: pos,
            to: pos + node.nodeSize,
            name: node.type.name
        }, colourScheme));
    });
    return decorations;
};
/**
 * Groups adjacent changes to reduce visual fragmentation in diffs.
 * Merges consecutive insertions and deletions that are close together.
 */ function $6a1dd0c85e18c1ea$var$optimizeChanges(changes) {
    if (changes.length <= 1) return changes;
    const optimized = [];
    let current = {
        ...changes[0]
    };
    for(let i = 1; i < changes.length; i++){
        const next = changes[i];
        // Check if changes are adjacent or very close (within 2 positions)
        const isAdjacent = next.fromB <= current.toB + 2;
        if (isAdjacent) current = {
            fromA: current.fromA,
            toA: Math.max(current.toA, next.toA),
            fromB: current.fromB,
            toB: Math.max(current.toB, next.toB),
            deleted: [
                ...current.deleted,
                ...next.deleted
            ],
            inserted: [
                ...current.inserted,
                ...next.inserted
            ]
        };
        else {
            optimized.push(current);
            current = {
                ...next
            };
        }
    }
    optimized.push(current);
    return optimized;
}
const $6a1dd0c85e18c1ea$var$calculateDiffDecorationsInner = ({ state: state, pluginState: pluginState, nodeViewSerializer: nodeViewSerializer, colourScheme: colourScheme, intl: intl })=>{
    const { originalDoc: originalDoc, steps: steps } = pluginState;
    if (!originalDoc || !pluginState.isDisplayingChanges) return (0, $ftzrq.DecorationSet).empty;
    const { tr: tr } = state;
    let steppedDoc = originalDoc;
    const attrSteps = [];
    const simplifiedSteps = (0, $77c34b4e3d11b0db$export$320ba57788df881b)(steps, originalDoc);
    const stepMaps = [];
    for (const step of simplifiedSteps){
        const result = step.apply(steppedDoc);
        if (result.failed === null && result.doc) {
            if ((0, $295ce6c80dd2e5a4$export$78b37f7430a7646c)(step, steppedDoc, result.doc)) attrSteps.push(step);
            stepMaps.push(step.getMap());
            steppedDoc = result.doc;
        }
    }
    // Rather than using .eq() we use a custom function that only checks for structural
    // changes and ignores differences in attributes which don't affect decoration positions
    if (!(0, $2pjJ5.areNodesEqualIgnoreAttrs)(steppedDoc, tr.doc)) return (0, $ftzrq.DecorationSet).empty;
    const changeset = (0, $6rMOj.ChangeSet).create(originalDoc).addSteps(steppedDoc, stepMaps, tr.doc);
    const changes = (0, $6rMOj.simplifyChanges)(changeset.changes, tr.doc);
    const optimizedChanges = $6a1dd0c85e18c1ea$var$optimizeChanges(changes);
    const decorations = [];
    optimizedChanges.forEach((change)=>{
        if (change.inserted.length > 0) {
            decorations.push((0, $3dc8b0bd0fe77648$export$69543ba6b110e31c)(change, colourScheme));
            decorations.push(...$6a1dd0c85e18c1ea$var$calculateNodesForBlockDecoration(tr.doc, change.fromB, change.toB, colourScheme));
        }
        if (change.deleted.length > 0) {
            const decoration = (0, $3dc8b0bd0fe77648$export$afefde4fd21bcada)({
                change: change,
                doc: originalDoc,
                nodeViewSerializer: nodeViewSerializer,
                colourScheme: colourScheme,
                newDoc: tr.doc,
                intl: intl
            });
            if (decoration) decorations.push(...decoration);
        }
    });
    (0, $17b314da77ea36bc$export$cb37e032b0f65b99)(steps).forEach((change)=>{
        decorations.push((0, $3dc8b0bd0fe77648$export$69543ba6b110e31c)(change, colourScheme));
    });
    (0, $295ce6c80dd2e5a4$export$34445edbbb29aecb)(tr.doc, attrSteps).forEach((change)=>{
        decorations.push(...$6a1dd0c85e18c1ea$var$calculateNodesForBlockDecoration(tr.doc, change.fromB, change.toB, colourScheme));
    });
    return (0, $ftzrq.DecorationSet).empty.add(tr.doc, decorations);
};
const $6a1dd0c85e18c1ea$export$aa7cf3ccfb5d875f = (0, $2XqLN.default)($6a1dd0c85e18c1ea$var$calculateDiffDecorationsInner, // Cache results unless relevant inputs change
([{ pluginState: pluginState, state: state, colourScheme: colourScheme, intl: intl }], [{ pluginState: lastPluginState, state: lastState, colourScheme: lastColourScheme, intl: lastIntl }])=>{
    const originalDocIsSame = lastPluginState.originalDoc && pluginState.originalDoc && pluginState.originalDoc.eq(lastPluginState.originalDoc);
    return (originalDocIsSame && (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(pluginState.steps, lastPluginState.steps) && state.doc.eq(lastState.doc) && colourScheme === lastColourScheme && intl.locale === lastIntl.locale) ?? false;
});



var $5SAOw = parcelRequire("5SAOw");

function $e9d15807b524bec2$export$42cf4389dbe8b0ff(view) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return view.nodeViews !== undefined;
}
class $e9d15807b524bec2$export$314a8d5cfa8a18e6 {
    /**
   * Initializes or reinitializes the NodeViewSerializer with a new EditorView.
   * This allows the same serializer instance to be reused across different editor states.
   */ init(params) {
        this.serializer = (0, $5SAOw.DOMSerializer).fromSchema(params.editorView.state.schema);
        if ($e9d15807b524bec2$export$42cf4389dbe8b0ff(params.editorView)) this.editorView = params.editorView;
        const nodeViews = // eslint-disable-next-line @typescript-eslint/no-explicit-any
        params.editorView?.nodeViews || {};
        this.nodeViews = nodeViews ?? this.editorView?.nodeViews ?? {};
    }
    /**
   * Appends serialized child nodes to the given contentDOM element.
   */ appendChildNodes(children, contentDOM) {
        children.forEach((child)=>{
            const childNode = this.tryCreateNodeView(child) || this.serializeNode(child);
            if (childNode) contentDOM?.append(childNode);
        });
    }
    /**
   * Attempts to create a node view for the given node.
   *
   * Returns `null` when there is no `EditorView`, no constructor for the node type,
   * or the node type is blocklisted. Otherwise returns the constructed node view instance.
   */ tryCreateNodeView(targetNode) {
        if (!this.editorView) return null;
        const constructor = this.nodeViews?.[targetNode.type.name];
        if (this.nodeViewBlocklist.has(targetNode.type.name)) return null;
        try {
            if (!constructor) {
                if (targetNode.isInline) return null;
                const toDOMResult = targetNode.type.spec.toDOM?.(targetNode);
                if (!toDOMResult) return null;
                const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, toDOMResult);
                if (dom instanceof HTMLElement) {
                    if (targetNode.type.name === 'paragraph' && targetNode.children.length === 1) return this.serializeFragment(targetNode.content);
                    // Iteratively populate children
                    this.appendChildNodes(targetNode.children, contentDOM);
                }
                return dom;
            }
            const { dom: dom, contentDOM: contentDOM } = constructor(targetNode, this.editorView, ()=>0, [], {});
            // Iteratively populate children
            this.appendChildNodes(targetNode.children, contentDOM);
            return dom;
        } catch (e) {
            return null;
        }
    }
    /**
   * Serializes a node to a DOM `Node` using the schema's `DOMSerializer`.
   */ serializeNode(node) {
        if (!this.serializer) throw new Error('NodeViewSerializer must be initialized with init() before use');
        try {
            return this.serializer.serializeNode(node);
        } catch (e) {
            return null;
        }
    }
    /**
   * Serializes a fragment to a `DocumentFragment` using the schema's `DOMSerializer`.
   */ serializeFragment(fragment) {
        if (!this.serializer) throw new Error('NodeViewSerializer must be initialized with init() before use');
        try {
            return this.serializer.serializeFragment(fragment);
        } catch (e) {
            return null;
        }
    }
    /**
   * Returns a copy of the current node view blocklist.
   */ getNodeViewBlocklist() {
        return new Set(this.nodeViewBlocklist);
    }
    /**
   * Returns a filtered copy of the node view blocklist, excluding specified node types.
   * @param excludeTypes - Array of node type names to exclude from the blocklist
   */ getFilteredNodeViewBlocklist(excludeTypes) {
        const filtered = new Set(this.nodeViewBlocklist);
        excludeTypes.forEach((type)=>filtered.delete(type));
        return filtered;
    }
    constructor(params){
        this.editorView = void 0;
        this.serializer = void 0;
        this.nodeViews = void 0;
        this.nodeViewBlocklist = void 0;
        if (params?.editorView) this.init({
            editorView: params.editorView
        });
        this.nodeViewBlocklist = new Set(params.blocklist ?? [
            'paragraph'
        ]);
    }
}


const $5e437f43e556a591$export$cc8ba64700247b36 = new (0, $ks2lK.PluginKey)('showDiffPlugin');
const $5e437f43e556a591$export$ae829ec7b2625219 = (config, getIntl)=>{
    const nodeViewSerializer = new (0, $e9d15807b524bec2$export$314a8d5cfa8a18e6)({});
    const setNodeViewSerializer = (editorView)=>{
        nodeViewSerializer.init({
            editorView: editorView
        });
    };
    return new (0, $1S4f7.SafePlugin)({
        key: $5e437f43e556a591$export$cc8ba64700247b36,
        state: {
            init (_, _state) {
                // We do initial setup after we setup the editor view
                return {
                    steps: [],
                    originalDoc: undefined,
                    decorations: (0, $ftzrq.DecorationSet).empty,
                    isDisplayingChanges: false
                };
            },
            apply: (tr, currentPluginState, oldState, newState)=>{
                const meta = tr.getMeta($5e437f43e556a591$export$cc8ba64700247b36);
                let newPluginState = currentPluginState;
                if (meta) {
                    if (meta?.action === 'SHOW_DIFF') {
                        // Update the plugin state with the new metadata
                        newPluginState = {
                            ...currentPluginState,
                            ...meta,
                            isDisplayingChanges: true
                        };
                        // Calculate and store decorations in state
                        const decorations = (0, $6a1dd0c85e18c1ea$export$aa7cf3ccfb5d875f)({
                            state: newState,
                            pluginState: newPluginState,
                            nodeViewSerializer: nodeViewSerializer,
                            colourScheme: config?.colourScheme,
                            intl: getIntl()
                        });
                        // Update the decorations
                        newPluginState.decorations = decorations;
                    } else if (meta?.action === 'HIDE_DIFF') newPluginState = {
                        ...currentPluginState,
                        ...meta,
                        decorations: (0, $ftzrq.DecorationSet).empty,
                        isDisplayingChanges: false
                    };
                    else newPluginState = {
                        ...currentPluginState,
                        ...meta
                    };
                }
                return {
                    ...newPluginState,
                    decorations: newPluginState.decorations.map(tr.mapping, tr.doc)
                };
            }
        },
        view (editorView) {
            setNodeViewSerializer(editorView);
            let isFirst = true;
            return {
                update (view) {
                    // If we're using configuration to show diffs we initialise here once we setup the editor view
                    if (config?.originalDoc && config?.steps && config.steps.length > 0 && isFirst) {
                        isFirst = false;
                        view.dispatch(view.state.tr.setMeta($5e437f43e556a591$export$cc8ba64700247b36, {
                            action: 'SHOW_DIFF',
                            steps: config.steps.map((step)=>(0, $cO9ey.Step).fromJSON(view.state.schema, step)),
                            originalDoc: (0, $6tl2G.processRawValue)(view.state.schema, config.originalDoc)
                        }));
                    }
                }
            };
        },
        props: {
            decorations: (state)=>{
                const pluginState = $5e437f43e556a591$export$cc8ba64700247b36.getState(state);
                return pluginState?.decorations;
            }
        }
    });
};


const $0a7e0bfbc3e153f6$export$b025b000fc343096 = ({ api: _api, config: config })=>({
        name: 'showDiff',
        commands: {
            showDiff: (params)=>({ tr: tr })=>{
                    return tr.setMeta((0, $5e437f43e556a591$export$cc8ba64700247b36), {
                        ...params,
                        action: 'SHOW_DIFF'
                    });
                },
            hideDiff: ({ tr: tr })=>{
                return tr.setMeta((0, $5e437f43e556a591$export$cc8ba64700247b36), {
                    steps: [],
                    action: 'HIDE_DIFF'
                });
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'showDiffPlugin',
                    plugin: ({ getIntl: getIntl })=>(0, $5e437f43e556a591$export$ae829ec7b2625219)(config, getIntl)
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return {
                isDisplayingChanges: false
            };
            const pluginState = (0, $5e437f43e556a591$export$cc8ba64700247b36).getState(editorState);
            const decorationCount = pluginState?.decorations?.find() || [];
            return {
                isDisplayingChanges: decorationCount.length > 0
            };
        }
    });
module.exports["showDiffPlugin"] = $0a7e0bfbc3e153f6$export$b025b000fc343096;

});

parcelRegister("aB4bz", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d7ZU3 = parcelRequire("d7ZU3");


var $hgeg8 = parcelRequire("hgeg8");


var $1S4f7 = parcelRequire("1S4f7");


var $dus6D = parcelRequire("dus6D");


var $dh538 = parcelRequire("dh538");

function $4f7135484255b265$export$e832373cff8dec22(api) {
    const list = {};
    const browser = (0, $d7ZU3.getBrowserInfo)();
    // Exclude Firefox browser from keyboard shortcut
    if (!browser.gecko && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) (0, $hgeg8.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.toggleViewChanges).common, ()=>{
        const isShowDiffAvailable = api?.trackChanges?.sharedState.currentState()?.isShowDiffAvailable;
        if (!isShowDiffAvailable) return false;
        const result = api?.core.actions.execute(api?.trackChanges?.commands.toggleChanges);
        return result ?? false;
    }, list);
    return new (0, $1S4f7.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const keyboardEvent = (0, $hgeg8.isCapsLockOnAndModifyKeyboardEvent)(event);
                return (0, $dus6D.keydownHandler)(list)(view, keyboardEvent);
            }
        }
    });
}






var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");

// To be determined a suitable threshold
// Exported for testing
const $70c4b5744ffd488b$export$e7e75006689980e4 = 10;


function $0f39de1919deebad$export$1f6a8febb8dbe92b(steps, allocations) {
    if (allocations.size <= (0, $70c4b5744ffd488b$export$e7e75006689980e4)) return {
        steps: steps,
        allocations: allocations
    };
    // Create a new allocation, retaining only the most recent values
    const elements = Array.from(allocations);
    const newAllocation = new Set(elements.slice(-(0, $70c4b5744ffd488b$export$e7e75006689980e4)));
    const finalSteps = [];
    let cutoffFound = false;
    for (const step of steps){
        if (newAllocation.has(step.allocation)) cutoffFound = true;
        // Accept everything after this point otherwise we could have mis-ordered steps
        if (cutoffFound) finalSteps.push(step);
    }
    return {
        steps: finalSteps,
        allocations: newAllocation
    };
}


class $68ea13a8482d82ad$export$ebdc1f934f4dd665 {
    constructor(step, inverted, allocation){
        this.step = step;
        this.inverted = inverted;
        this.allocation = allocation;
    }
}


var $c202f366898454cc$export$afb82ed05a2451a3 = /*#__PURE__*/ function(TOGGLE_TRACK_CHANGES_ACTION) {
    TOGGLE_TRACK_CHANGES_ACTION["TOGGLE_TRACK_CHANGES"] = "TOGGLE_TRACK_CHANGES";
    TOGGLE_TRACK_CHANGES_ACTION["RESET_BASELINE"] = "RESET_BASELINE";
    return TOGGLE_TRACK_CHANGES_ACTION;
}({});


const $b4822fc2c345489d$export$7304ae0cfc08f061 = new (0, $ks2lK.PluginKey)('trackChangesPlugin');
const $b4822fc2c345489d$export$26b3581d344cfc94 = (doc, steps)=>{
    try {
        // Filter out AttrStep's since attribute changes shouldn't affect baseline content comparison
        const contentSteps = steps.filter((step)=>!(step.step instanceof (0, $aXG5V.AttrStep)));
        for (const step of contentSteps.slice().reverse()){
            const result = step.inverted.apply(doc);
            if (result.failed === null && result.doc) doc = result.doc;
        }
        return doc;
    } catch (e) {
        // Temporary - we need to understand how this happens - but we want to unblock issues where this crashes the editor
        return undefined;
    }
};
const $b4822fc2c345489d$export$67af324863e9eeaf = (api)=>{
    // Mark the state to be reset on next time the document has a meaningful change
    let resetBaseline = false;
    return new (0, $1S4f7.SafePlugin)({
        key: $b4822fc2c345489d$export$7304ae0cfc08f061,
        state: {
            init () {
                return {
                    steps: [],
                    shouldChangesBeDisplayed: false,
                    isShowDiffAvailable: false,
                    allocations: new Set()
                };
            },
            apply (tr, state) {
                const metadata = tr.getMeta($b4822fc2c345489d$export$7304ae0cfc08f061);
                if (metadata && metadata.action === (0, $c202f366898454cc$export$afb82ed05a2451a3).RESET_BASELINE) return {
                    ...state,
                    steps: [],
                    isShowDiffAvailable: false
                };
                if (metadata && metadata.action === (0, $c202f366898454cc$export$afb82ed05a2451a3).TOGGLE_TRACK_CHANGES) {
                    resetBaseline = true;
                    return {
                        ...state,
                        shouldChangesBeDisplayed: !state.shouldChangesBeDisplayed
                    };
                }
                const isDocChanged = tr.docChanged && tr.steps.some((step)=>step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep) || step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep) || step instanceof (0, $aXG5V.AttrStep));
                const isAnnotationStep = (step)=>step instanceof (0, $aXG5V.AddMarkStep) && step.mark.type.name === 'annotation';
                if (!isDocChanged || tr.getMeta('isRemote') || tr.getMeta('replaceDocument') || tr.steps.some(isAnnotationStep)) // If the transaction is remote, we need to map the steps to the current document
                return {
                    ...state,
                    steps: state.steps.map((s)=>{
                        const newStep = s.step.map(tr.mapping);
                        const newInvertedStep = s.inverted.map(tr.mapping);
                        if (newStep && newInvertedStep) return new (0, $68ea13a8482d82ad$export$ebdc1f934f4dd665)(newStep, newInvertedStep, s.allocation);
                        return undefined;
                    }).filter((s)=>!!s)
                };
                // If we don't have the history plugin don't limit the change tracking
                const historyState = api?.history?.sharedState.currentState();
                const currentAllocation = historyState ? historyState.done.eventCount + historyState.undone.eventCount : (state.steps.at(-1)?.allocation ?? 0) + 1;
                const newSteps = tr.steps.map((step, idx)=>new (0, $68ea13a8482d82ad$export$ebdc1f934f4dd665)(step, step.invert(tr.docs[idx]), currentAllocation));
                const concatSteps = resetBaseline ? newSteps : [
                    ...state.steps,
                    ...newSteps
                ];
                resetBaseline = false;
                const { allocations: allocations, steps: steps } = (0, $0f39de1919deebad$export$1f6a8febb8dbe92b)(concatSteps, state.allocations.add(currentAllocation));
                // Calculate if there are actual changes by comparing current doc with baseline
                const baselineDoc = $b4822fc2c345489d$export$26b3581d344cfc94(tr.doc, steps);
                const hasChangesFromBaseline = baselineDoc ? !tr.doc.eq(baselineDoc) : false;
                // Create a new ChangeSet based on document changes
                return {
                    ...state,
                    allocations: allocations,
                    steps: steps,
                    shouldChangesBeDisplayed: false,
                    isShowDiffAvailable: hasChangesFromBaseline
                };
            }
        },
        view () {
            return {
                update (view, prevState) {
                    const prevShouldChangesBeDisplayed = $b4822fc2c345489d$export$7304ae0cfc08f061.getState(prevState)?.shouldChangesBeDisplayed;
                    const currentPluginState = $b4822fc2c345489d$export$7304ae0cfc08f061.getState(view.state);
                    const currentShouldChangesBeDisplayed = currentPluginState?.shouldChangesBeDisplayed;
                    if (prevShouldChangesBeDisplayed === false && currentShouldChangesBeDisplayed === true) {
                        const steps = currentPluginState?.steps ?? [];
                        const originalDoc = $b4822fc2c345489d$export$26b3581d344cfc94(view.state.doc, steps);
                        if (originalDoc) api?.core?.actions.execute(api?.showDiff?.commands?.showDiff({
                            originalDoc: originalDoc,
                            steps: steps.map((s)=>s.step)
                        }));
                    } else if (currentShouldChangesBeDisplayed === false && prevShouldChangesBeDisplayed === true) api?.core?.actions.execute(api?.showDiff?.commands?.hideDiff);
                }
            };
        }
    });
};






parcelRequire("42omo");


var $4Chin = parcelRequire("4Chin");

var $cPCP8 = parcelRequire("cPCP8");








var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");





var $eiA8Z = parcelRequire("eiA8Z");





var $808tb = parcelRequire("808tb");


var $fi2El = parcelRequire("fi2El");

var $7ERUE = parcelRequire("7ERUE");

var $iIVVb = parcelRequire("iIVVb");




const $97b620886c6f4f29$export$da54b7c34578dd9e = ({ api: api, wrapper: Wrapper })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const { isDisplayingChanges: isDisplayingChanges, isShowDiffAvailable: isShowDiffAvailable } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'trackChanges'
    ], (states)=>({
            isDisplayingChanges: states.trackChangesState?.isDisplayingChanges,
            isShowDiffAvailable: states.trackChangesState?.isShowDiffAvailable
        }));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        const wasShowingDiffSelected = isDisplayingChanges;
        const result = api?.core.actions.execute(api?.trackChanges?.commands.toggleChanges);
        // On de-selection - focus back on the editor
        if (result && wasShowingDiffSelected) api?.core.actions.focus();
    }, [
        api,
        isDisplayingChanges
    ]);
    const browser = (0, $d7ZU3.getBrowserInfo)();
    // Exclude Firefox browser from showing keyboard shortcut in tooltip
    const showShortcut = !browser.gecko && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers');
    const tooltipContent = showShortcut ? /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
        description: formatMessage((0, $808tb.trackChangesMessages).toolbarIconLabel),
        keymap: (0, $hgeg8.toggleViewChanges)
    }) : formatMessage((0, $808tb.trackChangesMessages).toolbarIconLabel);
    if (!isToolbarAIFCEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fi2El))),
            label: formatMessage((0, $808tb.trackChangesMessages).toolbarIconLabel),
            appearance: "subtle",
            isDisabled: !isShowDiffAvailable,
            isSelected: isDisplayingChanges,
            onClick: handleClick
        })
    });
    const button = /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7ERUE.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fi2El))), {
                label: formatMessage((0, $808tb.trackChangesMessages).toolbarIconLabel),
                size: "small"
            }),
            onClick: handleClick,
            isDisabled: !isShowDiffAvailable,
            isSelected: isDisplayingChanges
        })
    });
    return Wrapper ? /*#__PURE__*/ (0, $l998X.jsx)(Wrapper, {
        children: button
    }) : button;
};


const $7e8e83c32ee71781$export$a758406ca53b86a5 = (api, options)=>{
    return [
        ...(0, $dh538.fg)('platform_editor_toolbar_aifc_undo_redo_confluence') ? [] : [
            {
                type: (0, $cPCP8.TRACK_CHANGES_SECTION).type,
                key: (0, $cPCP8.TRACK_CHANGES_SECTION).key,
                parents: [
                    {
                        type: 'toolbar',
                        key: (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR,
                        rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.TRACK_CHANGES_SECTION).key]
                    }
                ]
            }
        ],
        {
            type: (0, $cPCP8.TRACK_CHANGES_GROUP).type,
            key: (0, $cPCP8.TRACK_CHANGES_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.TRACK_CHANGES_SECTION).type,
                    key: (0, $cPCP8.TRACK_CHANGES_SECTION).key,
                    rank: (0, $4Chin.TRACK_CHANGES_SECTION_RANK)[(0, $cPCP8.TRACK_CHANGES_GROUP).key]
                }
            ]
        },
        {
            type: (0, $cPCP8.TRACK_CHANGES_BUTTON).type,
            key: (0, $cPCP8.TRACK_CHANGES_BUTTON).key,
            parents: [
                {
                    type: (0, $cPCP8.TRACK_CHANGES_GROUP).type,
                    key: (0, $cPCP8.TRACK_CHANGES_GROUP).key,
                    rank: (0, $4Chin.TRACK_CHANGES_GROUP_RANK)[(0, $cPCP8.TRACK_CHANGES_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $97b620886c6f4f29$export$da54b7c34578dd9e), {
                    api: api,
                    wrapper: options?.ButtonWrapper
                })
        }
    ];
};



const $594c0761b769300b$export$1ce21d3d70c60c32 = ({ api: api, config: options })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $97b620886c6f4f29$export$da54b7c34578dd9e), {
            api: api
        });
    };
    if (options?.showOnToolbar === true) {
        if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $7e8e83c32ee71781$export$a758406ca53b86a5)(api, options));
        else api?.primaryToolbar?.actions?.registerComponent({
            name: 'trackChanges',
            component: primaryToolbarComponent
        });
    }
    return {
        name: 'trackChanges',
        pmPlugins () {
            return [
                {
                    name: 'trackChangesKeyMap',
                    plugin: ()=>(0, $4f7135484255b265$export$e832373cff8dec22)(api)
                },
                {
                    name: 'trackChangesPlugin',
                    plugin: ()=>(0, $b4822fc2c345489d$export$67af324863e9eeaf)(api)
                }
            ];
        },
        commands: {
            toggleChanges: ({ tr: tr })=>{
                return tr.setMeta((0, $b4822fc2c345489d$export$7304ae0cfc08f061), {
                    action: (0, $c202f366898454cc$export$afb82ed05a2451a3).TOGGLE_TRACK_CHANGES
                });
            },
            resetBaseline: ({ tr: tr })=>{
                if (!api?.trackChanges?.sharedState.currentState()?.isShowDiffAvailable) return null;
                return tr.setMeta((0, $b4822fc2c345489d$export$7304ae0cfc08f061), {
                    action: (0, $c202f366898454cc$export$afb82ed05a2451a3).RESET_BASELINE
                });
            }
        },
        getSharedState: (editorState)=>{
            if (!editorState) return {
                isDisplayingChanges: false,
                isShowDiffAvailable: false
            };
            return {
                isDisplayingChanges: Boolean((0, $b4822fc2c345489d$export$7304ae0cfc08f061).getState(editorState)?.shouldChangesBeDisplayed),
                isShowDiffAvailable: Boolean((0, $b4822fc2c345489d$export$7304ae0cfc08f061).getState(editorState)?.isShowDiffAvailable)
            };
        }
    };
};
module.exports["trackChangesPlugin"] = $594c0761b769300b$export$1ce21d3d70c60c32;

});

parcelRegister("dF1N1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fO7hX = parcelRequire("fO7hX");


var $dh538 = parcelRequire("dh538");


var $d925B = parcelRequire("d925B");


var $2pjJ5 = parcelRequire("2pjJ5");




const $af0b798917256420$export$d4371db4dc3f8b5f = [
    'replaceNode',
    'removeNode',
    'insertNodeBefore',
    'insertNodeAfter',
    'appendNodeToEnd',
    'setAttrs',
    'wrap',
    'wrapNode',
    'appendNode'
];
 // #endregion


function $839bfdacc8d0b035$export$6bf900bab6a4720d(api) {
    let doc;
    // Quick and dirty way to get the doc
    api?.core.actions.execute(({ tr: tr })=>{
        doc = tr.doc;
        return null;
    });
    return doc;
}






var $4QzBR = parcelRequire("4QzBR");







function $009cb14caceb5527$export$1bd732ee2c8aaeb(doc, localId) {
    let nodeResult;
    doc.descendants((node, pos, parent)=>{
        if (nodeResult) return false;
        if (node.attrs.localId === localId) nodeResult = {
            node: node,
            pos: pos,
            parent: parent
        };
        return !nodeResult;
    });
    return nodeResult;
}
function $009cb14caceb5527$export$c1cb5b5eb3aab3e3(doc, localId) {
    let nodeResult;
    doc.descendants((node, pos, parent)=>{
        if (node.attrs.localId === localId) {
            nodeResult = {
                node: node,
                pos: pos,
                parent: parent
            };
            return false;
        }
        return true;
    });
    return nodeResult;
}
function $009cb14caceb5527$export$b7b4fc0a0195a016(api, localId) {
    if (!localId) return undefined;
    let foundNode;
    api?.core.actions.execute(({ tr: tr })=>{
        foundNode = $009cb14caceb5527$export$1bd732ee2c8aaeb(tr.doc, localId)?.node;
        return null;
    });
    return foundNode;
}
function $009cb14caceb5527$export$aadcc3ba2430b(api, tr, localId, callback, reversed) {
    const result = ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? reversed ? $009cb14caceb5527$export$c1cb5b5eb3aab3e3 : $009cb14caceb5527$export$1bd732ee2c8aaeb : $009cb14caceb5527$export$1bd732ee2c8aaeb)(tr.doc, localId);
    if (result) {
        api?.aiExperience?.actions.tagAsAIStreamingTransformation(tr);
        callback(result);
    }
    if (!result) {
        let docSize;
        // Quick and dirty way to get the node size - do not copy this pattern, use `requestDocument`
        api?.core.actions.execute(({ tr: tr })=>{
            docSize = tr.doc.nodeSize;
            return null;
        });
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).LOCAL_ID_NOT_FOUND,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_STREAMING,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                localIdLength: localId?.length,
                docSize: docSize,
                scrubbedLocalId: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? (0, $4QzBR.scrubStr)(localId) : ''
            }
        });
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) return null;
        else throw new Error(`Node with localId ${localId} not found`);
    }
    return tr;
}



var $h9yJL = parcelRequire("h9yJL");


var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");




const $adc2c60cd4921249$var$transformer = new (0, $h9yJL.JSONTransformer)();
function $adc2c60cd4921249$export$7b6c9d9d26e2f428(api, response, type) {
    const schema = api?.core.sharedState.currentState()?.schema;
    if (!schema || !response) return {
        adfDoc: response
    };
    try {
        const doc = schema.node('doc', null, [
            schema.node('paragraph', null, [])
        ]);
        const transform = new (0, $aXG5V.Transform)(doc);
        const node = (0, $5SAOw.Node).fromJSON(schema, response);
        const newDoc = transform.replaceWith(0, 2, node).doc;
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) return {
            doc: newDoc,
            // The "doc" response can cause nesting issues (ie. by wrapping a taskItem in doc -> taskList -> taskItem)
            // We should use the response, but for now only use it for `replaceNode` since it causes some edge cases with other commands
            // that need to be resolved separately
            adfDoc: type === 'replaceNode' || (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? response : $adc2c60cd4921249$var$transformer.encode(newDoc)
        };
        return {
            doc: newDoc,
            adfDoc: $adc2c60cd4921249$var$transformer.encode(newDoc)
        };
    } catch  {
        return {
            adfDoc: response
        };
    }
}


function $9dc598573bd03537$export$450b2ad108e2e506(api, initialNode, finalNode) {
    const schema = api?.core.sharedState.currentState()?.schema;
    if (!initialNode || !finalNode || !schema || !initialNode.attrs.localId) return false;
    const finalPMDoc = (0, $adc2c60cd4921249$export$7b6c9d9d26e2f428)(api, finalNode, undefined)?.doc;
    if (!finalPMDoc) return false;
    const finalPMNode = (0, $009cb14caceb5527$export$1bd732ee2c8aaeb)(finalPMDoc, initialNode.attrs.localId)?.node;
    return (finalPMNode && !initialNode.eq(finalPMNode) && (0, $2pjJ5.areNodesEqualIgnoreAttrs)(initialNode, finalPMNode)) ?? false;
}


function $7b61ecd8bc5f3510$export$6dcba6b9d3966cf9({ api: api, isCreateAction: isCreateAction, traceId: traceId }) {
    return (event)=>{
        if ((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events')) {
            const commonAttributes = {
                traceId: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? traceId : undefined,
                experienceName: null,
                selectionType: null,
                selectionCategory: null,
                streamId: null,
                source: {
                    type: 'orchestrator',
                    isCreateAction: isCreateAction
                }
            };
            if (event.type === 'error') api?.analytics?.actions.fireAnalyticsEvent({
                action: 'error',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'adfStreaming',
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    ...commonAttributes,
                    errorMessage: event.message,
                    errorData: event.data
                }
            });
            else api?.analytics?.actions.fireAnalyticsEvent({
                action: 'info',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'adfStreaming',
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    ...commonAttributes,
                    message: event.message,
                    data: event.data
                }
            });
        } else if (event.type === 'error') api?.analytics?.actions.fireAnalyticsEvent({
            action: 'error',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'adfStreaming',
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                errorMessage: event.message,
                errorData: event.data,
                experienceName: null,
                selectionType: null,
                selectionCategory: null,
                streamId: null,
                source: {
                    type: 'orchestrator',
                    isCreateAction: isCreateAction
                }
            }
        });
        else api?.analytics?.actions.fireAnalyticsEvent({
            action: 'info',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'adfStreaming',
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                message: event.message,
                data: event.data,
                experienceName: null,
                selectionType: null,
                selectionCategory: null,
                streamId: null,
                source: {
                    type: 'orchestrator',
                    isCreateAction: isCreateAction
                }
            }
        });
    };
}
function $7b61ecd8bc5f3510$export$7535a054b27a27c4({ api: api, initialNode: initialNode, lastDoc: lastDoc }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'replaceNodeAction',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'orchestratorReplaceNode',
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            attributeOnlyChange: (0, $9dc598573bd03537$export$450b2ad108e2e506)(api, initialNode, lastDoc),
            nodeName: initialNode?.type.name
        }
    });
}
// Validates the command is valid ()
const $7b61ecd8bc5f3510$var$validateCommandType = (cmd)=>cmd?.type && (0, $af0b798917256420$export$d4371db4dc3f8b5f).includes(cmd.type) ? cmd.type : 'invalid';
function $7b61ecd8bc5f3510$export$276ecd5322451ab4({ api: api, docBeforeStreaming: docBeforeStreaming, command: command }) {
    const docAfterStreaming = (0, $839bfdacc8d0b035$export$6bf900bab6a4720d)(api);
    if (docBeforeStreaming && docAfterStreaming) {
        const isSameDoc = docBeforeStreaming.eq(docAfterStreaming);
        const isSameDocIgnoreAttrs = (0, $2pjJ5.areNodesEqualIgnoreAttrs)(docBeforeStreaming, docAfterStreaming);
        if (isSameDoc || isSameDocIgnoreAttrs) api.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).NO_DOC_CHANGE_FOUND,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_STREAMING,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                command: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? $7b61ecd8bc5f3510$var$validateCommandType(command) : '',
                isSameDoc: isSameDoc,
                isSameDocIgnoreAttrs: isSameDocIgnoreAttrs
            }
        });
    }
}
function $7b61ecd8bc5f3510$export$8b7d4483ec260574({ api: api, sessionStarted: sessionStarted, endSessionCallCount: endSessionCallCount, lastEndedSessionId: lastEndedSessionId, isDoubleCall: isDoubleCall }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'error',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreamingEndSession',
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            sessionStarted: sessionStarted,
            endSessionCallCount: endSessionCallCount,
            lastEndedSessionId: lastEndedSessionId,
            isDoubleCall: isDoubleCall
        }
    });
}
function $7b61ecd8bc5f3510$export$4b84cbb6abceadd2({ api: api, sessionId: sessionId, traceId: traceId }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'sessionStart',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'userFlow',
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            aiGroupId: sessionId,
            actionTaken: undefined,
            editCount: 0,
            aiSessionId: '',
            traceIds: traceId ? [
                traceId
            ] : undefined
        }
    });
}



var $c6GJD = parcelRequire("c6GJD");


var $e83av = parcelRequire("e83av");

function $19e1d609df7dfc8f$var$isNumber(value) {
    return typeof value === 'number';
}
function $19e1d609df7dfc8f$var$isRamp(value) {
    if (typeof value !== 'object' || value === null) return false;
    const v = value;
    return $19e1d609df7dfc8f$var$isNumber(v.initialDelaySec) && $19e1d609df7dfc8f$var$isNumber(v.stepDelaySec) && $19e1d609df7dfc8f$var$isNumber(v.flushDelaySec) && $19e1d609df7dfc8f$var$isNumber(v.growthFactor);
}
function $19e1d609df7dfc8f$var$getExperimentValue(key, defaultValue) {
    return (0, $c6GJD.default).getExperimentValue('platform-editor-ai-streaming-speed', key, defaultValue, {
        typeGuard: $19e1d609df7dfc8f$var$isNumber
    });
}
function $19e1d609df7dfc8f$export$9ea8217d5ec56f82(enabled) {
    if (enabled === false) return null;
    const backlogRampThreshold = $19e1d609df7dfc8f$var$getExperimentValue('backlogRampThreshold', 100);
    const initialCharsPerTick = $19e1d609df7dfc8f$var$getExperimentValue('initialCharsPerTick', 8);
    const maxCharsPerTick = $19e1d609df7dfc8f$var$getExperimentValue('maxCharsPerTick', 1000);
    const tickMs = $19e1d609df7dfc8f$var$getExperimentValue('tickMs', 41);
    const ramp = (0, $c6GJD.default).getExperimentValue('platform-editor-ai-streaming-speed', 'ramp', {
        initialDelaySec: 6,
        stepDelaySec: 3,
        flushDelaySec: 0.5,
        growthFactor: 1.5
    }, {
        typeGuard: $19e1d609df7dfc8f$var$isRamp
    });
    // These settings are copied from the ai plugins pacer -> platform/packages/editor/editor-plugin-ai/src/ui/utils/request/stream-flow-pacer.ts
    return new (0, $e83av.StreamFlowPacer)({
        backlogRampThreshold: backlogRampThreshold,
        initialCharsPerTick: initialCharsPerTick,
        maxCharsPerTick: maxCharsPerTick,
        ramp: ramp,
        tickMs: tickMs
    });
}









var $4pSml = parcelRequire("4pSml");


var $1xicG = parcelRequire("1xicG");


var $9Tkc6 = parcelRequire("9Tkc6");




const $127e6d5334706012$var$reset = '\x1b[0m';
const $127e6d5334706012$var$red = '\x1b[31m';
const $127e6d5334706012$var$magenta = '\x1b[35m';
const $127e6d5334706012$var$green = '\x1b[32m';
const $127e6d5334706012$var$blue = '\x1b[34m';
class $127e6d5334706012$export$21e6cc849c1dc1ab {
    add(log) {
        if ((0, $dh538.fg)('platform_editor_editor_debugging_panel')) {
            try {
                if (window.top?.__aifcDebuggerEnabled__) {
                    const { type: type, message: message } = log;
                    // eslint-disable-next-line no-console
                    console.log(`${$127e6d5334706012$var$magenta}[AIFC]:EditorStreamQueue${$127e6d5334706012$var$reset} ${type === 'Public' ? $127e6d5334706012$var$green : type === 'Queue' ? $127e6d5334706012$var$blue : $127e6d5334706012$var$red}${type}${$127e6d5334706012$var$reset} ${message}`, log);
                }
            } catch (error) {
            // Ignore cross-origin errors
            }
            this.logs.push({
                type: log.type,
                message: log.message,
                timestamp: log.timestamp
            });
            if (this.logs.length > this.MAX_LENGTH) this.logs.shift(); // Remove the oldest log to maintain a max log
        }
    }
    logPublic(message, data) {
        this.add({
            type: 'Public',
            message: message,
            ...data,
            timestamp: new Date()
        });
    }
    logError(message, data) {
        this.add({
            type: 'Error',
            message: message,
            ...data,
            timestamp: new Date()
        });
    }
    logQueueState(message, data) {
        this.add({
            type: 'Queue',
            message: message,
            ...data,
            timestamp: new Date()
        });
    }
    // Current ADF at the time of logging so we can recreate the scenario
    getAdf() {
        if (!this.api) return undefined;
        let doc;
        this.api.core.actions.execute(({ tr: tr })=>{
            doc = tr.doc.toJSON();
            return null;
        });
        return doc;
    }
    getDebugInformation() {
        return {
            logs: this.logs,
            adf: this.getAdf(),
            selection: this.api?.selection?.actions.getSelectionFragment() ?? undefined,
            localIds: this.api?.selection?.actions.getSelectionLocalIds() ?? undefined
        };
    }
    constructor(api){
        this.api = api;
        this.logs = [];
        this.MAX_LENGTH = 100;
        if ((0, $dh538.fg)('platform_editor_editor_debugging_panel')) {
            if (window.top) try {
                window.top.__aifcEditorDebugData__ = ()=>this.getDebugInformation();
            } catch (error) {
            // Ignore cross-origin errors
            }
        }
    }
}





function $c127a9255266496a$export$f85aff2979b590a7(command) {
    return [
        'replaceNode',
        'insertNodeBefore',
        'insertNodeAfter',
        'appendNode',
        'appendNodeToEnd'
    ].includes(command.type);
}






function $a561bee60676cdb0$export$c48ec1bf46060d54(commandsToProcess) {
    const mergedCommands = [];
    for (const command of commandsToProcess){
        const lastCommand = mergedCommands[mergedCommands.length - 1];
        // Check if we can merge the current command with the last one
        if (command.type === 'streamCommand' && lastCommand && lastCommand.type === 'streamCommand' && command.actionId === lastCommand.actionId) {
            if ((0, $dh538.fg)('platform_editor_ai_aifc_adf_parser_on_update')) lastCommand.chunk = command.chunk;
            else // Merge by concatenating chunks
            lastCommand.chunk += command.chunk;
        } else // Otherwise, just push the command to mergedCommands
        mergedCommands.push(command);
    }
    return mergedCommands;
}


function $d96f5329afc42f98$export$6c44330c7facd24b(promise, options) {
    const { timeout: timeout, onTimeout: onTimeout, onCleanup: onCleanup } = options;
    let timeoutHandle;
    let timeoutResolve;
    let isCompleted = false;
    // Function to start/restart the timeout
    const resetTimeout = ()=>{
        if (isCompleted) return;
        if (timeoutHandle) clearTimeout(timeoutHandle);
        timeoutHandle = setTimeout(()=>{
            if (!isCompleted) {
                onTimeout();
                timeoutResolve?.();
            }
        }, timeout);
    };
    const timeoutPromise = new Promise((resolve)=>{
        timeoutResolve = resolve;
    });
    resetTimeout();
    // Race the original promise against the timeout
    const wrappedPromise = Promise.race([
        promise,
        timeoutPromise
    ]).finally(()=>{
        isCompleted = true;
        if (timeoutHandle) clearTimeout(timeoutHandle);
        onCleanup?.();
    });
    return {
        resetTimeout: resetTimeout,
        promise: wrappedPromise
    };
}



var $6jPem = parcelRequire("6jPem");




function $76ccf77dd7d8e539$export$ab173b3d1046c711(adfResponse, type, schema) {
    if (!adfResponse || type !== 'insertNodeAfter' || !(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) return {
        updatedResponse: adfResponse,
        localId: undefined
    };
    const indexMap = [];
    let newLocalId = crypto.randomUUID();
    const depthToCheckAgainst = (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? 0 : 1;
    // First pass just to get the node to update
    (0, $6jPem.traverse)(adfResponse, {
        any: (_n, _p, index, depth)=>{
            if (depth === depthToCheckAgainst) indexMap.push(index);
        }
    });
    // Update the localId of the last node
    let localIdUpdated = false;
    const newAdfResponse = (0, $6jPem.traverse)({
        ...adfResponse
    }, {
        any: (node, _p, index, depth)=>{
            if (depth === depthToCheckAgainst && indexMap[indexMap.length - 1] === index && !!schema?.nodes[node.type]?.spec?.attrs?.localId) {
                localIdUpdated = true;
                if (!!node?.attrs?.localId && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) newLocalId = node?.attrs?.localId;
                return {
                    ...node,
                    attrs: {
                        ...node.attrs,
                        localId: newLocalId
                    }
                };
            }
        }
    });
    return {
        updatedResponse: newAdfResponse ? newAdfResponse : adfResponse,
        localId: localIdUpdated ? newLocalId : undefined
    };
}






var $ks2lK = parcelRequire("ks2lK");

const $d4e9e31242338f4c$export$9e6d85a71b01d30 = (api)=>()=>{
        return api.core.actions.execute(({ tr: tr })=>{
            let selection;
            if ((0, $2pjJ5.isEmptyDocument)(tr.doc)) selection = (0, $ks2lK.Selection).atEnd(tr.doc);
            else {
                const $pos = tr.doc.resolve(tr.doc.content.size);
                tr.insert($pos.pos, tr.doc.type.schema.nodes.paragraph.create());
                selection = (0, $ks2lK.TextSelection).create(tr.doc, $pos.pos + 1);
            }
            if (!selection) throw new Error('Failed to create selection');
            api?.aiExperience?.actions.tagAsAIStreamingTransformation(tr);
            tr.setSelection(selection).scrollIntoView();
            return tr;
        });
    };






var $7XFGZ = parcelRequire("7XFGZ");


var $LmqWp = parcelRequire("LmqWp");


var $9MzzS = parcelRequire("9MzzS");





const $c2ca03eb7fbe6fb1$var$nodeNamesToSkipInsertParagraph = [
    'listItem',
    'taskItem',
    'decisionItem'
];
const $c2ca03eb7fbe6fb1$export$d4ccce03e5361e34 = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $009cb14caceb5527$export$aadcc3ba2430b)(api, tr, command.localId, ({ pos: pos, node: node, parent: parent })=>{
                if (node.type.name === 'tableRow' && parent) {
                    const tableMap = (0, $LmqWp.TableMap).get(parent);
                    const $pos = tr.doc.resolve(pos);
                    const tableStart = $pos.start($pos.depth);
                    const rect = tableMap.findCell(pos - tableStart + 1);
                    const tableContext = {
                        map: tableMap,
                        table: parent,
                        tableStart: tableStart
                    };
                    (0, $9MzzS.addRow)(tr, tableContext, rect.bottom);
                    const $newPos = tr.doc.resolve(pos);
                    const table = $newPos.node($newPos.depth);
                    const newTableMap = (0, $LmqWp.TableMap).get(table);
                    // Not considering merged cells
                    const cells = newTableMap.mapByRow[rect.bottom];
                    const selection = (0, $7XFGZ.CellSelection).rowSelection(tr.doc.resolve(cells[0] + tableStart), tr.doc.resolve(cells[cells.length - 1] + tableStart));
                    tr.setSelection(selection).scrollIntoView();
                } else if ($c2ca03eb7fbe6fb1$var$nodeNamesToSkipInsertParagraph.includes(node.type.name) && parent && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) {
                    /**
						 * Not creating new paragraph node when inserting node after list item.
						 * Because when inserting new list item, it will add new list item in new list.
						 */ const selection = (0, $ks2lK.TextSelection).create(tr.doc, pos + node.nodeSize);
                    tr.setSelection(selection).scrollIntoView();
                } else {
                    let insertPos = Math.min(pos + node.nodeSize, tr.doc.content.size);
                    if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
                        insertPos = pos + node.nodeSize;
                        while(insertPos < tr.doc.content.size){
                            const $pos = tr.doc.resolve(insertPos);
                            let nextNode = null;
                            // For top-level nodes (depth 0 = document), check document children directly
                            // For nested nodes, use nodeAfter which works at higher depths
                            if ($pos.depth === 0) {
                                // At document root level, find the next top-level child
                                const childIndex = $pos.indexAfter(0);
                                if (childIndex < tr.doc.childCount) nextNode = tr.doc.child(childIndex);
                            } else // For nested structures, nodeAfter works correctly
                            nextNode = $pos.nodeAfter;
                            // Skip nodes without localId (from previous AI insertions)
                            // This prevents sequential insertions from overriding each other
                            if (nextNode && !nextNode.attrs.localId) insertPos += nextNode.nodeSize;
                            else break;
                        }
                    }
                    if (node.type.name === 'tableCell' || node.type.name === 'tableHeader') insertPos--;
                    tr.insert(insertPos, tr.doc.type.schema.nodes.paragraph.create());
                    const selection = (0, $ks2lK.TextSelection).create(tr.doc, insertPos + 1);
                    tr.setSelection(selection).scrollIntoView();
                }
            }, // Inserting after should always look for the last node with a matching localid. This will ensure that we
            // always insert AFTER.
            true);
        });
    };






const $221cde67568b69a7$export$1226208ece997066 = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $009cb14caceb5527$export$aadcc3ba2430b)(api, tr, command.localId, ({ pos: pos })=>{
                const selection = new (0, $ks2lK.TextSelection)(tr.doc.resolve(pos));
                tr.setSelection(selection).scrollIntoView();
            });
        });
    };



const $32edc2d4989fa97a$export$9a6ccf2338830d60 = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $009cb14caceb5527$export$aadcc3ba2430b)(api, tr, command.localId, ({ node: node, pos: pos })=>{
                tr.delete(pos, pos + node.nodeSize).scrollIntoView();
            });
        });
    };












const $909a39db2548dac9$export$8077407ea1dae01f = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $009cb14caceb5527$export$aadcc3ba2430b)(api, tr, command.localId, ({ pos: pos, node: node })=>{
                let selection = null;
                // this if block can be removed when 'platform_editor_ai_aifc_patch_ga' is removed
                // i.e. we will not want any special handling for table replacements
                if (node.type.name === 'table' && !(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
                    tr.replaceRangeWith(pos, pos + node.nodeSize, tr.doc.type.schema.nodes.paragraph.create());
                    selection = (0, $ks2lK.TextSelection).create(tr.doc, pos + 1);
                } else if ((0, $ks2lK.NodeSelection).isSelectable(node)) selection = (0, $ks2lK.NodeSelection).create(tr.doc, pos);
                else {
                    const role = node.type.spec.tableRole;
                    if (role === 'cell' || role === 'header_cell') selection = (0, $7XFGZ.CellSelection).create(tr.doc, pos);
                    else if (role === 'row') {
                        // There's always a cell after the row
                        const $cell = tr.doc.resolve(pos + 1);
                        selection = (0, $7XFGZ.CellSelection).rowSelection($cell, $cell, true);
                    } else {
                        const $pos = tr.doc.resolve(pos);
                        const $end = tr.doc.resolve(pos + node.nodeSize);
                        selection = (0, $ks2lK.TextSelection).between($pos, $end);
                    }
                }
                if (selection) tr.setSelection(selection).scrollIntoView();
            });
        });
    };






var $1oCLl = parcelRequire("1oCLl");


const $834280e13ce7e027$var$getValidAttributes = (attrs, nodeSpec)=>{
    const validAttrs = {};
    for(const key in attrs)if (nodeSpec.attrs?.hasOwnProperty(key)) validAttrs[key] = attrs[key];
    return validAttrs;
};
const $834280e13ce7e027$export$3c4e918a3d6ca42f = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            let shouldExecute = false;
            (0, $009cb14caceb5527$export$aadcc3ba2430b)(api, tr, command.localId, ({ node: node, pos: pos })=>{
                if (node) {
                    const attrs = command.attrs;
                    if (!attrs || typeof attrs !== 'object') return;
                    const validAttrs = $834280e13ce7e027$var$getValidAttributes(attrs, node.type.spec);
                    node.type.spec.attrs;
                    tr.setNodeMarkup(pos, node.type, {
                        ...node.attrs,
                        ...validAttrs
                    });
                    if ((0, $1oCLl.expValEquals)('platform_editor_ai_update_set_attrs_selection', 'isEnabled', true)) tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve(pos)));
                    shouldExecute = true;
                }
            });
            return shouldExecute ? tr : null;
        });
    };



var $3KVX0 = parcelRequire("3KVX0");


var $4rpi6 = parcelRequire("4rpi6");











var $2QlXt = parcelRequire("2QlXt");


const $f350631d999bc8ec$var$panelTypes = new (0, $3KVX0.default)((0, $4rpi6.panel).props.attrs.props.panelType.values);
function $f350631d999bc8ec$var$wrapChild(fragment, type, attrs) {
    if (!fragment.firstChild) return null;
    const wrappingNodeTypes = type.contentMatch.findWrapping(fragment.firstChild.type);
    let currentChildNodes = null;
    if (wrappingNodeTypes) {
        currentChildNodes = fragment.content;
        for(let i = wrappingNodeTypes.length - 1; i >= 0; i--){
            const wrappingNodeType = wrappingNodeTypes[i];
            const nextChildNode = wrappingNodeType.createAndFill(null, currentChildNodes);
            if (nextChildNode) currentChildNodes = [
                nextChildNode
            ];
            else {
                currentChildNodes = null;
                break;
            }
        }
    }
    if (currentChildNodes) return type.createAndFill(attrs, currentChildNodes);
    return null;
}
function $f350631d999bc8ec$var$findPosForNode(node, $to) {
    for(let depth = $to.depth; depth >= 0; depth--){
        const ancestor = $to.node(depth);
        if (ancestor.type.contentMatch.matchType(node.type)) return $to.after(depth + 1);
    }
    return null;
}
function $f350631d999bc8ec$var$getAncestorTypes($to) {
    const ancestors = [];
    for(let depth = $to.depth; depth >= 0; depth--){
        const ancestor = $to.node(depth);
        ancestors.push(ancestor.type.name);
    }
    return ancestors;
}
function $f350631d999bc8ec$var$getChildTypes(fragment) {
    return fragment.content.map((node)=>node.type.name);
}
const $f350631d999bc8ec$export$2c6212a0adabc271 = (api)=>(command)=>{
        let success = false;
        let error;
        let repaired = false;
        let ancestors = [];
        let fragments = [];
        api.core.actions.execute(({ tr: tr })=>{
            try {
                (0, $009cb14caceb5527$export$aadcc3ba2430b)(api, tr, command.localId, ({ node: node, pos: pos })=>{
                    const $from = tr.doc.resolve(pos);
                    const $to = tr.doc.resolve(pos + node.nodeSize);
                    const range = $from.blockRange($to);
                    if (range) {
                        const type = tr.doc.type.schema.nodes[command.wrapperType];
                        const attrs = command.wrapperAttrs;
                        // TODO: EDITOR-1371 - Validate attributes for all nodes
                        if (command.wrapperType === 'panel' && attrs.panelType !== undefined) {
                            const panelType = command.wrapperAttrs.panelType;
                            const panelTypeResult = $f350631d999bc8ec$var$panelTypes.search(panelType);
                            if (panelTypeResult.length) attrs.panelType = panelTypeResult[0].item;
                            else attrs.panelType = 'info';
                        }
                        try {
                            // NOTE: `wrapping` will be empty ([]) when it fits directly
                            const wrapping = (0, $aXG5V.findWrapping)(range, type, attrs);
                            if (wrapping !== null) {
                                tr.wrap(range, wrapping).scrollIntoView();
                                success = true;
                            } else {
                                const slice = tr.doc.slice(range.$from.pos, range.$to.pos);
                                const fragment = slice.content;
                                let node = type.createAndFill(attrs, fragment);
                                if (!node) node = $f350631d999bc8ec$var$wrapChild(fragment, type, attrs);
                                if (node) {
                                    const insertPos = $f350631d999bc8ec$var$findPosForNode(node, $to);
                                    if (insertPos !== null) {
                                        tr.insert(insertPos, node).scrollIntoView();
                                        tr.replaceRange(range.$from.pos, range.$to.pos, (0, $5SAOw.Slice).empty);
                                        success = true;
                                        repaired = true;
                                    }
                                }
                                ancestors = $f350631d999bc8ec$var$getAncestorTypes($to);
                                fragments = $f350631d999bc8ec$var$getChildTypes(fragment);
                            }
                        } catch (e) {
                            error = e;
                            // TODO: EDITOR-1370 - Log the error
                            // eslint-disable-next-line no-console
                            console.error(e);
                        }
                    }
                });
            } catch (e) {
                error = e;
                // TODO: EDITOR-1370 - Log the error
                // eslint-disable-next-line no-console
                console.error(e);
            }
            return tr;
        });
        if (!success || repaired) {
            // Log the error
            const errorMessage = (0, $2QlXt.ErrorUtils).extractErrorMessage(error);
            let errorStack = '';
            if (error instanceof Error) errorStack = error.stack || '';
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).INVALID_COMMAND_FOUND,
                actionSubject: (0, $d925B.ACTION_SUBJECT).AI_STREAMING,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    success: // Disable for now #hot-122604
                    // command,
                    success,
                    repaired: repaired,
                    ancestors: ancestors,
                    fragments: fragments,
                    errorMessage: errorMessage,
                    errorStack: errorStack
                }
            });
        }
        return success;
    };


function $748219bd4f4f1029$export$a0774277976bc21f(api) {
    return {
        replaceNode: (0, $909a39db2548dac9$export$8077407ea1dae01f)(api),
        insertNodeBefore: (0, $221cde67568b69a7$export$1226208ece997066)(api),
        insertNodeAfter: (0, $c2ca03eb7fbe6fb1$export$d4ccce03e5361e34)(api),
        removeNode: (0, $32edc2d4989fa97a$export$9a6ccf2338830d60)(api),
        appendNode: (0, $d4e9e31242338f4c$export$9e6d85a71b01d30)(api),
        appendNodeToEnd: (0, $d4e9e31242338f4c$export$9e6d85a71b01d30)(api),
        wrap: (0, $f350631d999bc8ec$export$2c6212a0adabc271)(api),
        wrapNode: (0, $f350631d999bc8ec$export$2c6212a0adabc271)(api),
        setAttrs: (0, $834280e13ce7e027$export$3c4e918a3d6ca42f)(api)
    };
}


class $4c93be51fe49a367$export$f3feb8728b17a0a9 {
    isActorReady() {
        try {
            const currentState = this.api.aiExperience.sharedState.currentState();
            if (!(0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) {
                // Check if actor exists and is in streaming state
                const actor = this.api.aiExperience.actions.getAiExperienceActor();
                return actor && currentState?.isStreaming === true;
            }
            return currentState?.isStreaming === true;
        } catch  {
            return false;
        }
    }
    commandToProcess(commandToProcess) {
        const { type: type, actionId: actionId, chunk: chunk } = commandToProcess;
        if (type === 'initStream') return this.initStreamPromise(commandToProcess.command, commandToProcess.options);
        else if (type === 'endStream') return this.endExperiencePromise(commandToProcess);
        else return this.processStreamCommandPromise(actionId, chunk);
    }
    async processQueue() {
        if (this.processingQueue) return;
        if (this.queueTimeout) clearTimeout(this.queueTimeout);
        this.processingQueue = true;
        let commandsToProcess = [
            ...this.queue
        ].filter((cmd)=>cmd.actionId === this.currentAction?.id);
        this.inProcessing = [
            ...new Set(commandsToProcess.map((cmd)=>cmd.actionId))
        ];
        this.queue = this.queue.filter((cmd)=>!commandsToProcess.includes(cmd));
        try {
            if ((0, $dh538.fg)('platform_editor_ai_aifc_background')) commandsToProcess = (0, $a561bee60676cdb0$export$c48ec1bf46060d54)(commandsToProcess);
            for (const commandToProcess of commandsToProcess){
                if (this.aborted.includes(commandToProcess.actionId)) {
                    // If we abort the last stream let's move onto the next stream
                    if (commandToProcess.type === 'endStream' && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) this.resolvePendingQueue(true);
                    continue;
                }
                await this.wrapInTimeout(this.commandToProcess(commandToProcess), commandToProcess);
            }
        } finally{
            // Reset the processing queue flag
            this.processingQueue = false;
            const lastCommand = commandsToProcess.pop();
            this.inProcessing = [];
            if (lastCommand?.type === 'endStream') this.checkAndResolveEmptyQueue();
        }
        // If commands have been added to the queue during async operations, process them now
        if (this.queue.filter((cmd)=>cmd.actionId === this.currentAction?.id).length > 0) this.processQueue();
        else if (this.queue.length > 0) this.queueTimeout = setTimeout(()=>{
            this.logger.logError(`Current stream queue timed out while starting next`, {
                actionId: this.currentAction?.id ?? undefined
            });
            this.resolvePendingQueue(true);
            this.processQueue();
        }, this.CURRENT_QUEUE_TIMEOUT);
    }
    onEmptyQueue() {
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
            const promise = new Promise((resolve)=>{
                this.onEmptyQueueResolve = resolve;
            });
            this.checkAndResolveEmptyQueue();
            return promise;
        } else {
            if (this.queue.length === 0) return Promise.resolve();
            return new Promise((resolve)=>{
                this.onEmptyQueueResolve = resolve;
            });
        }
    }
    async wrapInTimeout(promise, cmd) {
        const { promise: wrappedPromise, resetTimeout: resetTimeout } = (0, $d96f5329afc42f98$export$6c44330c7facd24b)(promise, {
            timeout: this.COMMAND_TIMEOUT,
            onTimeout: ()=>{
                this.logger.logError(`Stream command timed out ${cmd.type}`, {
                    actionId: cmd.actionId,
                    chunk: cmd.chunk
                });
            },
            onCleanup: ()=>{
                this.currentCommandTimeoutReset = null;
                if (cmd.type === 'endStream') this.checkAndResolveEmptyQueue();
                this.resolvePendingQueue();
            }
        });
        this.currentCommandTimeoutReset = resetTimeout;
        await wrappedPromise;
    }
    /**
   * End the AI experience
   */ endStreamCommand(actionId) {
        // duplicated endStreamCommand will kill accept reject screen prematurely
        if (this.endedActionIds.includes(actionId)) {
            this.logger.logPublic('End Stream Command Ignored', {
                actionId: actionId
            });
            return;
        }
        this.endedActionIds.push(actionId);
        if (this.endedActionIds.length > 10) this.endedActionIds.shift();
        this.logger.logPublic('End Stream Command', {
            actionId: actionId
        });
        // deprecated - Cleanup with platform_editor_ai_aifc_patch_ga
        this.hideLoadingScreen = false;
        if (this.aborted.includes(actionId) || this.isAborted) {
            this.updateAbortedCache([
                actionId
            ]);
            return;
        }
        // Actor not ready, queue the command
        this.queue.push({
            type: 'endStream',
            actionId: actionId,
            chunk: undefined,
            reason: 'endCurrentStream'
        });
        this.processQueue();
    }
    endExperience() {
        // if it's isFinalStream
        // - when auto accept AI changes is on, editor-plugin-ai will end itself
        // - when auto accept AI changes is off, the accept reject screen will be shown
        // if it's not isFinalStream, the endAIExperience is used to kill a previous AI modal
        // - which can be the previous accept reject screen
        // - or the command palette screen (followed by rovo free-gen screen)
        if (!this.isFinalStream) {
            this.logger.logQueueState('End AI Experience');
            this.api.aiExperience.actions.endAIExperience();
        }
        this.isFinalStream = false;
        // deprecated - Cleanup with platform_editor_ai_aifc_patch_ga
        this.hideLoadingScreen = false;
        this.adfStreamer?.reset();
        this.streamFlowPacer?.reset();
        this.subscription?.();
    }
    resolvePendingQueue(timeout = false) {
        if (timeout || this.isPendingResolveQueue) {
            const currentAction = this.queue.find((cmd)=>cmd.type === 'initStream') ?? null;
            this.logger.logQueueState('Resolve Pending Queue', {
                actionId: currentAction?.actionId,
                reason: timeout ? 'timeout' : 'isPendingResolveQueue'
            });
            this.currentAction = currentAction ? {
                id: currentAction.actionId,
                isCreateAction: (currentAction.command.type === 'appendNode' || currentAction.command.type === 'appendNodeToEnd') && currentAction.command.streamingType === 'create',
                initialNode: (0, $009cb14caceb5527$export$b7b4fc0a0195a016)(this.api, currentAction.command.type === 'replaceNode' && currentAction.command.localId),
                type: currentAction.command.type
            } : null;
            this.isPendingResolveQueue = false;
        }
    }
    checkAndResolveEmptyQueue() {
        if (this.queue.length === 0 && this.inProcessing.length === 0) this.onEmptyQueueResolve?.();
    }
    endNonStreamble() {
        if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) this.api.aiExperience.actions.dispatchAIEvent({
            type: 'complete',
            adfResponse: undefined
        });
        else {
            const { send: send } = this.api.aiExperience.actions.getAiExperienceActor();
            send({
                type: 'complete',
                markdown: '',
                adfResponse: undefined,
                cacheKey: '',
                modelInput: {}
            });
        }
    }
    async endExperiencePromise(command) {
        const { actionId: actionId, reason: reason } = command;
        this.logger.logQueueState('End Experience', {
            actionId: actionId,
            reason: reason
        });
        this.isPendingResolveQueue = reason === 'endCurrentStream';
        // should not check empty queue if the end command is triggered by the initStreamCommand
        // which is used to close a previous AI modal
        // because there are more commands to process even if the queue is empty
        // and this.isPendingResolveQueue will be reset, so use a different flag here
        const shouldCheckEmptyQueue = reason === 'endCurrentStream';
        const isStreamingCommand = !(this.currentAction?.type && !(0, $c127a9255266496a$export$f85aff2979b590a7)({
            type: this.currentAction?.type
        }));
        if (this.isStreaming && isStreamingCommand) {
            await this.processStreamCommandPromise(actionId, '', true);
            if (this.currentAction?.type === 'replaceNode') (0, $7b61ecd8bc5f3510$export$7535a054b27a27c4)({
                api: this.api,
                initialNode: this.currentAction.initialNode,
                lastDoc: this.adfStreamer?.getLastDoc()
            });
            (0, $7b61ecd8bc5f3510$export$276ecd5322451ab4)({
                api: this.api,
                command: this.currentCommand,
                docBeforeStreaming: this.docBeforeStreaming
            });
        } else if (!isStreamingCommand && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) this.isFinalStream = true;
        return new Promise((resolve)=>{
            const endNow = ()=>{
                this.endExperience();
                // After we end the experience there are a number of React re-renders that occur immediately after
                // This causes the state to flick between streaming and not streaming, it's not pretty
                // but wrap this in a `requestAnimationFrame` to delay our check until this clears.
                // To fix this properly we probably need to decouple the state with React
                const checkStreaming = ()=>{
                    const resolveAndEndStream = ()=>{
                        resolve();
                        this.logger.logQueueState('End Experience Resolved', {
                            actionId: actionId,
                            reason: reason
                        });
                        this.resolvePendingQueue();
                        shouldCheckEmptyQueue && this.checkAndResolveEmptyQueue();
                    };
                    if (!isStreamingCommand && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
                        this.endNonStreamble();
                        resolveAndEndStream();
                        return;
                    }
                    if (!this.api.aiExperience?.sharedState.currentState()?.isStreaming) {
                        resolveAndEndStream();
                        return;
                    }
                    const unsubscribe = this.api.aiExperience?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                        if (!nextSharedState.isStreaming) {
                            unsubscribe();
                            resolveAndEndStream();
                        }
                    });
                };
                setTimeout(checkStreaming, 0);
            };
            // If we're not running the pacer or its a non-streamable command, end immediately
            if (!this.streamFlowPacer?.isRunning() || this.currentAction?.type && !(0, $c127a9255266496a$export$f85aff2979b590a7)({
                type: this.currentAction?.type
            })) endNow();
            else this.streamFlowPacer.onComplete(()=>{
                // Need to be careful not to end the experience too soon. We need to give the xstate and react time to process
                // the final stream events before we kill the experience. Otherwise you will see an unfinished stream in the doc.
                setTimeout(endNow, 100);
            });
        });
    }
    /**
   * Streams the AI experience
   */ queueStreamCommand(actionId, chunk) {
        this.logger.logPublic('Stream Command', {
            actionId: actionId,
            chunk: chunk
        });
        if (this.aborted.includes(actionId) || this.isAborted) {
            this.updateAbortedCache([
                actionId
            ]);
            return;
        }
        // Actor not ready, queue the command
        this.queue.push({
            type: 'streamCommand',
            actionId: actionId,
            chunk: chunk
        });
        if (this.isActorReady()) this.processQueue();
        else {
            // if there are multiple sequential queueStreamCommand calls
            // and we assign the return value to this.subscription and call this.subscription
            // we won't be able to unsubscribe the corresponding right one
            // and will cause the callback to be called tons of times when state changes
            const unsubscribe = this.api?.aiExperience.sharedState.onChange(()=>{
                if (this.isActorReady()) {
                    unsubscribe?.();
                    this.processQueue();
                }
            });
        }
    }
    hasChangedDocument(latestDoc) {
        if (!this.previousValidDoc && latestDoc && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) return true;
        const nodesAreNotEqual = !this.previousValidDoc?.doc || !latestDoc?.doc || !(0, $2pjJ5.areNodesEqualIgnoreAttrs)(this.previousValidDoc?.doc, latestDoc.doc);
        if (this.streamFlowPacer === null) return Boolean(nodesAreNotEqual && latestDoc.doc && !(0, $2pjJ5.isEmptyDocument)(latestDoc.doc));
        const latestCount = this.streamFlowPacer?.adfTextLen(latestDoc?.adfDoc);
        return Boolean(nodesAreNotEqual && latestDoc.adfDoc && this.previousValidDoc?.adfDoc && latestCount.chars > 0 && // Ensure we only stream changes if the stream flow pacer detects semantic changes
        !this.streamFlowPacer?.adfTextLen(this.previousValidDoc?.adfDoc).gte(latestCount));
    }
    createCallback(usePush) {
        if (usePush) return (evt)=>{
            const fullEvent = (0, $1xicG.normaliseAIExperienceEvent)(evt);
            this?.streamFlowPacer?.push(fullEvent);
        };
        if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) return (evt)=>{
            this.api.aiExperience.actions.dispatchAIEvent(evt);
        };
        // Legacy path: send to actor with padded defaults
        const { send: send } = this.api.aiExperience.actions.getAiExperienceActor();
        return (evt)=>{
            const payload = (0, $1xicG.normaliseAIExperienceEvent)(evt);
            send(payload);
        };
    }
    processStreamCommand(actionId, chunk, finalStream = false) {
        if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) this.streamFlowPacer?.setEmit((evt)=>{
            // While the stream flow pacer is doing work reset the timeout
            this.currentCommandTimeoutReset?.();
            this.api.aiExperience.actions.dispatchAIEvent(evt);
        });
        else {
            const { send: send } = this.api.aiExperience.actions.getAiExperienceActor();
            this.streamFlowPacer?.setEmit((evt)=>{
                // While the stream flow pacer is doing work reset the timeout
                this.currentCommandTimeoutReset?.();
                send(evt);
            });
        }
        const callback = this.createCallback(!!this.streamFlowPacer?.push);
        // Initialize streamer if needed
        if (!this.adfStreamer) {
            const schema = this.api.core.sharedState.currentState()?.schema;
            this.adfStreamer = schema ? new (0, $4pSml.ADFStreamer)(schema, (0, $7b61ecd8bc5f3510$export$6dcba6b9d3966cf9)({
                api: this.api,
                isCreateAction: this.currentAction?.isCreateAction ?? false,
                traceId: (0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events') ? this.traceId : undefined
            })) : undefined;
        }
        if (finalStream) {
            const adfResponseBefore = (0, $adc2c60cd4921249$export$7b6c9d9d26e2f428)(this.api, this.adfStreamer?.getLastDoc(), this.currentAction?.type).adfDoc;
            const schema = this.api.core.sharedState.currentState()?.schema;
            const { updatedResponse: updatedResponse, localId: localId } = (0, $76ccf77dd7d8e539$export$ab173b3d1046c711)(adfResponseBefore, this.currentAction?.type, schema);
            const adfResponse = (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga') ? updatedResponse : adfResponseBefore;
            this.insertAfterQueueLocalId = localId;
            this.adfStreamer?.endStreamingSession({
                hasProcessedFinalResponse: true
            });
            this.logger.logQueueState('Final Stream', {
                actionId: actionId,
                adf: adfResponse,
                finalStream: true
            });
            callback({
                type: 'complete',
                adfResponse: adfResponse
            });
            return true;
        }
        if (this.currentAction?.isCreateAction || (0, $dh538.fg)('platform_editor_ai_aifc_adf_parser_on_update')) // Resetting because we are going to get full ADF as chunk
        this.adfStreamer?.reset();
        this.adfStreamer?.processChunk(chunk);
        const latestDoc = (0, $adc2c60cd4921249$export$7b6c9d9d26e2f428)(this.api, this.adfStreamer?.getLastDocWithoutLastLeafNode(), this.currentAction?.type);
        const changed = this.hasChangedDocument(latestDoc);
        this.previousValidDoc = latestDoc;
        // We compare the before/after docs because if nothing has changed then it will not trigger a react update (because the adfResponse needs to be different)
        // which means the chunkNumber will never update and the processStreamCommandPromise Promise will never resolve.
        // This cause the wrapInTimeout 1sec delay to occur before the next chunk is processed. This means we can end up in a situation
        // where we're recieving a lot of chunks, but nothing in the view is changed and everything starts taking a lot of time
        // because of the sequential 1sec failovers.
        if (changed) {
            callback({
                type: 'stream',
                adfResponse: latestDoc.adfDoc
            });
            return true;
        }
        return false;
    }
    processStreamCommandPromise(actionId, chunk, finalStream = false) {
        this.logger.logQueueState('Streaming Command', {
            actionId: actionId,
            chunk: chunk,
            finalStream: finalStream
        });
        this.isStreaming = !finalStream;
        this.isFinalStream = finalStream;
        return new Promise((resolve)=>{
            // remove go when cleanup platform_editor_ai_aifc_background, just make the logic inline
            const go = ()=>{
                const chunkBefore = this.api.aiExperience?.sharedState.currentState()?.chunkNumber;
                if (!this.processStreamCommand(actionId, chunk, finalStream)) {
                    // If nothing was processed then we should be able to end immediately since we will never get a chuckNumber update
                    // this means the next chunk can be processed straight away.
                    resolve();
                    this.logger.logQueueState('Streaming Command Resolved', {
                        actionId: actionId,
                        chunk: chunk,
                        finalStream: finalStream
                    });
                    return;
                }
                if (chunkBefore !== this.api.aiExperience?.sharedState.currentState()?.chunkNumber) {
                    resolve();
                    this.logger.logQueueState('Streaming Command Resolved', {
                        actionId: actionId,
                        chunk: chunk,
                        finalStream: finalStream
                    });
                    return;
                }
                // if there are multiple sequential queueStreamCommand calls and one of them timeout
                // and we assign the return value to this.subscription and call this.subscription
                // we won't be able to unsubscribe the corresponding right one
                // and will cause the callback to be called tons of times when state changes
                const unsubscribe = this.api.aiExperience?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                    if (nextSharedState?.chunkNumber !== prevSharedState?.chunkNumber) {
                        unsubscribe?.();
                        resolve();
                        this.logger.logQueueState('Streaming Command Resolved', {
                            actionId: actionId,
                            chunk: chunk,
                            finalStream: finalStream
                        });
                    }
                });
            };
            if ((0, $dh538.fg)('platform_editor_ai_aifc_background')) go();
            else setTimeout(()=>go(), 0);
        });
    }
    /**
   * Streams the AI experience
   */ initStreamCommand(actionId, command, options) {
        this.logger.logPublic('Init Command', {
            actionId: actionId,
            command: command
        });
        this.isAborted = false;
        // deprecated - Cleanup with platform_editor_ai_aifc_patch_ga
        this.hideLoadingScreen = options?.hideLoadingScreen ?? false;
        if (!this.currentAction) this.currentAction = {
            id: actionId,
            isCreateAction: (command.type === 'appendNode' || command.type === 'appendNodeToEnd') && command.streamingType === 'create',
            initialNode: (0, $009cb14caceb5527$export$b7b4fc0a0195a016)(this.api, command.type === 'replaceNode' && command.localId),
            type: command.type
        };
        // If we're already running end the stream and restart
        if (this.api.aiExperience.sharedState.currentState()?.aiDecorationExperiencePluginState.isRunning) this.queue.push({
            type: 'endStream',
            actionId: actionId,
            chunk: undefined,
            reason: 'endPreviousStream'
        });
        this.queue.push({
            type: 'initStream',
            actionId: actionId,
            chunk: undefined,
            command: command,
            options: options
        });
        this.processQueue();
    }
    applyCommand(command) {
        const insertAfterQueue = this.currentCommand?.type === 'insertNodeAfter' && command.type === 'insertNodeAfter' && command.localId === this.currentCommand?.localId;
        this.currentCommand = command;
        this.docBeforeStreaming = (0, $839bfdacc8d0b035$export$6bf900bab6a4720d)(this.api);
        let isSuccessful = true;
        // If we have subsequent "insertAfter" commands with the same localId, instead point to the end of the
        // previous insertion. This is because the AI will "insertAfter" in a logical order, but that puts the content
        // into the document backwards.
        if (insertAfterQueue && this.insertAfterQueueLocalId && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) // If for some reason the localId doesn't exist in the document fallback to the original stream command
        try {
            isSuccessful = this.streamingCommands[command.type]({
                ...command,
                localId: this.insertAfterQueueLocalId
            });
        } catch  {
            isSuccessful = this.streamingCommands[command.type](command);
        }
        else isSuccessful = this.streamingCommands[command.type](command);
        return isSuccessful;
    }
    initStream(command, options) {
        const applied = this.applyCommand(command);
        // If we couldn't apply the command (ie. broken localId) add it to the abort cache so we don't apply anymore commands
        if (!applied && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
            // Never start the stream and resolve immediately
            if (this.currentAction?.id) this.updateAbortedCache([
                this.currentAction?.id
            ]);
            return true;
        }
        this.streamFlowPacer?.reset();
        this.adfStreamer?.reset();
        // We have to set an empty callback before starting otherwise the flow pacer wont start. We need to cleanup the flow pacer
        // and make it more generic.
        this.streamFlowPacer?.setEmit(()=>{});
        this.streamFlowPacer?.start();
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) {
            const isCreate = (command.type === 'appendNode' || command.type === 'appendNodeToEnd') && command.streamingType === 'create';
            this.logger.logQueueState('Open AI Modal', {
                command: command
            });
            this.api.aiExperience.actions.openAIModal({
                invokedFrom: 'streamingApi',
                configItem: (0, $9Tkc6.UNSTABLE_configItems).freeGenerateAifcConfigItem,
                withStreamingHighlight: !isCreate,
                // don't show accept reject screen for staging first-time creation streaming
                withAcceptReject: !isCreate,
                hideLoadingScreen: ((0, $dh538.fg)('platform_editor_tmp_hide_loader') && options?.hideLoadingScreen) ?? false,
                traceId: this.traceId
            });
            if (!(0, $c127a9255266496a$export$f85aff2979b590a7)(command)) (0, $7b61ecd8bc5f3510$export$276ecd5322451ab4)({
                api: this.api,
                command: this.currentCommand,
                docBeforeStreaming: this.docBeforeStreaming
            });
            return false;
        } else if ((0, $c127a9255266496a$export$f85aff2979b590a7)(command)) {
            const isCreate = (command.type === 'appendNode' || command.type === 'appendNodeToEnd') && command.streamingType === 'create';
            this.logger.logQueueState('Open AI Modal', {
                command: command
            });
            this.api.aiExperience.actions.openAIModal({
                invokedFrom: 'streamingApi',
                configItem: (0, $9Tkc6.UNSTABLE_configItems).freeGenerateAifcConfigItem,
                withStreamingHighlight: !isCreate,
                // don't show accept reject screen for staging first-time creation streaming
                withAcceptReject: !isCreate,
                hideLoadingScreen: (0, $dh538.fg)('platform_editor_tmp_hide_loader') && this.hideLoadingScreen
            });
            return false;
        } else {
            (0, $7b61ecd8bc5f3510$export$276ecd5322451ab4)({
                api: this.api,
                command: this.currentCommand,
                docBeforeStreaming: this.docBeforeStreaming
            });
            return true;
        }
    }
    async initStreamPromise(command, options) {
        await new Promise((resolve)=>{
            this.logger.logQueueState(`Init Command ${command.type}`, {
                command: command
            });
            if (this.initStream(command, options)) {
                resolve();
                this.logger.logQueueState(`Init Command Resolved ${command.type}`, {
                    command: command
                });
                return;
            }
            const unsubscribe = this.api.aiExperience?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                if (nextSharedState.aiDecorationExperiencePluginState.isRunning) {
                    unsubscribe?.();
                    resolve();
                    this.logger.logQueueState(`Init Command Resolved ${command.type}`, {
                        command: command
                    });
                }
            });
        });
    }
    startSession(sessionId, traceId) {
        if ((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events')) {
            this.traceId = traceId;
            (0, $7b61ecd8bc5f3510$export$4b84cbb6abceadd2)({
                api: this.api,
                sessionId: sessionId,
                traceId: traceId
            });
        }
        this.logger.logPublic('Start Session', {
            sessionId: sessionId
        });
    }
    queueEndSession(sessionId) {
        this.logger.logPublic('Queue End Session', {
            sessionId: sessionId
        });
    }
    endSession(sessionId) {
        if ((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events')) this.traceId = undefined;
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) this.currentCommand = undefined;
        this.logger.logPublic('End Session', {
            sessionId: sessionId
        });
    }
    destroy() {
        this.queue = [];
        this.adfStreamer = undefined;
        this.currentCommand = undefined;
        this.docBeforeStreaming = undefined;
        if ((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events')) this.traceId = undefined;
    }
    /**
   * Abort the current streaming and end the experience
   * This is a hard abort and will clear the queue
   * This will only restart the experience when initStreamCommand is called again
   */ abort() {
        this.logger.logPublic('Abort');
        const currentQueue = this.queue.map((cmd)=>cmd.actionId);
        this.queue = [];
        // Add new aborted action IDs to end of array
        this.updateAbortedCache([
            ...new Set(currentQueue),
            ...this.inProcessing
        ]);
        this.isAborted = true;
        this.endExperience();
        this.isPendingResolveQueue = false;
        if (this.queueTimeout) clearTimeout(this.queueTimeout);
        this.currentAction = null;
        this.isFinalStream = false;
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) this.currentCommand = undefined;
        if ((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events')) this.traceId = undefined;
    }
    updateAbortedCache(actionIds) {
        this.aborted = [
            ...new Set([
                ...this.aborted,
                ...actionIds
            ])
        ];
        const maxAbortedCacheLength = 5;
        if (this.aborted.length > maxAbortedCacheLength) this.aborted = this.aborted.slice(-maxAbortedCacheLength);
    }
    constructor(api, streamFlowPacer = null){
        this.api = api;
        this.streamFlowPacer = streamFlowPacer;
        this.queue = [];
        this.adfStreamer = void 0;
        this.streamingCommands = void 0;
        this.currentCommand = undefined;
        this.docBeforeStreaming = undefined;
        this.isStreaming = false;
        this.isFinalStream = false;
        this.aborted = [];
        this.subscription = null;
        this.previousValidDoc = null;
        this.logger = void 0;
        this.endedActionIds = [];
        this.currentAction = null;
        // deprecated - Cleanup with platform_editor_ai_aifc_patch_ga
        this.hideLoadingScreen = false;
        this.insertAfterQueueLocalId = undefined;
        /**
     * The traceId received in response header from AI api call
     * This is used to trace the AI experience through the backend to frontend.
     */ this.traceId = undefined;
        this.processingQueue = false;
        this.inProcessing = [];
        this.queueTimeout = null;
        // This is only used *if* we have started receiving values with a different
        // action id (new stream) and we have nothing left in the current stream (ie. it hasn't finished)
        // Really this shouldn't be hit since this would only happen on the edge when we're wrapping up the old stream
        // and starting the next early
        this.CURRENT_QUEUE_TIMEOUT = 5000;
        this.currentCommandTimeoutReset = null;
        this.onEmptyQueueResolve = null;
        // 2 seconds - this is the maximum time to process a command before we abort it and continue
        // This can be longer if for example if a lot of commands have been processed, but the stream flow
        // pacer has a backlog (particularly for elements with lots of attributes / marks etc) and hasn't had
        // a chance to emit yet
        this.COMMAND_TIMEOUT = 2000;
        this.isPendingResolveQueue = false;
        this.isAborted = false;
        this.logger = new (0, $127e6d5334706012$export$21e6cc849c1dc1ab)(api);
        this.streamingCommands = (0, $748219bd4f4f1029$export$a0774277976bc21f)(api);
    }
}


const $15f96a0d1cd67d4c$export$4010adcbb216eb38 = ({ api: api, config: config })=>{
    if (!api) throw new Error('api is not defined');
    let streamQueue;
    // Only allow one session to be active at a time
    let sessionId = null;
    // Tracking variables for debugging session lifecycle issues
    let hasSessionBeenStarted = false;
    let isEndingSession = false;
    let lastEndedSessionId = null;
    let endSessionCallCount = 0;
    let sessionAborted = false;
    const streamFlowPacer = (0, $19e1d609df7dfc8f$export$9ea8217d5ec56f82)(config?.streamFlowPacerEnabled);
    return {
        name: 'aiStreamingOrchestrator',
        actions: {
            startSession: (traceId)=>{
                sessionId = (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? crypto.randomUUID() ?? (0, $fO7hX.uuid).generate() : crypto.randomUUID();
                hasSessionBeenStarted = true;
                sessionAborted = false;
                streamQueue = new (0, $4c93be51fe49a367$export$f3feb8728b17a0a9)(api, streamFlowPacer);
                if ((0, $dh538.fg)('platform_editor_ai_traceid_in_analytics_events')) {
                    streamQueue.startSession(sessionId, traceId);
                    api.aiExperience.actions.startSession(sessionId, traceId);
                } else {
                    streamQueue.startSession(sessionId);
                    api.aiExperience.actions.startSession(sessionId);
                }
                return sessionId;
            },
            endSession: async (error)=>{
                // In the session abort we end the session and no longer need to run this
                // On a new session we reset the state so this is safe to ignore
                if (sessionAborted && (0, $dh538.fg)('platform_editor_ai_aifc_avoid_session_error')) return;
                if (sessionId === null) {
                    if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) {
                        (0, $7b61ecd8bc5f3510$export$8b7d4483ec260574)({
                            api: api,
                            sessionStarted: hasSessionBeenStarted,
                            endSessionCallCount: endSessionCallCount,
                            lastEndedSessionId: lastEndedSessionId,
                            isDoubleCall: isEndingSession
                        });
                        throw new Error(`endSession requires a session to be started first!`);
                    } else throw new Error(`endSession requires a session to be started first!`);
                }
                endSessionCallCount++;
                isEndingSession = true;
                const currentSessionId = sessionId;
                try {
                    streamQueue?.queueEndSession(currentSessionId);
                    if (error) {
                        if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) api.aiExperience.actions.dispatchAIEvent({
                            type: 'error',
                            errorInfo: {
                                failureReason: error.failureReason,
                                statusCode: error.statusCode
                            }
                        });
                        else {
                            const { send: send } = api.aiExperience.actions.getAiExperienceActor();
                            send({
                                type: 'error',
                                errorInfo: {
                                    failureReason: error.failureReason,
                                    statusCode: error.statusCode
                                }
                            });
                        }
                    }
                    // Since `endSession` is going to be called after all the actions are invoked
                    // so we can basically wait for the queue to be empty
                    await streamQueue?.onEmptyQueue();
                    streamQueue?.endSession(currentSessionId);
                    // https://atlassian.slack.com/archives/C0962DYFLRL/p1759397599541949?thread_ts=1759366160.706849&cid=C0962DYFLRL
                    // streamQueue?.destroy();
                    api.aiExperience.actions.endSession(currentSessionId);
                    hasSessionBeenStarted = false;
                    lastEndedSessionId = currentSessionId;
                    sessionId = null;
                } finally{
                    isEndingSession = false;
                }
            },
            abortSession: ()=>{
                // abortSession can be called multiple times from multiple command handlers
                if (!sessionId) return;
                const sessionToEnd = sessionId;
                lastEndedSessionId = sessionToEnd;
                sessionId = null;
                streamQueue?.abort();
                if (sessionToEnd) {
                    api.aiExperience.actions.endSession(sessionToEnd);
                    sessionAborted = true;
                }
            },
            initAction: (command, options)=>{
                if (sessionId === null) throw new Error('initAction requires a session to be started first!');
                const actionId = crypto.randomUUID();
                streamQueue?.initStreamCommand(actionId, command, options);
                return actionId;
            },
            // We are sending the full document as a chunk for create actions
            streamValue: (actionId, chunk)=>{
                // Use the queue manager to handle streaming
                // This will either process immediately if actor is ready, or queue for later
                streamQueue?.queueStreamCommand(actionId, chunk);
            },
            finishAction: (actionId, error)=>{
                if (error) {
                    if ((0, $dh538.fg)('platform_editor_ai_migrate_from_xstate')) api.aiExperience.actions.dispatchAIEvent({
                        type: 'error',
                        errorInfo: {
                            failureReason: error.failureReason,
                            statusCode: error.statusCode
                        }
                    });
                    else {
                        const { send: send } = api.aiExperience.actions.getAiExperienceActor();
                        send({
                            type: 'error',
                            errorInfo: {
                                failureReason: error.failureReason,
                                statusCode: error.statusCode
                            }
                        });
                    }
                }
                streamQueue?.endStreamCommand(actionId);
            }
        },
        usePluginHook: ()=>{
            (0, $42omo.useEffect)(()=>{
                return ()=>{
                    streamQueue?.destroy();
                };
            }, []);
        }
    };
};
module.exports["aiStreamingOrchestratorPlugin"] = $15f96a0d1cd67d4c$export$4010adcbb216eb38;

});

parcelRegister("delmI", function(module, exports) {

var $iyDxB = parcelRequire("iyDxB");


var $5SAOw = parcelRequire("5SAOw");

const $b3d6bafd8af48f38$var$domParser = (0, $5SAOw.DOMParser).fromSchema((0, $iyDxB.defaultSchema));
const $b3d6bafd8af48f38$export$61f8df97ec7cf3 = ()=>{
    const KEYWORDS = [
        'inline',
        'block',
        'text',
        'leaf',
        'group',
        'unsupportedBlock',
        'unsupportedInline'
    ];
    const rules = {};
    for (const nodeType of Object.keys((0, $iyDxB.defaultSchema).nodes)){
        const contentStr = (0, $iyDxB.defaultSchema).nodes[nodeType]?.spec.content;
        if (!contentStr) continue;
        const allowedChildren = (String(contentStr).match(/\b([a-zA-Z_][a-zA-Z0-9_]*)\b/g) || []).filter((match, index, arr)=>!KEYWORDS.includes(match) && (0, $iyDxB.defaultSchema).nodes[match] && arr.indexOf(match) === index);
        if (allowedChildren.length > 0) rules[nodeType] = allowedChildren;
    }
    return rules;
};
const $b3d6bafd8af48f38$var$NESTING_RULES = $b3d6bafd8af48f38$export$61f8df97ec7cf3();
const $b3d6bafd8af48f38$var$canContainChildren = (nodeType)=>!!$b3d6bafd8af48f38$var$NESTING_RULES[nodeType]?.length;
const $b3d6bafd8af48f38$var$isAllowedChild = (parent, child)=>$b3d6bafd8af48f38$var$NESTING_RULES[parent]?.includes(child) ?? false;
const $b3d6bafd8af48f38$var$shouldApplyMark = (tag)=>$b3d6bafd8af48f38$var$domParser.rules.some((rule)=>'mark' in rule && rule.tag === tag);
const $b3d6bafd8af48f38$var$isBlockElement = (tag)=>$b3d6bafd8af48f38$var$domParser.rules.some((rule)=>rule.tag === tag && rule.node);
const $b3d6bafd8af48f38$var$getMarkTypes = (tags)=>{
    const seen = new Set();
    const marks = [];
    for (const tag of tags){
        const markType = $b3d6bafd8af48f38$var$domParser.rules.find((rule)=>rule.tag === tag)?.mark;
        if (markType && !seen.has(markType)) {
            marks.push({
                type: markType
            });
            seen.add(markType);
        }
    }
    return marks;
};
const $b3d6bafd8af48f38$var$createParagraph = (content = [])=>({
        type: 'paragraph',
        content: content
    });
const $b3d6bafd8af48f38$var$getBlockType = (tag)=>{
    const rule = $b3d6bafd8af48f38$var$domParser.rules.find((r)=>r.tag === tag);
    return rule && 'node' in rule && rule.node ? rule.node : 'paragraph';
};
const $b3d6bafd8af48f38$var$createTextNode = (text, marks)=>{
    const markTypes = $b3d6bafd8af48f38$var$getMarkTypes(marks);
    return {
        type: 'text',
        text: text,
        ...markTypes.length > 0 && {
            marks: markTypes
        }
    };
};
const $b3d6bafd8af48f38$var$addText = (text, marks, content)=>{
    if (text) content.push($b3d6bafd8af48f38$var$createTextNode(text, marks));
};
const $b3d6bafd8af48f38$var$handleBlockElement = (tag, innerContent, marks, blocks, currentParagraphContent, parseNode, nestedContainer)=>{
    // Push any accumulated content as paragraph before block element
    if (currentParagraphContent.length > 0) {
        blocks.push($b3d6bafd8af48f38$var$createParagraph([
            ...currentParagraphContent
        ]));
        currentParagraphContent.length = 0;
    }
    const blockType = $b3d6bafd8af48f38$var$getBlockType(tag);
    const newMarks = $b3d6bafd8af48f38$var$shouldApplyMark(tag) ? [
        ...marks,
        tag
    ] : marks;
    const parentNodeType = nestedContainer?.parentType;
    if (nestedContainer && parentNodeType && $b3d6bafd8af48f38$var$isAllowedChild(parentNodeType, blockType)) {
        const elementContent = [];
        const childNestedContainer = $b3d6bafd8af48f38$var$canContainChildren(blockType) ? {
            parentType: blockType,
            children: elementContent
        } : nestedContainer;
        parseNode(innerContent, newMarks, childNestedContainer);
        if (currentParagraphContent.length > 0) {
            elementContent.push($b3d6bafd8af48f38$var$createParagraph([
                ...currentParagraphContent
            ]));
            currentParagraphContent.length = 0;
        }
        nestedContainer.children.push({
            type: blockType,
            content: elementContent.length > 0 ? elementContent : [
                $b3d6bafd8af48f38$var$createParagraph()
            ]
        });
    } else if ($b3d6bafd8af48f38$var$canContainChildren(blockType)) {
        const children = [];
        parseNode(innerContent, newMarks, {
            parentType: blockType,
            children: children
        });
        blocks.push({
            type: blockType,
            content: children.length > 0 ? children : [
                $b3d6bafd8af48f38$var$createParagraph()
            ]
        });
    } else {
        // Regular block elements
        parseNode(innerContent, newMarks, nestedContainer);
        // Push content generated from block parsing
        if (currentParagraphContent.length > 0) {
            if (blockType === 'paragraph' || blockType === 'codeBlock') blocks.push({
                type: blockType,
                content: [
                    ...currentParagraphContent
                ]
            });
            currentParagraphContent.length = 0;
        }
    }
};
const $b3d6bafd8af48f38$var$handleInlineElement = (tag, innerContent, marks, parseNode, nestedContainer)=>{
    const newMarks = $b3d6bafd8af48f38$var$shouldApplyMark(tag) ? [
        ...marks,
        tag
    ] : marks;
    parseNode(innerContent, newMarks, nestedContainer);
};
const $b3d6bafd8af48f38$export$803b79985c54270a = (html)=>{
    const blocks = [];
    const currentParagraphContent = [];
    // Simple regex-based parser that works in both SSR and browser
    const parseNode = (content, marks = [], nestedContainer)=>{
        // Match HTML tags and text content
        // eslint-disable-next-line require-unicode-regexp
        const tagRegex = /<\s*(\w+)([^>]*)>([\s\S]*?)<\s*\/\s*\1\s*>|([^<]+)/g;
        let match = tagRegex.exec(content);
        while(match !== null){
            if (match[4]) $b3d6bafd8af48f38$var$addText(match[4], marks, currentParagraphContent);
            else {
                // HTML element
                const tag = match[1].toLowerCase();
                const innerContent = match[3];
                if ($b3d6bafd8af48f38$var$isBlockElement(tag)) $b3d6bafd8af48f38$var$handleBlockElement(tag, innerContent, marks, blocks, currentParagraphContent, parseNode, nestedContainer);
                else $b3d6bafd8af48f38$var$handleInlineElement(tag, innerContent, marks, parseNode, nestedContainer);
            }
            match = tagRegex.exec(content);
        }
    };
    parseNode(html);
    // Push any remaining content
    if (currentParagraphContent.length > 0) blocks.push($b3d6bafd8af48f38$var$createParagraph(currentParagraphContent));
    return {
        type: 'doc',
        version: 1,
        content: blocks.length > 0 ? blocks : [
            $b3d6bafd8af48f38$var$createParagraph()
        ]
    };
};


const $6f1c9f8313f13d49$export$2cf68c3f3d00fa30 = (html)=>{
    return (0, $b3d6bafd8af48f38$export$803b79985c54270a)(html);
};
module.exports["createADFFromHTML"] = $6f1c9f8313f13d49$export$2cf68c3f3d00fa30;

});


//# sourceMappingURL=FullPageEditorComponent.a3154c66.js.map
